import './index.css';var nu = Object.defineProperty;
var ru = (t, e, n) => e in t ? nu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Bi = (t, e, n) => ru(t, typeof e != "symbol" ? e + "" : e, n);
import { jsxs as _, jsx as p, Fragment as Wn } from "react/jsx-runtime";
import { useTheme as ut, Select as ou, MenuItem as Ut, Divider as Et, Typography as it, CardActionArea as fn, alpha as pn, ListItemIcon as pa, ListItemText as Yo, Paper as er, Stack as He, createSvgIcon as Cn, SvgIcon as Sn, Tooltip as iu, IconButton as ma, Popover as xn, InputBase as su, Box as ve, Menu as au, Dialog as ha, DialogTitle as ga, DialogContent as ya, DialogActions as ba, Button as St, FormGroup as lu, TextField as cu, ButtonGroup as va, Switch as uu, Tabs as du, Tab as fu } from "@mui/material";
import { NodeViewWrapper as wa, NodeViewContent as pu, Extension as Ca, ReactNodeViewRenderer as Sa, ReactRenderer as mu, useCurrentEditor as hu, isTextSelection as gu, BubbleMenu as xa, posToDOMRect as yu, findParentNodeClosestToPos as bu, useEditor as vu, EditorContext as wu, EditorContent as Cu } from "@tiptap/react";
import Ce from "clsx";
import * as et from "react";
import Su, { useEffect as Je, useRef as Ur, useMemo as mn, createContext as Ta, useContext as ka, forwardRef as Aa, createElement as xu, useCallback as Ea, useState as ke, useImperativeHandle as Oa } from "react";
import { initReactI18next as $a, useTranslation as ee, I18nextProvider as Tu } from "react-i18next";
import ku from "react-virtualized-auto-sizer";
import { CodeBlockLowlight as Au } from "@tiptap/extension-code-block-lowlight";
import Eu from "@tiptap/extension-focus";
import { Plugin as bt, PluginKey as Kt, Selection as an, TextSelection as st, AllSelection as Ou, NodeSelection as Ra } from "@tiptap/pm/state";
import { DecorationSet as Ia, Decoration as Ma } from "@tiptap/pm/view";
import { Fragment as ln, Slice as $u, Node as Ru, Schema as Iu, DOMParser as uo } from "@tiptap/pm/model";
import Mu from "@tiptap/extension-list-keymap";
import { Placeholder as Pu } from "@tiptap/extension-placeholder";
import Nu from "@tiptap/extension-subscript";
import Lu from "@tiptap/extension-superscript";
import Du from "@tiptap/extension-table-row";
import Fu from "@tiptap/extension-task-item";
import Bu from "@tiptap/extension-task-list";
import _u from "@tiptap/extension-text-align";
import _i from "@tiptap/extension-text-style";
import { Underline as zu } from "@tiptap/extension-underline";
import { Youtube as Vu } from "@tiptap/extension-youtube";
import ju from "@tiptap/starter-kit";
import { createLowlight as Hu, common as Uu } from "lowlight";
import Vt from "i18next";
import zi from "highlight.js";
import { Color as Wu } from "@tiptap/extension-color";
import { orderBy as qu, chain as Ku, times as Yu, max as Gu } from "lodash";
import { CheckRounded as Pa, GridOnRounded as Na, FormatSizeRounded as Wr, FormatListBulletedRounded as La, FormatListNumberedRounded as Da, ChecklistRounded as Fa, CodeRounded as Go, FormatQuoteRounded as Ju, FormatBoldRounded as Jo, FormatItalicRounded as Zo, FormatUnderlinedRounded as Xo, FormatStrikethroughRounded as Ba, SubscriptRounded as _a, SuperscriptRounded as za, HorizontalRuleRounded as Va, PhotoRounded as Zu, OndemandVideoRounded as Xu, FormatClearRounded as Qo, DeleteRounded as ei, CheckCircleRounded as Qu, LinkRounded as ed, OpenInNewRounded as td, FormatColorTextRounded as nd, CloseRounded as rd, UndoRounded as od, RedoRounded as id, ImageRounded as sd, SubscriptionsRounded as ad, KeyboardCommandKeyRounded as ld, AddRounded as ja, FormatIndentDecreaseRounded as cd, FormatIndentIncreaseRounded as ud, FormatAlignLeftRounded as dd, FormatAlignCenterRounded as fd, FormatAlignRightRounded as pd, FormatAlignJustifyRounded as md, KeyboardArrowDownRounded as Ha, RemoveRounded as hd, TableRowsOutlined as gd, ViewWeekOutlined as yd, HorizontalSplitRounded as bd, VerticalSplitRounded as vd, IntegrationInstructionsRounded as wd, ViewSidebarRounded as Cd, StartRounded as Sd } from "@mui/icons-material";
import xd from "@tiptap/extension-highlight";
import Td from "@tiptap/extension-link";
import { Image as kd } from "@tiptap/extension-image";
import { ThemeContext as Ad, __unsafe_useEmotionCache as Ed } from "@emotion/react";
import Od from "@tiptap/suggestion";
import $d from "@tiptap/extension-table-cell";
import Rd from "@tiptap/extension-table";
import { selectedRect as Nn, addRow as Id, addColumn as Md, removeRow as Pd, removeColumn as Nd, columnResizing as Ld, tableEditing as Dd, tableNodeTypes as Fd } from "prosemirror-tables";
import Bd from "@tiptap/extension-table-header";
import _d from "@uppy/core";
import zd from "@uppy/dropbox";
import Vd from "@uppy/google-drive";
import jd from "@uppy/onedrive";
import Hd from "@uppy/screen-capture";
import Ud, { COMPANION_URL as gr, COMPANION_ALLOWED_HOSTS as fo } from "@uppy/transloadit";
import Wd from "@uppy/url";
import qd from "@uppy/webcam";
import Kd from "@emotion/styled";
import { Dashboard as Yd } from "@uppy/react";
import { AnimatePresence as ti, motion as ni } from "framer-motion";
function Ua(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let o = t.child(r), i = e.child(r);
    if (o == i) {
      n += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(i))
      return n;
    if (o.isText && o.text != i.text) {
      for (let s = 0; o.text[s] == i.text[s]; s++)
        n++;
      return n;
    }
    if (o.content.size || i.content.size) {
      let s = Ua(o.content, i.content, n + 1);
      if (s != null)
        return s;
    }
    n += o.nodeSize;
  }
}
function Wa(t, e, n, r) {
  for (let o = t.childCount, i = e.childCount; ; ) {
    if (o == 0 || i == 0)
      return o == i ? null : { a: n, b: r };
    let s = t.child(--o), a = e.child(--i), l = s.nodeSize;
    if (s == a) {
      n -= l, r -= l;
      continue;
    }
    if (!s.sameMarkup(a))
      return { a: n, b: r };
    if (s.isText && s.text != a.text) {
      let c = 0, u = Math.min(s.text.length, a.text.length);
      for (; c < u && s.text[s.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (s.content.size || a.content.size) {
      let c = Wa(s.content, a.content, n - 1, r - 1);
      if (c)
        return c;
    }
    n -= l, r -= l;
  }
}
class j {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, o = 0, i) {
    for (let s = 0, a = 0; a < n; s++) {
      let l = this.content[s], c = a + l.nodeSize;
      if (c > e && r(l, o + a, i || null, s) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, n - u), r, o + u);
      }
      a = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, o) {
    let i = "", s = !0;
    return this.nodesBetween(e, n, (a, l) => {
      let c = a.isText ? a.text.slice(Math.max(e, l) - l, n - l) : a.isLeaf ? o ? typeof o == "function" ? o(a) : o : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && c || a.isTextblock) && r && (s ? s = !1 : i += r), i += c;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, o = this.content.slice(), i = 0;
    for (n.isText && n.sameMarkup(r) && (o[o.length - 1] = n.withText(n.text + r.text), i = 1); i < e.content.length; i++)
      o.push(e.content[i]);
    return new j(o, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], o = 0;
    if (n > e)
      for (let i = 0, s = 0; s < n; i++) {
        let a = this.content[i], l = s + a.nodeSize;
        l > e && ((s < e || l > n) && (a.isText ? a = a.cut(Math.max(0, e - s), Math.min(a.text.length, n - s)) : a = a.cut(Math.max(0, e - s - 1), Math.min(a.content.size, n - s - 1))), r.push(a), o += a.nodeSize), s = l;
      }
    return new j(r, o);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? j.empty : e == 0 && n == this.content.length ? this : new j(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let o = this.content.slice(), i = this.size + n.nodeSize - r.nodeSize;
    return o[e] = n, new j(o, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new j([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new j(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let o = this.content[n];
      e(o, r, n), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return Ua(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return Wa(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, n = -1) {
    if (e == 0)
      return yr(0, e);
    if (e == this.size)
      return yr(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, o = 0; ; r++) {
      let i = this.child(r), s = o + i.nodeSize;
      if (s >= e)
        return s == e || n > 0 ? yr(r + 1, s) : yr(r, o);
      o = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return j.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new j(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return j.empty;
    let n, r = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      r += i.nodeSize, o && i.isText && e[o - 1].sameMarkup(i) ? (n || (n = e.slice(0, o)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
    }
    return new j(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return j.empty;
    if (e instanceof j)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new j([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
j.empty = new j([], 0);
const po = { index: 0, offset: 0 };
function yr(t, e) {
  return po.index = t, po.offset = e, po;
}
class Gd extends Error {
}
class G {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = Ka(this.content, e + this.openStart, n);
    return r && new G(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new G(qa(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return G.empty;
    let r = n.openStart || 0, o = n.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new G(j.fromJSON(e, n.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, o = 0;
    for (let i = e.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
      r++;
    for (let i = e.lastChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.lastChild)
      o++;
    return new G(e, r, o);
  }
}
G.empty = new G(j.empty, 0, 0);
function qa(t, e, n) {
  let { index: r, offset: o } = t.findIndex(e), i = t.maybeChild(r), { index: s, offset: a } = t.findIndex(n);
  if (o == e || i.isText) {
    if (a != n && !t.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != s)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, i.copy(qa(i.content, e - o - 1, n - o - 1)));
}
function Ka(t, e, n, r) {
  let { index: o, offset: i } = t.findIndex(e), s = t.maybeChild(o);
  if (i == e || s.isText)
    return t.cut(0, e).append(n).append(t.cut(e));
  let a = Ka(s.content, e - i - 1, n);
  return a && t.replaceChild(o, s.copy(a));
}
class Lo {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Ya = 65535, Ga = Math.pow(2, 16);
function Jd(t, e) {
  return t + e * Ga;
}
function Vi(t) {
  return t & Ya;
}
function Zd(t) {
  return (t - (t & Ya)) / Ga;
}
const Ja = 1, Za = 2, $r = 4, Xa = 8;
class ji {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Xa) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Ja | $r)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Za | $r)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & $r) > 0;
  }
}
class Be {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && Be.empty)
      return Be.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = Vi(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        n += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + n + Zd(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0, i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? o : 0);
      if (l > e)
        break;
      let c = this.ranges[a + i], u = this.ranges[a + s], f = l + c;
      if (e <= f) {
        let m = c ? e == l ? -1 : e == f ? 1 : n : n, g = l + o + (m < 0 ? 0 : u);
        if (r)
          return g;
        let b = e == (n < 0 ? l : f) ? null : Jd(a / 3, e - l), d = e == l ? Za : e == f ? Ja : $r;
        return (n < 0 ? e != l : e != f) && (d |= Xa), new ji(g, d, b);
      }
      o += u - c;
    }
    return r ? e + o : new ji(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, o = Vi(n), i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[a + i], u = l + c;
      if (e <= u && a == o * 3)
        return !0;
      r += this.ranges[a + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let s = this.ranges[o], a = s - (this.inverted ? i : 0), l = s + (this.inverted ? 0 : i), c = this.ranges[o + n], u = this.ranges[o + r];
      e(a, a + c, l, l + u), i += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Be(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Be.empty : new Be(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Be.empty = new Be([]);
const mo = /* @__PURE__ */ Object.create(null);
class Re {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Be.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = mo[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in mo)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return mo[e] = n, n.prototype.jsonID = e, n;
  }
}
class xe {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new xe(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new xe(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, o) {
    try {
      return xe.ok(e.replace(n, r, o));
    } catch (i) {
      if (i instanceof Gd)
        return xe.fail(i.message);
      throw i;
    }
  }
}
function ri(t, e, n) {
  let r = [];
  for (let o = 0; o < t.childCount; o++) {
    let i = t.child(o);
    i.content.size && (i = i.copy(ri(i.content, e, i))), i.isInline && (i = e(i, n, o)), r.push(i);
  }
  return j.fromArray(r);
}
class Dt extends Re {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), i = new G(ri(n.content, (s, a) => !s.isAtom || !a.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), o), n.openStart, n.openEnd);
    return xe.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new Ft(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Dt(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Dt && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Dt(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Dt(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Re.jsonID("addMark", Dt);
class Ft extends Re {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new G(ri(n.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), n.openStart, n.openEnd);
    return xe.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Dt(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Ft(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Ft && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Ft(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Ft(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Re.jsonID("removeMark", Ft);
class Bt extends Re {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return xe.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return xe.fromReplace(e, this.pos, this.pos + 1, new G(j.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let o = 0; o < n.marks.length; o++)
          if (!n.marks[o].isInSet(r))
            return new Bt(this.pos, n.marks[o]);
        return new Bt(this.pos, this.mark);
      }
    }
    return new qn(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Bt(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Bt(n.pos, e.markFromJSON(n.mark));
  }
}
Re.jsonID("addNodeMark", Bt);
class qn extends Re {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return xe.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return xe.fromReplace(e, this.pos, this.pos + 1, new G(j.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Bt(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new qn(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new qn(n.pos, e.markFromJSON(n.mark));
  }
}
Re.jsonID("removeNodeMark", qn);
class Fe extends Re {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, o = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && Do(e, this.from, this.to) ? xe.fail("Structure replace would overwrite content") : xe.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Be([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Fe(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new Fe(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof Fe) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? G.empty : new G(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Fe(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? G.empty : new G(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Fe(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Fe(n.from, n.to, G.fromJSON(e, n.slice), !!n.structure);
  }
}
Re.jsonID("replace", Fe);
class Me extends Re {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, o, i, s, a = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = o, this.slice = i, this.insert = s, this.structure = a;
  }
  apply(e) {
    if (this.structure && (Do(e, this.from, this.gapFrom) || Do(e, this.gapTo, this.to)))
      return xe.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return xe.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? xe.fromReplace(e, this.from, this.to, r) : xe.fail("Content does not fit in gap");
  }
  getMap() {
    return new Be([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new Me(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), i = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || o < n.pos || i > r.pos ? null : new Me(n.pos, r.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Me(n.from, n.to, n.gapFrom, n.gapTo, G.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
Re.jsonID("replaceAround", Me);
function Do(t, e, n) {
  let r = t.resolve(e), o = n - e, i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let s = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, o--;
    }
  }
  return !1;
}
function Xd(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function Tn(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth; ; --r) {
    let o = t.$from.node(r), i = t.$from.index(r), s = t.$to.indexAfter(r);
    if (r < t.depth && o.canReplace(i, s, n))
      return r;
    if (r == 0 || o.type.spec.isolating || !Xd(o, i, s))
      break;
  }
  return null;
}
function Qa(t, e, n = null, r = t) {
  let o = Qd(t, e), i = o && ef(r, e);
  return i ? o.map(Hi).concat({ type: e, attrs: n }).concat(i.map(Hi)) : null;
}
function Hi(t) {
  return { type: t, attrs: null };
}
function Qd(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, i = n.contentMatchAt(r).findWrapping(e);
  if (!i)
    return null;
  let s = i.length ? i[0] : e;
  return n.canReplaceWith(r, o, s) ? i : null;
}
function ef(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, i = n.child(r), s = e.contentMatch.findWrapping(i.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = r; l && c < o; c++)
    l = l.matchType(n.child(c).type);
  return !l || !l.validEnd ? null : s;
}
function cn(t, e, n = 1, r) {
  let o = t.resolve(e), i = o.depth - n, s = r && r[r.length - 1] || o.parent;
  if (i < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !s.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let c = o.depth - 1, u = n - 2; c > i; c--, u--) {
    let f = o.node(c), m = o.index(c);
    if (f.type.spec.isolating)
      return !1;
    let g = f.content.cutByIndex(m, f.childCount), b = r && r[u + 1];
    b && (g = g.replaceChild(0, b.type.create(b.attrs)));
    let d = r && r[u] || f;
    if (!f.canReplace(m + 1, f.childCount) || !d.type.validContent(g))
      return !1;
  }
  let a = o.indexAfter(i), l = r && r[0];
  return o.node(i).canReplaceWith(a, a, l ? l.type : o.node(i + 1).type);
}
function Yt(t, e) {
  let n = t.resolve(e), r = n.index();
  return el(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function tf(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let o = 0; o < e.childCount; o++) {
    let i = e.child(o), s = i.type == r ? t.type.schema.nodes.text : i.type;
    if (n = n.matchType(s), !n || !t.type.allowsMarks(i.marks))
      return !1;
  }
  return n.validEnd;
}
function el(t, e) {
  return !!(t && e && !t.isLeaf && tf(t, e));
}
function qr(t, e, n = -1) {
  let r = t.resolve(e);
  for (let o = r.depth; ; o--) {
    let i, s, a = r.index(o);
    if (o == r.depth ? (i = r.nodeBefore, s = r.nodeAfter) : n > 0 ? (i = r.node(o + 1), a++, s = r.node(o).maybeChild(a)) : (i = r.node(o).maybeChild(a - 1), s = r.node(o + 1)), i && !i.isTextblock && el(i, s) && r.node(o).canReplace(a, a + 1))
      return e;
    if (o == 0)
      break;
    e = n < 0 ? r.before(o) : r.after(o);
  }
}
function oi(t, e, n = e, r = G.empty) {
  if (e == n && !r.size)
    return null;
  let o = t.resolve(e), i = t.resolve(n);
  return nf(o, i, r) ? new Fe(e, n, r) : new rf(o, i, r).fit();
}
function nf(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class rf {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = j.empty;
    for (let o = 0; o <= e.depth; o++) {
      let i = e.node(o);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = j.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let i = this.placed, s = r.depth, a = o.depth;
    for (; s && a && i.childCount == 1; )
      i = i.firstChild.content, s--, a--;
    let l = new G(i, s, a);
    return e > -1 ? new Me(r.pos, e, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new Fe(r.pos, o.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let i = n.firstChild;
      if (n.childCount > 1 && (o = 0), i.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      n = i.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, i = null;
        r ? (i = ho(this.unplaced.content, r - 1).firstChild, o = i.content) : o = this.unplaced.content;
        let s = o.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: c } = this.frontier[a], u, f = null;
          if (n == 1 && (s ? c.matchType(s.type) || (f = c.fillBefore(j.from(s), !1)) : i && l.compatibleContent(i.type)))
            return { sliceDepth: r, frontierDepth: a, parent: i, inject: f };
          if (n == 2 && s && (u = c.findWrapping(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: i, wrap: u };
          if (i && c.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = ho(e, n);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new G(e, n + 1, Math.max(r, o.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = ho(e, n);
    if (o.childCount <= 1 && n > 0) {
      let i = e.size - n <= n + o.size;
      this.unplaced = new G(Ln(e, n - 1, 1), n - 1, i ? n - 1 : r);
    } else
      this.unplaced = new G(Ln(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: o, wrap: i }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (i)
      for (let d = 0; d < i.length; d++)
        this.openFrontierNode(i[d]);
    let s = this.unplaced, a = r ? r.content : s.content, l = s.openStart - e, c = 0, u = [], { match: f, type: m } = this.frontier[n];
    if (o) {
      for (let d = 0; d < o.childCount; d++)
        u.push(o.child(d));
      f = f.matchFragment(o);
    }
    let g = a.size + e - (s.content.size - s.openEnd);
    for (; c < a.childCount; ) {
      let d = a.child(c), v = f.matchType(d.type);
      if (!v)
        break;
      c++, (c > 1 || l == 0 || d.content.size) && (f = v, u.push(tl(d.mark(m.allowedMarks(d.marks)), c == 1 ? l : 0, c == a.childCount ? g : -1)));
    }
    let b = c == a.childCount;
    b || (g = -1), this.placed = Dn(this.placed, n, j.from(u)), this.frontier[n].match = f, b && g < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let d = 0, v = a; d < g; d++) {
      let C = v.lastChild;
      this.frontier.push({ type: C.type, match: C.contentMatchAt(C.childCount) }), v = C.content;
    }
    this.unplaced = b ? e == 0 ? G.empty : new G(Ln(s.content, e - 1, 1), e - 1, g < 0 ? s.openEnd : e - 1) : new G(Ln(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !go(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: r, type: o } = this.frontier[n], i = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), s = go(e, n, o, r, i);
      if (s) {
        for (let a = n - 1; a >= 0; a--) {
          let { match: l, type: c } = this.frontier[a], u = go(e, a, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: s, move: i ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Dn(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), i = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, i);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = Dn(this.placed, this.depth, j.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(j.empty, !0);
    n.childCount && (this.placed = Dn(this.placed, this.frontier.length, n));
  }
}
function Ln(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(Ln(t.firstChild.content, e - 1, n)));
}
function Dn(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(Dn(t.lastChild.content, e - 1, n)));
}
function ho(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function tl(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, tl(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(j.empty, !0)))), t.copy(r);
}
function go(t, e, n, r, o) {
  let i = t.node(e), s = o ? t.indexAfter(e) : t.index(e);
  if (s == i.childCount && !n.compatibleContent(i.type))
    return null;
  let a = r.fillBefore(i.content, !0, s);
  return a && !of(n, i.content, s) ? a : null;
}
function of(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
class _n extends Re {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return xe.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in n.attrs)
      r[i] = n.attrs[i];
    r[this.attr] = this.value;
    let o = n.type.create(r, null, n.marks);
    return xe.fromReplace(e, this.pos, this.pos + 1, new G(j.from(o), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return Be.empty;
  }
  invert(e) {
    return new _n(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new _n(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new _n(n.pos, n.attr, n.value);
  }
}
Re.jsonID("attr", _n);
class Nr extends Re {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      n[o] = e.attrs[o];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return xe.ok(r);
  }
  getMap() {
    return Be.empty;
  }
  invert(e) {
    return new Nr(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Nr(n.attr, n.value);
  }
}
Re.jsonID("docAttr", Nr);
let Kn = class extends Error {
};
Kn = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
Kn.prototype = Object.create(Error.prototype);
Kn.prototype.constructor = Kn;
Kn.prototype.name = "TransformError";
const yo = /* @__PURE__ */ Object.create(null);
class be {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new sf(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = G.empty) {
    let r = n.content.lastChild, o = null;
    for (let a = 0; a < n.openEnd; a++)
      o = r, r = r.lastChild;
    let i = e.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: l, $to: c } = s[a], u = e.mapping.slice(i);
      e.replaceRange(u.map(l.pos), u.map(c.pos), a ? G.empty : n), a == 0 && qi(e, i, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: s, $to: a } = o[i], l = e.mapping.slice(r), c = l.map(s.pos), u = l.map(a.pos);
      i ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, n), qi(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let o = e.parent.inlineContent ? new Ve(e) : rn(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (o)
      return o;
    for (let i = e.depth - 1; i >= 0; i--) {
      let s = n < 0 ? rn(e.node(0), e.node(i), e.before(i + 1), e.index(i), n, r) : rn(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, n, r);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new at(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return rn(e, e, 0, 0, 1) || new at(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return rn(e, e, e.content.size, e.childCount, -1) || new at(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = yo[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in yo)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return yo[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ve.between(this.$anchor, this.$head).getBookmark();
  }
}
be.prototype.visible = !0;
class sf {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let Ui = !1;
function Wi(t) {
  !Ui && !t.parent.inlineContent && (Ui = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class Ve extends be {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    Wi(e), Wi(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return be.near(r);
    let o = e.resolve(n.map(this.anchor));
    return new Ve(o.parent.inlineContent ? o : r, r);
  }
  replace(e, n = G.empty) {
    if (super.replace(e, n), n == G.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Ve && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Kr(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ve(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let o = e.resolve(n);
    return new this(o, r == n ? o : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let o = e.pos - n.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let i = be.findFrom(n, r, !0) || be.findFrom(n, -r, !0);
      if (i)
        n = i.$head;
      else
        return be.near(n, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = n : (e = (be.findFrom(e, -r, !0) || be.findFrom(e, r, !0)).$anchor, e.pos < n.pos != o < 0 && (e = n))), new Ve(e, n);
  }
}
be.jsonID("text", Ve);
class Kr {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new Kr(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Ve.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class he extends be {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: o } = n.mapResult(this.anchor), i = e.resolve(o);
    return r ? be.near(i) : new he(i);
  }
  content() {
    return new G(j.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof he && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new ii(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new he(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new he(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
he.prototype.visible = !1;
be.jsonID("node", he);
class ii {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new Kr(r, r) : new ii(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && he.isSelectable(r) ? new he(n) : be.near(n);
  }
}
class at extends be {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = G.empty) {
    if (n == G.empty) {
      e.delete(0, e.doc.content.size);
      let r = be.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new at(e);
  }
  map(e) {
    return new at(e);
  }
  eq(e) {
    return e instanceof at;
  }
  getBookmark() {
    return af;
  }
}
be.jsonID("all", at);
const af = {
  map() {
    return this;
  },
  resolve(t) {
    return new at(t);
  }
};
function rn(t, e, n, r, o, i = !1) {
  if (e.inlineContent)
    return Ve.create(t, n);
  for (let s = r - (o > 0 ? 0 : 1); o > 0 ? s < e.childCount : s >= 0; s += o) {
    let a = e.child(s);
    if (a.isAtom) {
      if (!i && he.isSelectable(a))
        return he.create(t, n - (o < 0 ? a.nodeSize : 0));
    } else {
      let l = rn(t, a, n + o, o < 0 ? a.childCount : 0, o, i);
      if (l)
        return l;
    }
    n += a.nodeSize * o;
  }
  return null;
}
function qi(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let o = t.steps[r];
  if (!(o instanceof Fe || o instanceof Me))
    return;
  let i = t.mapping.maps[r], s;
  i.forEach((a, l, c, u) => {
    s == null && (s = u);
  }), t.setSelection(be.near(t.doc.resolve(s), n));
}
function Ki(t, e) {
  return !e || !t ? t : t.bind(e);
}
class br {
  constructor(e, n, r) {
    this.name = e, this.init = Ki(n.init, r), this.apply = Ki(n.apply, r);
  }
}
new br("doc", {
  init(t) {
    return t.doc || t.schema.topNodeType.createAndFill();
  },
  apply(t) {
    return t.doc;
  }
}), new br("selection", {
  init(t, e) {
    return t.selection || be.atStart(e.doc);
  },
  apply(t) {
    return t.selection;
  }
}), new br("storedMarks", {
  init(t) {
    return t.storedMarks || null;
  },
  apply(t, e, n, r) {
    return r.selection.$cursor ? t.storedMarks : null;
  }
}), new br("scrollToSelection", {
  init() {
    return 0;
  },
  apply(t, e) {
    return t.scrolledIntoView ? e + 1 : e;
  }
});
const lf = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function nl(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const cf = (t, e, n) => {
  let r = nl(t, n);
  if (!r)
    return !1;
  let o = si(r);
  if (!o) {
    let s = r.blockRange(), a = s && Tn(s);
    return a == null ? !1 : (e && e(t.tr.lift(s, a).scrollIntoView()), !0);
  }
  let i = o.nodeBefore;
  if (sl(t, o, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (hn(i, "end") || he.isSelectable(i)))
    for (let s = r.depth; ; s--) {
      let a = oi(t.doc, r.before(s), r.after(s), G.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = t.tr.step(a);
          l.setSelection(hn(i, "end") ? be.findFrom(l.doc.resolve(l.mapping.map(o.pos, -1)), -1) : he.create(l.doc, o.pos - i.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || r.node(s - 1).childCount > 1)
        break;
    }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos - i.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, uf = (t, e, n) => {
  let r = nl(t, n);
  if (!r)
    return !1;
  let o = si(r);
  return o ? rl(t, o, e) : !1;
}, df = (t, e, n) => {
  let r = ol(t, n);
  if (!r)
    return !1;
  let o = ai(r);
  return o ? rl(t, o, e) : !1;
};
function rl(t, e, n) {
  let r = e.nodeBefore, o = r, i = e.pos - 1;
  for (; !o.isTextblock; i--) {
    if (o.type.spec.isolating)
      return !1;
    let u = o.lastChild;
    if (!u)
      return !1;
    o = u;
  }
  let s = e.nodeAfter, a = s, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let c = oi(t.doc, i, l, G.empty);
  if (!c || c.from != i || c instanceof Fe && c.slice.size >= l - i)
    return !1;
  if (n) {
    let u = t.tr.step(c);
    u.setSelection(Ve.create(u.doc, i)), n(u.scrollIntoView());
  }
  return !0;
}
function hn(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const ff = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    i = si(r);
  }
  let s = i && i.nodeBefore;
  return !s || !he.isSelectable(s) ? !1 : (e && e(t.tr.setSelection(he.create(t.doc, i.pos - s.nodeSize)).scrollIntoView()), !0);
};
function si(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function ol(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const pf = (t, e, n) => {
  let r = ol(t, n);
  if (!r)
    return !1;
  let o = ai(r);
  if (!o)
    return !1;
  let i = o.nodeAfter;
  if (sl(t, o, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (hn(i, "start") || he.isSelectable(i))) {
    let s = oi(t.doc, r.before(), r.after(), G.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let a = t.tr.step(s);
        a.setSelection(hn(i, "start") ? be.findFrom(a.doc.resolve(a.mapping.map(o.pos)), 1) : he.create(a.doc, a.mapping.map(o.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos, o.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, mf = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    i = ai(r);
  }
  let s = i && i.nodeAfter;
  return !s || !he.isSelectable(s) ? !1 : (e && e(t.tr.setSelection(he.create(t.doc, i.pos)).scrollIntoView()), !0);
};
function ai(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const hf = (t, e) => {
  let n = t.selection, r = n instanceof he, o;
  if (r) {
    if (n.node.isTextblock || !Yt(t.doc, n.from))
      return !1;
    o = n.from;
  } else if (o = qr(t.doc, n.from, -1), o == null)
    return !1;
  if (e) {
    let i = t.tr.join(o);
    r && i.setSelection(he.create(i.doc, o - t.doc.resolve(o).nodeBefore.nodeSize)), e(i.scrollIntoView());
  }
  return !0;
}, gf = (t, e) => {
  let n = t.selection, r;
  if (n instanceof he) {
    if (n.node.isTextblock || !Yt(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = qr(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, yf = (t, e) => {
  let { $from: n, $to: r } = t.selection, o = n.blockRange(r), i = o && Tn(o);
  return i == null ? !1 : (e && e(t.tr.lift(o, i).scrollIntoView()), !0);
}, bf = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function il(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const vf = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let o = n.node(-1), i = n.indexAfter(-1), s = il(o.contentMatchAt(i));
  if (!s || !o.canReplaceWith(i, i, s))
    return !1;
  if (e) {
    let a = n.after(), l = t.tr.replaceWith(a, a, s.createAndFill());
    l.setSelection(be.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, wf = (t, e) => {
  let n = t.selection, { $from: r, $to: o } = n;
  if (n instanceof at || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let i = il(o.parent.contentMatchAt(o.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (e) {
    let s = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, a = t.tr.insert(s, i.createAndFill());
    a.setSelection(Ve.create(a.doc, s + 1)), e(a.scrollIntoView());
  }
  return !0;
}, Cf = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (cn(t.doc, i))
      return e && e(t.tr.split(i).scrollIntoView()), !0;
  }
  let r = n.blockRange(), o = r && Tn(r);
  return o == null ? !1 : (e && e(t.tr.lift(r, o).scrollIntoView()), !0);
}, Sf = (t, e) => {
  let { $from: n, to: r } = t.selection, o, i = n.sharedDepth(r);
  return i == 0 ? !1 : (o = n.before(i), e && e(t.tr.setSelection(he.create(t.doc, o))), !0);
};
function xf(t, e, n) {
  let r = e.nodeBefore, o = e.nodeAfter, i = e.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && e.parent.canReplace(i - 1, i) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(i, i + 1) || !(o.isTextblock || Yt(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function sl(t, e, n, r) {
  let o = e.nodeBefore, i = e.nodeAfter, s, a, l = o.type.spec.isolating || i.type.spec.isolating;
  if (!l && xf(t, e, n))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (a = o.contentMatchAt(o.childCount)).findWrapping(i.type)) && a.matchType(s[0] || i.type).validEnd) {
    if (n) {
      let g = e.pos + i.nodeSize, b = j.empty;
      for (let C = s.length - 1; C >= 0; C--)
        b = j.from(s[C].create(null, b));
      b = j.from(o.copy(b));
      let d = t.tr.step(new Me(e.pos - 1, g, e.pos, g, new G(b, 1, 0), s.length, !0)), v = d.doc.resolve(g + 2 * s.length);
      v.nodeAfter && v.nodeAfter.type == o.type && Yt(d.doc, v.pos) && d.join(v.pos), n(d.scrollIntoView());
    }
    return !0;
  }
  let u = i.type.spec.isolating || r > 0 && l ? null : be.findFrom(e, 1), f = u && u.$from.blockRange(u.$to), m = f && Tn(f);
  if (m != null && m >= e.depth)
    return n && n(t.tr.lift(f, m).scrollIntoView()), !0;
  if (c && hn(i, "start", !0) && hn(o, "end")) {
    let g = o, b = [];
    for (; b.push(g), !g.isTextblock; )
      g = g.lastChild;
    let d = i, v = 1;
    for (; !d.isTextblock; d = d.firstChild)
      v++;
    if (g.canReplace(g.childCount, g.childCount, d.content)) {
      if (n) {
        let C = j.empty;
        for (let E = b.length - 1; E >= 0; E--)
          C = j.from(b[E].copy(C));
        let R = t.tr.step(new Me(e.pos - b.length, e.pos + i.nodeSize, e.pos + v, e.pos + i.nodeSize - v, new G(C, b.length, 0), 0, !0));
        n(R.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function al(t) {
  return function(e, n) {
    let r = e.selection, o = t < 0 ? r.$from : r.$to, i = o.depth;
    for (; o.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return o.node(i).isTextblock ? (n && n(e.tr.setSelection(Ve.create(e.doc, t < 0 ? o.start(i) : o.end(i)))), !0) : !1;
  };
}
const Tf = al(-1), kf = al(1);
function Af(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: i } = n.selection, s = o.blockRange(i), a = s && Qa(s, t, e);
    return a ? (r && r(n.tr.wrap(s, a).scrollIntoView()), !0) : !1;
  };
}
function Yi(t, e = null) {
  return function(n, r) {
    let o = !1;
    for (let i = 0; i < n.selection.ranges.length && !o; i++) {
      let { $from: { pos: s }, $to: { pos: a } } = n.selection.ranges[i];
      n.doc.nodesBetween(s, a, (l, c) => {
        if (o)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            o = !0;
          else {
            let u = n.doc.resolve(c), f = u.index();
            o = u.parent.canReplaceWith(f, f + 1, t);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let i = n.tr;
      for (let s = 0; s < n.selection.ranges.length; s++) {
        let { $from: { pos: a }, $to: { pos: l } } = n.selection.ranges[s];
        i.setBlockType(a, l, t, e);
      }
      r(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function Ef(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: i } = n.selection, s = o.blockRange(i);
    if (!s)
      return !1;
    let a = r ? n.tr : null;
    return Of(a, s, t, e) ? (r && r(a.scrollIntoView()), !0) : !1;
  };
}
function Of(t, e, n, r = null) {
  let o = !1, i = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    i = new Lo(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Lo(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), o = !0;
  }
  let a = Qa(i, n, r, e);
  return a ? (t && $f(t, e, a, o, n), !0) : !1;
}
function $f(t, e, n, r, o) {
  let i = j.empty;
  for (let u = n.length - 1; u >= 0; u--)
    i = j.from(n[u].type.create(n[u].attrs, i));
  t.step(new Me(e.start - (r ? 2 : 0), e.end, e.start, e.end, new G(i, 0, 0), n.length, !0));
  let s = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == o && (s = u + 1);
  let a = n.length - s, l = e.start + n.length - (r ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, f = e.endIndex, m = !0; u < f; u++, m = !1)
    !m && cn(t.doc, l, a) && (t.split(l, a), l += 2 * a), l += c.child(u).nodeSize;
  return t;
}
function Rf(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (s) => s.childCount > 0 && s.firstChild.type == t);
    return i ? n ? r.node(i.depth - 1).type == t ? If(e, n, t, i) : Mf(e, n, i) : !0 : !1;
  };
}
function If(t, e, n, r) {
  let o = t.tr, i = r.end, s = r.$to.end(r.depth);
  i < s && (o.step(new Me(i - 1, s, i, s, new G(j.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Lo(o.doc.resolve(r.$from.pos), o.doc.resolve(s), r.depth));
  const a = Tn(r);
  if (a == null)
    return !1;
  o.lift(r, a);
  let l = o.mapping.map(i, -1) - 1;
  return Yt(o.doc, l) && o.join(l), e(o.scrollIntoView()), !0;
}
function Mf(t, e, n) {
  let r = t.tr, o = n.parent;
  for (let g = n.end, b = n.endIndex - 1, d = n.startIndex; b > d; b--)
    g -= o.child(b).nodeSize, r.delete(g - 1, g + 1);
  let i = r.doc.resolve(n.start), s = i.nodeAfter;
  if (r.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize)
    return !1;
  let a = n.startIndex == 0, l = n.endIndex == o.childCount, c = i.node(-1), u = i.index(-1);
  if (!c.canReplace(u + (a ? 0 : 1), u + 1, s.content.append(l ? j.empty : j.from(o))))
    return !1;
  let f = i.pos, m = f + s.nodeSize;
  return r.step(new Me(f - (a ? 1 : 0), m + (l ? 1 : 0), f + 1, m - 1, new G((a ? j.empty : j.from(o.copy(j.empty))).append(l ? j.empty : j.from(o.copy(j.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function Pf(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!i)
      return !1;
    let s = i.startIndex;
    if (s == 0)
      return !1;
    let a = i.parent, l = a.child(s - 1);
    if (l.type != t)
      return !1;
    if (n) {
      let c = l.lastChild && l.lastChild.type == a.type, u = j.from(c ? t.create() : null), f = new G(j.from(t.create(null, j.from(a.type.create(null, u)))), c ? 3 : 1, 0), m = i.start, g = i.end;
      n(e.tr.step(new Me(m - (c ? 3 : 1), g, m, g, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function ll(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: o } = n, { storedMarks: i } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return i;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = n.selection, o = n.doc, i = n.storedMarks, n;
    }
  };
}
class Nf {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: o } = n, { tr: i } = r, s = this.buildProps(i);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...u) => {
      const f = l(...u)(s);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(i), f;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: s } = o, a = [], l = !!e, c = e || i.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), a.every((m) => m === !0)), f = {
      ...Object.fromEntries(Object.entries(r).map(([m, g]) => [m, (...d) => {
        const v = this.buildProps(c, n), C = g(...d)(v);
        return a.push(C), f;
      }])),
      run: u
    };
    return f;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, o = !1, i = e || r.tr, s = this.buildProps(i, o);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(i, o)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: s } = o, a = {
      tr: e,
      editor: o,
      view: s,
      state: ll({
        state: i,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)(a)]));
      }
    };
    return a;
  }
}
function tt(t, e, n) {
  return t.config[e] === void 0 && t.parent ? tt(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? tt(t.parent, e, n) : null
  }) : t.config[e];
}
function Lf(t) {
  const e = t.filter((o) => o.type === "extension"), n = t.filter((o) => o.type === "node"), r = t.filter((o) => o.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function $e(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function cl(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([o, i]) => {
      if (!r[o]) {
        r[o] = i;
        return;
      }
      if (o === "class") {
        const a = i ? String(i).split(" ") : [], l = r[o] ? r[o].split(" ") : [], c = a.filter((u) => !l.includes(u));
        r[o] = [...l, ...c].join(" ");
      } else if (o === "style") {
        const a = i ? i.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[o] ? r[o].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [f, m] = u.split(":").map((g) => g.trim());
          c.set(f, m);
        }), a.forEach((u) => {
          const [f, m] = u.split(":").map((g) => g.trim());
          c.set(f, m);
        }), r[o] = Array.from(c.entries()).map(([u, f]) => `${u}: ${f}`).join("; ");
      } else
        r[o] = i;
    }), r;
  }, {});
}
function Df(t) {
  return typeof t == "function";
}
function ht(t, e = void 0, ...n) {
  return Df(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function Ff(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class ul {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
function Bf(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function vr(t) {
  return Bf(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function li(t, e) {
  const n = { ...t };
  return vr(t) && vr(e) && Object.keys(e).forEach((r) => {
    vr(e[r]) && vr(t[r]) ? n[r] = li(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class Le {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ht(tt(this, "addOptions", {
      name: this.name
    }))), this.storage = ht(tt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Le(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => li(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Le({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ht(tt(n, "addOptions", {
      name: n.name
    })), n.storage = ht(tt(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function _f(t, e, n) {
  const { from: r, to: o } = e, { blockSeparator: i = `

`, textSerializers: s = {} } = n;
  let a = "";
  return t.nodesBetween(r, o, (l, c, u, f) => {
    var m;
    l.isBlock && c > r && (a += i);
    const g = s == null ? void 0 : s[l.type.name];
    if (g)
      return u && (a += g({
        node: l,
        pos: c,
        parent: u,
        index: f,
        range: e
      })), !1;
    l.isText && (a += (m = l == null ? void 0 : l.text) === null || m === void 0 ? void 0 : m.slice(Math.max(r, c) - c, o - c));
  }), a;
}
function zf(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
Le.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Kt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: o } = e, { ranges: i } = o, s = Math.min(...i.map((u) => u.$from.pos)), a = Math.max(...i.map((u) => u.$to.pos)), l = zf(n);
            return _f(r, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
});
const Vf = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), jf = (t = !1) => ({ commands: e }) => e.setContent("", t), Hf = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: o } = r;
  return n && o.forEach(({ $from: i, $to: s }) => {
    t.doc.nodesBetween(i.pos, s.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, f = c.resolve(u.map(l)), m = c.resolve(u.map(l + a.nodeSize)), g = f.blockRange(m);
      if (!g)
        return;
      const b = Tn(g);
      if (a.type.isTextblock) {
        const { defaultType: d } = f.parent.contentMatchAt(f.index());
        e.setNodeMarkup(g.start, d);
      }
      (b || b === 0) && e.lift(g, b);
    });
  }), !0;
}, Uf = (t) => (e) => t(e), Wf = () => ({ state: t, dispatch: e }) => wf(t, e), qf = (t, e) => ({ editor: n, tr: r }) => {
  const { state: o } = n, i = o.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const s = r.mapping.map(e);
  return r.insert(s, i.content), r.setSelection(new st(r.doc.resolve(s - 1))), !0;
}, Kf = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = t.selection.$anchor;
  for (let i = o.depth; i > 0; i -= 1)
    if (o.node(i).type === r.type) {
      if (e) {
        const a = o.before(i), l = o.after(i);
        t.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Yf = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const o = $e(t, n.schema), i = e.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === o) {
      if (r) {
        const l = i.before(s), c = i.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Gf = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: o } = t;
  return n && e.delete(r, o), !0;
}, Jf = () => ({ state: t, dispatch: e }) => lf(t, e), Zf = () => ({ commands: t }) => t.keyboardShortcut("Enter"), Xf = () => ({ state: t, dispatch: e }) => vf(t, e);
function Lr(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((o) => n.strict ? e[o] === t[o] : Ff(e[o]) ? e[o].test(t[o]) : e[o] === t[o]) : !0;
}
function dl(t, e, n = {}) {
  return t.find((r) => r.type === e && Lr(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((o) => [o, r.attrs[o]])),
    n
  ));
}
function Gi(t, e, n = {}) {
  return !!dl(t, e, n);
}
function fl(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let o = t.parent.childAfter(t.parentOffset);
  if ((!o.node || !o.node.marks.some((u) => u.type === e)) && (o = t.parent.childBefore(t.parentOffset)), !o.node || !o.node.marks.some((u) => u.type === e) || (n = n || ((r = o.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !dl([...o.node.marks], e, n)))
    return;
  let s = o.index, a = t.start() + o.offset, l = s + 1, c = a + o.node.nodeSize;
  for (; s > 0 && Gi([...t.parent.child(s - 1).marks], e, n); )
    s -= 1, a -= t.parent.child(s).nodeSize;
  for (; l < t.parent.childCount && Gi([...t.parent.child(l).marks], e, n); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function Ot(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const Qf = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const i = Ot(t, r.schema), { doc: s, selection: a } = n, { $from: l, from: c, to: u } = a;
  if (o) {
    const f = fl(l, i, e);
    if (f && f.from <= c && f.to >= u) {
      const m = st.create(s, f.from, f.to);
      n.setSelection(m);
    }
  }
  return !0;
}, ep = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function pl(t) {
  return t instanceof st;
}
function _t(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function tp(t, e = null) {
  if (!e)
    return null;
  const n = an.atStart(t), r = an.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const o = n.from, i = r.to;
  return e === "all" ? st.create(t, _t(0, o, i), _t(t.content.size, o, i)) : st.create(t, _t(e, o, i), _t(e, o, i));
}
function np() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function ci() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const rp = (t = null, e = {}) => ({ editor: n, view: r, tr: o, dispatch: i }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (ci() || np()) && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (i && t === null && !pl(n.state.selection))
    return s(), !0;
  const a = tp(o.doc, t) || n.state.selection, l = n.state.selection.eq(a);
  return i && (l || o.setSelection(a), l && o.storedMarks && o.setStoredMarks(o.storedMarks), s()), !0;
}, op = (t, e) => (n) => t.every((r, o) => e(r, { ...n, index: o })), ip = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), ml = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && ml(r);
  }
  return t;
};
function wr(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return ml(n);
}
function Yn(t, e, n) {
  if (t instanceof Ru || t instanceof ln)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, o = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return ln.fromArray(t.map((a) => e.nodeFromJSON(a)));
      const s = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && s.check(), s;
    } catch (i) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: i });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", i), Yn("", e, n);
    }
  if (o) {
    if (n.errorOnInvalidContent) {
      let s = !1, a = "";
      const l = new Iu({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? uo.fromSchema(l).parseSlice(wr(t), n.parseOptions) : uo.fromSchema(l).parse(wr(t), n.parseOptions), n.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const i = uo.fromSchema(e);
    return n.slice ? i.parseSlice(wr(t), n.parseOptions).content : i.parse(wr(t), n.parseOptions);
  }
  return Yn("", e, n);
}
function sp(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const o = t.steps[r];
  if (!(o instanceof Fe || o instanceof Me))
    return;
  const i = t.mapping.maps[r];
  let s = 0;
  i.forEach((a, l, c, u) => {
    s === 0 && (s = u);
  }), t.setSelection(an.near(t.doc.resolve(s), n));
}
const ap = (t) => !("type" in t), lp = (t, e, n) => ({ tr: r, dispatch: o, editor: i }) => {
  var s;
  if (o) {
    n = {
      parseOptions: i.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let a;
    const l = (v) => {
      i.emit("contentError", {
        editor: i,
        error: v,
        disableCollaboration: () => {
          i.storage.collaboration && (i.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...n.parseOptions
    };
    if (!n.errorOnInvalidContent && !i.options.enableContentCheck && i.options.emitContentError)
      try {
        Yn(e, i.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (v) {
        l(v);
      }
    try {
      a = Yn(e, i.schema, {
        parseOptions: c,
        errorOnInvalidContent: (s = n.errorOnInvalidContent) !== null && s !== void 0 ? s : i.options.enableContentCheck
      });
    } catch (v) {
      return l(v), !1;
    }
    let { from: u, to: f } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, m = !0, g = !0;
    if ((ap(a) ? a : [a]).forEach((v) => {
      v.check(), m = m ? v.isText && v.marks.length === 0 : !1, g = g ? v.isBlock : !1;
    }), u === f && g) {
      const { parent: v } = r.doc.resolve(u);
      v.isTextblock && !v.type.spec.code && !v.childCount && (u -= 1, f += 1);
    }
    let d;
    if (m) {
      if (Array.isArray(e))
        d = e.map((v) => v.text || "").join("");
      else if (e instanceof ln) {
        let v = "";
        e.forEach((C) => {
          C.text && (v += C.text);
        }), d = v;
      } else typeof e == "object" && e && e.text ? d = e.text : d = e;
      r.insertText(d, u, f);
    } else
      d = a, r.replaceWith(u, f, d);
    n.updateSelection && sp(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: u, text: d }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: u, text: d });
  }
  return !0;
}, cp = () => ({ state: t, dispatch: e }) => hf(t, e), up = () => ({ state: t, dispatch: e }) => gf(t, e), dp = () => ({ state: t, dispatch: e }) => cf(t, e), fp = () => ({ state: t, dispatch: e }) => pf(t, e), pp = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = qr(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, mp = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = qr(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, hp = () => ({ state: t, dispatch: e }) => uf(t, e), gp = () => ({ state: t, dispatch: e }) => df(t, e);
function hl() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function yp(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, o, i, s;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      ci() || hl() ? s = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), o && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), i && (n = `Shift-${n}`), n;
}
const bp = (t) => ({ editor: e, view: n, tr: r, dispatch: o }) => {
  const i = yp(t).split(/-(?!$)/), s = i.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, a));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && o && r.maybeStep(u);
  }), !0;
};
function ui(t, e, n = {}) {
  const { from: r, to: o, empty: i } = t.selection, s = e ? $e(e, t.schema) : null, a = [];
  t.doc.nodesBetween(r, o, (f, m) => {
    if (f.isText)
      return;
    const g = Math.max(r, m), b = Math.min(o, m + f.nodeSize);
    a.push({
      node: f,
      from: g,
      to: b
    });
  });
  const l = o - r, c = a.filter((f) => s ? s.name === f.node.type.name : !0).filter((f) => Lr(f.node.attrs, n, { strict: !1 }));
  return i ? !!c.length : c.reduce((f, m) => f + m.to - m.from, 0) >= l;
}
const vp = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = $e(t, n.schema);
  return ui(n, o, e) ? yf(n, r) : !1;
}, wp = () => ({ state: t, dispatch: e }) => Cf(t, e), Cp = (t) => ({ state: e, dispatch: n }) => {
  const r = $e(t, e.schema);
  return Rf(r)(e, n);
}, Sp = () => ({ state: t, dispatch: e }) => bf(t, e);
function gl(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Ji(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, o) => (n.includes(o) || (r[o] = t[o]), r), {});
}
const xp = (t, e) => ({ tr: n, state: r, dispatch: o }) => {
  let i = null, s = null;
  const a = gl(typeof t == "string" ? t : t.name, r.schema);
  return a ? (a === "node" && (i = $e(t, r.schema)), a === "mark" && (s = Ot(t, r.schema)), o && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      i && i === c.type && n.setNodeMarkup(u, void 0, Ji(c.attrs, e)), s && c.marks.length && c.marks.forEach((f) => {
        s === f.type && n.addMark(u, u + c.nodeSize, s.create(Ji(f.attrs, e)));
      });
    });
  }), !0) : !1;
}, Tp = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), kp = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new Ou(t.doc);
    t.setSelection(n);
  }
  return !0;
}, Ap = () => ({ state: t, dispatch: e }) => ff(t, e), Ep = () => ({ state: t, dispatch: e }) => mf(t, e), Op = () => ({ state: t, dispatch: e }) => Sf(t, e), $p = () => ({ state: t, dispatch: e }) => kf(t, e), Rp = () => ({ state: t, dispatch: e }) => Tf(t, e);
function Ip(t, e, n = {}, r = {}) {
  return Yn(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const Mp = (t, e = !1, n = {}, r = {}) => ({ editor: o, tr: i, dispatch: s, commands: a }) => {
  var l, c;
  const { doc: u } = i;
  if (n.preserveWhitespace !== "full") {
    const f = Ip(t, o.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : o.options.enableContentCheck
    });
    return s && i.replaceWith(0, u.content.size, f).setMeta("preventUpdate", !e), !0;
  }
  return s && i.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : o.options.enableContentCheck
  });
};
function Pp(t, e) {
  const n = Ot(e, t.schema), { from: r, to: o, empty: i } = t.selection, s = [];
  i ? (t.storedMarks && s.push(...t.storedMarks), s.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, o, (l) => {
    s.push(...l.marks);
  });
  const a = s.find((l) => l.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function Np(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function Lp(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function di(t) {
  return (e) => Lp(e.$from, t);
}
function Rr(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const o = t.find((i) => i.type === e && i.name === r);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function Dp(t, e, n = {}) {
  const { empty: r, ranges: o } = t.selection, i = e ? Ot(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((f) => i ? i.name === f.type.name : !0).find((f) => Lr(f.attrs, n, { strict: !1 }));
  let s = 0;
  const a = [];
  if (o.forEach(({ $from: f, $to: m }) => {
    const g = f.pos, b = m.pos;
    t.doc.nodesBetween(g, b, (d, v) => {
      if (!d.isText && !d.marks.length)
        return;
      const C = Math.max(g, v), R = Math.min(b, v + d.nodeSize), E = R - C;
      s += E, a.push(...d.marks.map((y) => ({
        mark: y,
        from: C,
        to: R
      })));
    });
  }), s === 0)
    return !1;
  const l = a.filter((f) => i ? i.name === f.mark.type.name : !0).filter((f) => Lr(f.mark.attrs, n, { strict: !1 })).reduce((f, m) => f + m.to - m.from, 0), c = a.filter((f) => i ? f.mark.type !== i && f.mark.type.excludes(i) : !0).reduce((f, m) => f + m.to - m.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function Zi(t, e) {
  const { nodeExtensions: n } = Lf(e), r = n.find((s) => s.name === t);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, i = ht(tt(r, "group", o));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function yl(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let o = !0;
    return t.content.forEach((i) => {
      o !== !1 && (yl(i, { ignoreWhitespace: n, checkChildren: e }) || (o = !1));
    }), o;
  }
  return !1;
}
function Fp(t, e, n) {
  var r;
  const { selection: o } = e;
  let i = null;
  if (pl(o) && (i = o.$cursor), i) {
    const a = (r = t.storedMarks) !== null && r !== void 0 ? r : i.marks();
    return !!n.isInSet(a) || !a.some((l) => l.type.excludes(n));
  }
  const { ranges: s } = o;
  return s.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(a.pos, l.pos, (u, f, m) => {
      if (c)
        return !1;
      if (u.isInline) {
        const g = !m || m.type.allowsMarkType(n), b = !!n.isInSet(u.marks) || !u.marks.some((d) => d.type.excludes(n));
        c = g && b;
      }
      return !c;
    }), c;
  });
}
const Bp = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const { selection: i } = n, { empty: s, ranges: a } = i, l = Ot(t, r.schema);
  if (o)
    if (s) {
      const c = Pp(r, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      a.forEach((c) => {
        const u = c.$from.pos, f = c.$to.pos;
        r.doc.nodesBetween(u, f, (m, g) => {
          const b = Math.max(g, u), d = Math.min(g + m.nodeSize, f);
          m.marks.find((C) => C.type === l) ? m.marks.forEach((C) => {
            l === C.type && n.addMark(b, d, l.create({
              ...C.attrs,
              ...e
            }));
          }) : n.addMark(b, d, l.create(e));
        });
      });
  return Fp(r, n, l);
}, _p = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), zp = (t, e = {}) => ({ state: n, dispatch: r, chain: o }) => {
  const i = $e(t, n.schema);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), i.isTextblock ? o().command(({ commands: a }) => Yi(i, { ...s, ...e })(n) ? !0 : a.clearNodes()).command(({ state: a }) => Yi(i, { ...s, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Vp = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, o = _t(t, 0, r.content.size), i = Ra.create(r, o);
    e.setSelection(i);
  }
  return !0;
}, jp = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: o, to: i } = typeof t == "number" ? { from: t, to: t } : t, s = st.atStart(r).from, a = st.atEnd(r).to, l = _t(o, s, a), c = _t(i, s, a), u = st.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, Hp = (t) => ({ state: e, dispatch: n }) => {
  const r = $e(t, e.schema);
  return Pf(r)(e, n);
};
function Xi(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((o) => e == null ? void 0 : e.includes(o.type.name));
    t.tr.ensureMarks(r);
  }
}
const Up = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: o }) => {
  const { selection: i, doc: s } = e, { $from: a, $to: l } = i, c = o.extensionManager.attributes, u = Rr(c, a.node().type.name, a.node().attrs);
  if (i instanceof Ra && i.node.isBlock)
    return !a.parentOffset || !cn(s, a.pos) ? !1 : (r && (t && Xi(n, o.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const f = l.parentOffset === l.parent.content.size, m = a.depth === 0 ? void 0 : Np(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let g = f && m ? [
    {
      type: m,
      attrs: u
    }
  ] : void 0, b = cn(e.doc, e.mapping.map(a.pos), 1, g);
  if (!g && !b && cn(e.doc, e.mapping.map(a.pos), 1, m ? [{ type: m }] : void 0) && (b = !0, g = m ? [
    {
      type: m,
      attrs: u
    }
  ] : void 0), r) {
    if (b && (i instanceof st && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, g), m && !f && !a.parentOffset && a.parent.type !== m)) {
      const d = e.mapping.map(a.before()), v = e.doc.resolve(d);
      a.node(-1).canReplaceWith(v.index(), v.index() + 1, m) && e.setNodeMarkup(e.mapping.map(a.before()), m);
    }
    t && Xi(n, o.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return b;
}, Wp = (t, e = {}) => ({ tr: n, state: r, dispatch: o, editor: i }) => {
  var s;
  const a = $e(t, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const f = l.node(-1);
  if (f.type !== a)
    return !1;
  const m = i.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (o) {
      let C = ln.empty;
      const R = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let D = l.depth - R; D >= l.depth - 3; D -= 1)
        C = ln.from(l.node(D).copy(C));
      const E = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, y = {
        ...Rr(m, l.node().type.name, l.node().attrs),
        ...e
      }, w = ((s = a.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(y)) || void 0;
      C = C.append(ln.from(a.createAndFill(null, w) || void 0));
      const x = l.before(l.depth - (R - 1));
      n.replace(x, l.after(-E), new $u(C, 4 - R, 0));
      let L = -1;
      n.doc.nodesBetween(x, n.doc.content.size, (D, F) => {
        if (L > -1)
          return !1;
        D.isTextblock && D.content.size === 0 && (L = F + 1);
      }), L > -1 && n.setSelection(st.near(n.doc.resolve(L))), n.scrollIntoView();
    }
    return !0;
  }
  const g = c.pos === l.end() ? f.contentMatchAt(0).defaultType : null, b = {
    ...Rr(m, f.type.name, f.attrs),
    ...e
  }, d = {
    ...Rr(m, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const v = g ? [
    { type: a, attrs: b },
    { type: g, attrs: d }
  ] : [{ type: a, attrs: b }];
  if (!cn(n.doc, l.pos, 2))
    return !1;
  if (o) {
    const { selection: C, storedMarks: R } = r, { splittableMarks: E } = i.extensionManager, y = R || C.$to.parentOffset && C.$from.marks();
    if (n.split(l.pos, 2, v).scrollIntoView(), !y || !o)
      return !0;
    const w = y.filter((x) => E.includes(x.type.name));
    n.ensureMarks(w);
  }
  return !0;
}, bo = (t, e) => {
  const n = di((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && Yt(t.doc, n.pos) && t.join(n.pos), !0;
}, vo = (t, e) => {
  const n = di((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && Yt(t.doc, r) && t.join(r), !0;
}, qp = (t, e, n, r = {}) => ({ editor: o, tr: i, state: s, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: f, splittableMarks: m } = o.extensionManager, g = $e(t, s.schema), b = $e(e, s.schema), { selection: d, storedMarks: v } = s, { $from: C, $to: R } = d, E = C.blockRange(R), y = v || d.$to.parentOffset && d.$from.marks();
  if (!E)
    return !1;
  const w = di((x) => Zi(x.type.name, f))(d);
  if (E.depth >= 1 && w && E.depth - w.depth <= 1) {
    if (w.node.type === g)
      return c.liftListItem(b);
    if (Zi(w.node.type.name, f) && g.validContent(w.node.content) && a)
      return l().command(() => (i.setNodeMarkup(w.pos, g), !0)).command(() => bo(i, g)).command(() => vo(i, g)).run();
  }
  return !n || !y || !a ? l().command(() => u().wrapInList(g, r) ? !0 : c.clearNodes()).wrapInList(g, r).command(() => bo(i, g)).command(() => vo(i, g)).run() : l().command(() => {
    const x = u().wrapInList(g, r), L = y.filter((D) => m.includes(D.type.name));
    return i.ensureMarks(L), x ? !0 : c.clearNodes();
  }).wrapInList(g, r).command(() => bo(i, g)).command(() => vo(i, g)).run();
}, Kp = (t, e = {}, n = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: i = !1 } = n, s = Ot(t, r.schema);
  return Dp(r, s, e) ? o.unsetMark(s, { extendEmptyMarkRange: i }) : o.setMark(s, e);
}, Yp = (t, e, n = {}) => ({ state: r, commands: o }) => {
  const i = $e(t, r.schema), s = $e(e, r.schema), a = ui(r, i, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), a ? o.setNode(s, l) : o.setNode(i, { ...l, ...n });
}, Gp = (t, e = {}) => ({ state: n, commands: r }) => {
  const o = $e(t, n.schema);
  return ui(n, o, e) ? r.lift(o) : r.wrapIn(o, e);
}, Jp = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const o = n[r];
    let i;
    if (o.spec.isInputRules && (i = o.getState(t))) {
      if (e) {
        const s = t.tr, a = i.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          s.step(a.steps[l].invert(a.docs[l]));
        if (i.text) {
          const l = s.doc.resolve(i.from).marks();
          s.replaceWith(i.from, i.to, t.schema.text(i.text, l));
        } else
          s.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, Zp = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: o } = n;
  return r || e && o.forEach((i) => {
    t.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, Xp = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  var i;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: a } = n, l = Ot(t, r.schema), { $from: c, empty: u, ranges: f } = a;
  if (!o)
    return !0;
  if (u && s) {
    let { from: m, to: g } = a;
    const b = (i = c.marks().find((v) => v.type === l)) === null || i === void 0 ? void 0 : i.attrs, d = fl(c, l, b);
    d && (m = d.from, g = d.to), n.removeMark(m, g, l);
  } else
    f.forEach((m) => {
      n.removeMark(m.$from.pos, m.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, Qp = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  let i = null, s = null;
  const a = gl(typeof t == "string" ? t : t.name, r.schema);
  return a ? (a === "node" && (i = $e(t, r.schema)), a === "mark" && (s = Ot(t, r.schema)), o && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let f, m, g, b;
    n.selection.empty ? r.doc.nodesBetween(c, u, (d, v) => {
      i && i === d.type && (g = Math.max(v, c), b = Math.min(v + d.nodeSize, u), f = v, m = d);
    }) : r.doc.nodesBetween(c, u, (d, v) => {
      v < c && i && i === d.type && (g = Math.max(v, c), b = Math.min(v + d.nodeSize, u), f = v, m = d), v >= c && v <= u && (i && i === d.type && n.setNodeMarkup(v, void 0, {
        ...d.attrs,
        ...e
      }), s && d.marks.length && d.marks.forEach((C) => {
        if (s === C.type) {
          const R = Math.max(v, c), E = Math.min(v + d.nodeSize, u);
          n.addMark(R, E, s.create({
            ...C.attrs,
            ...e
          }));
        }
      }));
    }), m && (f !== void 0 && n.setNodeMarkup(f, void 0, {
      ...m.attrs,
      ...e
    }), s && m.marks.length && m.marks.forEach((d) => {
      s === d.type && n.addMark(g, b, s.create({
        ...d.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, em = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = $e(t, n.schema);
  return Af(o, e)(n, r);
}, tm = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = $e(t, n.schema);
  return Ef(o, e)(n, r);
};
var nm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: Vf,
  clearContent: jf,
  clearNodes: Hf,
  command: Uf,
  createParagraphNear: Wf,
  cut: qf,
  deleteCurrentNode: Kf,
  deleteNode: Yf,
  deleteRange: Gf,
  deleteSelection: Jf,
  enter: Zf,
  exitCode: Xf,
  extendMarkRange: Qf,
  first: ep,
  focus: rp,
  forEach: op,
  insertContent: ip,
  insertContentAt: lp,
  joinBackward: dp,
  joinDown: up,
  joinForward: fp,
  joinItemBackward: pp,
  joinItemForward: mp,
  joinTextblockBackward: hp,
  joinTextblockForward: gp,
  joinUp: cp,
  keyboardShortcut: bp,
  lift: vp,
  liftEmptyBlock: wp,
  liftListItem: Cp,
  newlineInCode: Sp,
  resetAttributes: xp,
  scrollIntoView: Tp,
  selectAll: kp,
  selectNodeBackward: Ap,
  selectNodeForward: Ep,
  selectParentNode: Op,
  selectTextblockEnd: $p,
  selectTextblockStart: Rp,
  setContent: Mp,
  setMark: Bp,
  setMeta: _p,
  setNode: zp,
  setNodeSelection: Vp,
  setTextSelection: jp,
  sinkListItem: Hp,
  splitBlock: Up,
  splitListItem: Wp,
  toggleList: qp,
  toggleMark: Kp,
  toggleNode: Yp,
  toggleWrap: Gp,
  undoInputRule: Jp,
  unsetAllMarks: Zp,
  unsetMark: Xp,
  updateAttributes: Qp,
  wrapIn: em,
  wrapInList: tm
});
Le.create({
  name: "commands",
  addCommands() {
    return {
      ...nm
    };
  }
});
Le.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Kt("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
});
Le.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Kt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
const rm = new Kt("focusEvents");
Le.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new bt({
        key: rm,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
});
Le.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: f } = l, { pos: m, parent: g } = f, b = f.parent.isTextblock && m > 0 ? a.doc.resolve(m - 1) : f, d = b.parent.type.spec.isolating, v = f.pos - f.parentOffset, C = d && b.parent.childCount === 1 ? v === f.pos : an.atStart(c).from === m;
        return !u || !g.type.isTextblock || g.textContent.length || !C || C && f.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, i = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return ci() || hl() ? i : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new bt({
        key: new Kt("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((d) => d.getMeta("composition")))
            return;
          const r = t.some((d) => d.docChanged) && !e.doc.eq(n.doc), o = t.some((d) => d.getMeta("preventClearDocument"));
          if (!r || o)
            return;
          const { empty: i, from: s, to: a } = e.selection, l = an.atStart(e.doc).from, c = an.atEnd(e.doc).to;
          if (i || !(s === l && a === c) || !yl(n.doc))
            return;
          const m = n.tr, g = ll({
            state: n,
            transaction: m
          }), { commands: b } = new Nf({
            editor: this.editor,
            state: g
          });
          if (b.clearNodes(), !!m.steps.length)
            return m;
        }
      })
    ];
  }
});
Le.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Kt("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
});
Le.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new bt({
        key: new Kt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
function k(t) {
  return new ul({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      let o = t.replace, i = n.from;
      const s = n.to;
      if (r[1]) {
        const a = r[0].lastIndexOf(r[1]);
        o += r[0].slice(a + r[1].length), i += a;
        const l = i - s;
        l > 0 && (o = r[0].slice(a - l, a) + o, i = s);
      }
      e.tr.insertText(o, i, s);
    }
  });
}
class Dr {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ht(tt(this, "addOptions", {
      name: this.name
    }))), this.storage = ht(tt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Dr(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => li(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Dr(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ht(tt(n, "addOptions", {
      name: n.name
    })), n.storage = ht(tt(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
const om = Dr.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", cl(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), im = "Actions", sm = "Body", am = "Bold", lm = "Bullet list", cm = "Cancel", um = "Caption", dm = "Background color", fm = "Center align", pm = "Clear formatting", mm = "Code", hm = "Code block", gm = "Auto", ym = "Collapse", bm = "Decrease indent", vm = "Delete column", wm = "Delete row", Cm = "Delete selection", Sm = "Delete table", xm = "Title", Tm = "Subtitle", km = "Heading", Am = "Highlight", Em = "Horizontal line", Om = "Image", $m = "Increase indent", Rm = "Insert", Im = "Insert column left", Mm = "Insert column right", Pm = "Insert image", Nm = "Insert row above", Lm = "Insert row below", Dm = "Insert", Fm = "Insert Youtube video", Bm = "Make sure you enter a valid url", _m = "Italic", zm = "Justify", Vm = "Left align", jm = "Paste a link, for example, www.google.com", Hm = "More text styles option", Um = "Normal", Wm = "Open link in new tab", qm = "Ordered list", Km = "Quote", Ym = "Redo", Gm = "Reset", Jm = "Right align", Zm = "Save", Xm = {
  insertHorizontalLine: "Horizontal line",
  insertImage: "Image",
  insertTable: "Table {{count}}x{{count}}",
  insertYoutubeVideo: "Youtube video"
}, Qm = "Strikethrough", eh = "Subscript", th = "Superscript", nh = "Table", rh = {
  cellFillColor: "Fill color",
  includeColumnHeader: "Header column",
  includeHeaderSection: "Header",
  includeRowHeader: "Header row",
  numberOfColumns: "Columns",
  numberOfRows: "Rows",
  panelTitle: "Table style",
  textColor: "Cell text color",
  textStyleSection: "Text style"
}, oh = "Task list", ih = "Color", sh = "Content", ah = "Titles", lh = "Decorations", ch = "Style", uh = "Toggle header cell", dh = "Toggle header column", fh = "Toggle header row", ph = "Underline", mh = "Undo", hh = "Uploading image…", gh = "Enter the url", yh = "Youtube video", bl = {
  actionsPanelTitle: im,
  body: sm,
  bold: am,
  bulletList: lm,
  cancel: cm,
  caption: um,
  cellBackgroundColor: dm,
  centerAlign: fm,
  clearFormatting: pm,
  code: mm,
  codeBlockTextStyle: hm,
  codeLanguageAuto: gm,
  collapseSidebar: ym,
  decreaseListIndent: bm,
  deleteColumn: vm,
  deleteRow: wm,
  deleteSelection: Cm,
  deleteTable: Sm,
  heading1TextStyle: xm,
  heading2TextStyle: Tm,
  heading3TextStyle: km,
  highlight: Am,
  horizontalLine: Em,
  image: Om,
  increaseListIndent: $m,
  insert: Rm,
  insertColumnLeft: Im,
  insertColumnRight: Mm,
  insertImageDialogTitle: Pm,
  insertRowAbove: Nm,
  insertRowBelow: Lm,
  insertYoutubeVideoDialogSubmit: Dm,
  insertYoutubeVideoDialogTitle: Fm,
  invalidUrl: Bm,
  italic: _m,
  justify: zm,
  leftAlign: Vm,
  linkInputPlaceholder: jm,
  moreTextStyles: Hm,
  normalTextStyle: Um,
  openLink: Wm,
  orderedList: qm,
  quoteTextStyle: Km,
  redo: Ym,
  reset: Gm,
  rightAlign: Jm,
  save: Zm,
  slashCommands: Xm,
  strikethrough: Qm,
  subscript: eh,
  superscript: th,
  table: nh,
  tableStyle: rh,
  taskList: oh,
  textColor: ih,
  textContentTypeContentSection: sh,
  textContentTypeTitlesSection: ah,
  textDecorations: lh,
  textStylePanelTitle: ch,
  toggleHeaderCell: uh,
  toggleHeaderColumn: dh,
  toggleHeaderRow: fh,
  underline: ph,
  undo: mh,
  uploadingImage: hh,
  urlInputLabel: gh,
  youtube: yh
}, bh = "Actions", vh = "Insérer un lien", wh = "Corps", Ch = "Gras", Sh = "Liste à puces", xh = "Annuler", Th = "Légende", kh = "Couleur de fond", Ah = "Centrer", Eh = "Effacer la mise en forme", Oh = "Code", $h = "Bloc de code", Rh = "Auto", Ih = "Réduire", Mh = "Insérer un lien", Ph = "Réduire le retrait", Nh = "Supprimer la colonne", Lh = "Supprimer la ligne", Dh = "Supprimer la sélection", Fh = "Supprimer le tableau", Bh = "Modifier un lien", _h = "Titre", zh = "Sous-titre", Vh = "En-tête", jh = "Surlignage", Hh = "Ligne horizontale", Uh = "Image", Wh = "Augmenter le retrait", qh = "Insérer", Kh = "Insérer une colonne à gauche", Yh = "Insérer une colonne à droite", Gh = "Insérer une image", Jh = "Insérer une ligne au-dessus", Zh = "Insérer une ligne en dessous", Xh = "Insérer", Qh = "Insérer une vidéo Youtube", eg = "Veuillez entrer un URL valide", tg = "Italique", ng = "Justifier", rg = "Aligner à gauche", og = "Copier un lien, par exemple, www.google.com", ig = "Autres options de style", sg = "Normal", ag = "Ouvrir le lien dans un nouvel onglet", lg = "Liste numérotée", cg = "Citation", ug = "Rétablir", dg = "Réinitialiser", fg = "Aligner à droite", pg = "Sauvegarder", mg = {
  insertHorizontalLine: "Ligne horizontale",
  insertImage: "Image",
  insertTable: "Tableau {{count}}x{{count}}",
  insertYoutubeVideo: "Vidéo Youtube"
}, hg = "Barré", gg = "Indice", yg = "Exposant", bg = "Tableau", vg = {
  cellFillColor: "Couleur de fond",
  includeColumnHeader: "Colonne d’en-tête",
  includeHeaderSection: "En-tête",
  includeRowHeader: "Ligne d’en-tête",
  numberOfColumns: "Colonnes",
  numberOfRows: "Lignes",
  panelTitle: "Style de tableu",
  textColor: "Couleur du texte",
  textStyleSection: "Style du texte"
}, wg = "Liste de contrôle", Cg = "Couleur", Sg = "Contenu", xg = "Titres", Tg = "Décorations", kg = "Style", Ag = "Basculer l’en-tête pour la cellule", Eg = "Basculer l’en-tête pour la colonne", Og = "Basculer l’en-tête pour la ligne", $g = "Souligner", Rg = "Effacer", Ig = "Téléversement de l’image…", Mg = "Entrer l’URL", Pg = "Vidéo Youtube", vl = {
  actionsPanelTitle: bh,
  addLinkDialogTitle: vh,
  body: wh,
  bold: Ch,
  bulletList: Sh,
  cancel: xh,
  caption: Th,
  cellBackgroundColor: kh,
  centerAlign: Ah,
  clearFormatting: Eh,
  code: Oh,
  codeBlockTextStyle: $h,
  codeLanguageAuto: Rh,
  collapseSidebar: Ih,
  createLink: Mh,
  decreaseListIndent: Ph,
  deleteColumn: Nh,
  deleteRow: Lh,
  deleteSelection: Dh,
  deleteTable: Fh,
  editLinkDialogTitle: Bh,
  heading1TextStyle: _h,
  heading2TextStyle: zh,
  heading3TextStyle: Vh,
  highlight: jh,
  horizontalLine: Hh,
  image: Uh,
  increaseListIndent: Wh,
  insert: qh,
  insertColumnLeft: Kh,
  insertColumnRight: Yh,
  insertImageDialogTitle: Gh,
  insertRowAbove: Jh,
  insertRowBelow: Zh,
  insertYoutubeVideoDialogSubmit: Xh,
  insertYoutubeVideoDialogTitle: Qh,
  invalidUrl: eg,
  italic: tg,
  justify: ng,
  leftAlign: rg,
  linkInputPlaceholder: og,
  moreTextStyles: ig,
  normalTextStyle: sg,
  openLink: ag,
  orderedList: lg,
  quoteTextStyle: cg,
  redo: ug,
  reset: dg,
  rightAlign: fg,
  save: pg,
  slashCommands: mg,
  strikethrough: hg,
  subscript: gg,
  superscript: yg,
  table: bg,
  tableStyle: vg,
  taskList: wg,
  textColor: Cg,
  textContentTypeContentSection: Sg,
  textContentTypeTitlesSection: xg,
  textDecorations: Tg,
  textStylePanelTitle: kg,
  toggleHeaderCell: Ag,
  toggleHeaderColumn: Eg,
  toggleHeaderRow: Og,
  underline: $g,
  undo: Rg,
  uploadingImage: Ig,
  urlInputLabel: Mg,
  youtube: Pg
};
Vt.use($a).init({
  fallbackLng: "en",
  lng: "en",
  interpolation: { escapeValue: !0 },
  resources: {
    en: { translation: bl },
    fr: { translation: vl }
  }
});
async function Ng(t) {
  await Vt.changeLanguage(t);
}
const zn = new bt({
  state: {
    init() {
      return Ia.empty;
    },
    apply(t, e) {
      e = e.map(t.mapping, t.doc);
      const n = t.getMeta(this);
      if (n && n.add) {
        const r = document.createElement("image-placeholder");
        r.innerText = Vt.t("uploadingImage");
        const o = Ma.widget(n.add.pos, r, { id: n.add.id });
        e = e.add(t.doc, [o]);
      } else n && n.remove && (e = e.remove(e.find(void 0, void 0, (r) => r.id == n.remove.id)));
      return e;
    }
  },
  props: {
    decorations(t) {
      return this.getState(t);
    }
  }
});
function Lg(t, e) {
  var o;
  const n = zn.getState(t), r = n == null ? void 0 : n.find(void 0, void 0, (i) => i.id == e);
  return (o = r == null ? void 0 : r.at(0)) == null ? void 0 : o.from;
}
const Dg = Le.create({
  name: "imagePlaceholder",
  addProseMirrorPlugins() {
    return [zn];
  }
}), Fg = ({
  node: {
    attrs: { language: t }
  },
  updateAttributes: e,
  extension: n,
  editor: r
}) => {
  var s;
  const o = ut(), { t: i } = ee();
  return Je(() => {
    o.palette.mode === "light" ? Promise.resolve({               }) : Promise.resolve({                    });
  }, [o]), /* @__PURE__ */ _(wa, { className: "rte-code-block", children: [
    r.isEditable ? /* @__PURE__ */ _(
      ou,
      {
        slotProps: { input: { sx: { py: 0.5, px: 1.5 } } },
        size: "small",
        className: "rte-code-block-language-select",
        variant: "outlined",
        value: t ?? "null",
        onChange: (a) => e({ language: a.target.value }),
        disabled: !r.isEditable,
        children: [
          /* @__PURE__ */ p(Ut, { value: "null", children: i("codeLanguageAuto") }),
          /* @__PURE__ */ p(Et, {}),
          n.options.lowlight.listLanguages().map((a, l) => {
            var c;
            return /* @__PURE__ */ p(Ut, { value: a, children: ((c = zi.getLanguage(a)) == null ? void 0 : c.name) ?? a }, l);
          })
        ]
      }
    ) : /* @__PURE__ */ p(it, { variant: "caption", className: "rte-code-block-language-label", color: "textSecondary", children: t != null ? ((s = zi.getLanguage(t)) == null ? void 0 : s.name) ?? "" : "" }),
    /* @__PURE__ */ p("pre", { children: /* @__PURE__ */ p(pu, { as: "code" }) })
  ] });
};
var Cr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function wl(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Fo = { exports: {} }, Sr = { exports: {} }, oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qi;
function Bg() {
  if (Qi) return oe;
  Qi = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, d = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, C = t ? Symbol.for("react.responder") : 60118, R = t ? Symbol.for("react.scope") : 60119;
  function E(w) {
    if (typeof w == "object" && w !== null) {
      var x = w.$$typeof;
      switch (x) {
        case e:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case b:
                case g:
                case s:
                  return w;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function y(w) {
    return E(w) === c;
  }
  return oe.AsyncMode = l, oe.ConcurrentMode = c, oe.ContextConsumer = a, oe.ContextProvider = s, oe.Element = e, oe.ForwardRef = u, oe.Fragment = r, oe.Lazy = b, oe.Memo = g, oe.Portal = n, oe.Profiler = i, oe.StrictMode = o, oe.Suspense = f, oe.isAsyncMode = function(w) {
    return y(w) || E(w) === l;
  }, oe.isConcurrentMode = y, oe.isContextConsumer = function(w) {
    return E(w) === a;
  }, oe.isContextProvider = function(w) {
    return E(w) === s;
  }, oe.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, oe.isForwardRef = function(w) {
    return E(w) === u;
  }, oe.isFragment = function(w) {
    return E(w) === r;
  }, oe.isLazy = function(w) {
    return E(w) === b;
  }, oe.isMemo = function(w) {
    return E(w) === g;
  }, oe.isPortal = function(w) {
    return E(w) === n;
  }, oe.isProfiler = function(w) {
    return E(w) === i;
  }, oe.isStrictMode = function(w) {
    return E(w) === o;
  }, oe.isSuspense = function(w) {
    return E(w) === f;
  }, oe.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === i || w === o || w === f || w === m || typeof w == "object" && w !== null && (w.$$typeof === b || w.$$typeof === g || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === v || w.$$typeof === C || w.$$typeof === R || w.$$typeof === d);
  }, oe.typeOf = E, oe;
}
var ie = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var es;
function _g() {
  return es || (es = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, d = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, C = t ? Symbol.for("react.responder") : 60118, R = t ? Symbol.for("react.scope") : 60119;
    function E(N) {
      return typeof N == "string" || typeof N == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      N === r || N === c || N === i || N === o || N === f || N === m || typeof N == "object" && N !== null && (N.$$typeof === b || N.$$typeof === g || N.$$typeof === s || N.$$typeof === a || N.$$typeof === u || N.$$typeof === v || N.$$typeof === C || N.$$typeof === R || N.$$typeof === d);
    }
    function y(N) {
      if (typeof N == "object" && N !== null) {
        var Oe = N.$$typeof;
        switch (Oe) {
          case e:
            var dt = N.type;
            switch (dt) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case f:
                return dt;
              default:
                var It = dt && dt.$$typeof;
                switch (It) {
                  case a:
                  case u:
                  case b:
                  case g:
                  case s:
                    return It;
                  default:
                    return Oe;
                }
            }
          case n:
            return Oe;
        }
      }
    }
    var w = l, x = c, L = a, D = s, F = e, h = u, O = r, I = b, P = g, z = n, re = i, Q = o, se = f, ue = !1;
    function Ee(N) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(N) || y(N) === l;
    }
    function $(N) {
      return y(N) === c;
    }
    function M(N) {
      return y(N) === a;
    }
    function H(N) {
      return y(N) === s;
    }
    function q(N) {
      return typeof N == "object" && N !== null && N.$$typeof === e;
    }
    function V(N) {
      return y(N) === u;
    }
    function K(N) {
      return y(N) === r;
    }
    function U(N) {
      return y(N) === b;
    }
    function Y(N) {
      return y(N) === g;
    }
    function J(N) {
      return y(N) === n;
    }
    function X(N) {
      return y(N) === i;
    }
    function Z(N) {
      return y(N) === o;
    }
    function we(N) {
      return y(N) === f;
    }
    ie.AsyncMode = w, ie.ConcurrentMode = x, ie.ContextConsumer = L, ie.ContextProvider = D, ie.Element = F, ie.ForwardRef = h, ie.Fragment = O, ie.Lazy = I, ie.Memo = P, ie.Portal = z, ie.Profiler = re, ie.StrictMode = Q, ie.Suspense = se, ie.isAsyncMode = Ee, ie.isConcurrentMode = $, ie.isContextConsumer = M, ie.isContextProvider = H, ie.isElement = q, ie.isForwardRef = V, ie.isFragment = K, ie.isLazy = U, ie.isMemo = Y, ie.isPortal = J, ie.isProfiler = X, ie.isStrictMode = Z, ie.isSuspense = we, ie.isValidElementType = E, ie.typeOf = y;
  }()), ie;
}
var ts;
function Cl() {
  return ts || (ts = 1, process.env.NODE_ENV === "production" ? Sr.exports = Bg() : Sr.exports = _g()), Sr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wo, ns;
function zg() {
  if (ns) return wo;
  ns = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return wo = o() ? Object.assign : function(i, s) {
    for (var a, l = r(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var f in a)
        e.call(a, f) && (l[f] = a[f]);
      if (t) {
        c = t(a);
        for (var m = 0; m < c.length; m++)
          n.call(a, c[m]) && (l[c[m]] = a[c[m]]);
      }
    }
    return l;
  }, wo;
}
var Co, rs;
function fi() {
  if (rs) return Co;
  rs = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Co = t, Co;
}
var So, is;
function Sl() {
  return is || (is = 1, So = Function.call.bind(Object.prototype.hasOwnProperty)), So;
}
var xo, ss;
function Vg() {
  if (ss) return xo;
  ss = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = fi(), n = {}, r = Sl();
    t = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var m = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            f = i[u](s, u, l, a, null, e);
          } catch (b) {
            f = b;
          }
          if (f && !(f instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var g = c ? c() : "";
            t(
              "Failed " + a + " type: " + f.message + (g ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, xo = o, xo;
}
var To, as;
function jg() {
  if (as) return To;
  as = 1;
  var t = Cl(), e = zg(), n = fi(), r = Sl(), o = Vg(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return To = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f($) {
      var M = $ && (c && $[c] || $[u]);
      if (typeof M == "function")
        return M;
    }
    var m = "<<anonymous>>", g = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: R(),
      arrayOf: E,
      element: y(),
      elementType: w(),
      instanceOf: x,
      node: h(),
      objectOf: D,
      oneOf: L,
      oneOfType: F,
      shape: I,
      exact: P
    };
    function b($, M) {
      return $ === M ? $ !== 0 || 1 / $ === 1 / M : $ !== $ && M !== M;
    }
    function d($, M) {
      this.message = $, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    d.prototype = Error.prototype;
    function v($) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, H = 0;
      function q(K, U, Y, J, X, Z, we) {
        if (J = J || m, Z = Z || Y, we !== n) {
          if (l) {
            var N = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw N.name = "Invariant Violation", N;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Oe = J + ":" + Y;
            !M[Oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Z + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), M[Oe] = !0, H++);
          }
        }
        return U[Y] == null ? K ? U[Y] === null ? new d("The " + X + " `" + Z + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new d("The " + X + " `" + Z + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : $(U, Y, J, X, Z);
      }
      var V = q.bind(null, !1);
      return V.isRequired = q.bind(null, !0), V;
    }
    function C($) {
      function M(H, q, V, K, U, Y) {
        var J = H[q], X = Q(J);
        if (X !== $) {
          var Z = se(J);
          return new d(
            "Invalid " + K + " `" + U + "` of type " + ("`" + Z + "` supplied to `" + V + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return v(M);
    }
    function R() {
      return v(s);
    }
    function E($) {
      function M(H, q, V, K, U) {
        if (typeof $ != "function")
          return new d("Property `" + U + "` of component `" + V + "` has invalid PropType notation inside arrayOf.");
        var Y = H[q];
        if (!Array.isArray(Y)) {
          var J = Q(Y);
          return new d("Invalid " + K + " `" + U + "` of type " + ("`" + J + "` supplied to `" + V + "`, expected an array."));
        }
        for (var X = 0; X < Y.length; X++) {
          var Z = $(Y, X, V, K, U + "[" + X + "]", n);
          if (Z instanceof Error)
            return Z;
        }
        return null;
      }
      return v(M);
    }
    function y() {
      function $(M, H, q, V, K) {
        var U = M[H];
        if (!a(U)) {
          var Y = Q(U);
          return new d("Invalid " + V + " `" + K + "` of type " + ("`" + Y + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v($);
    }
    function w() {
      function $(M, H, q, V, K) {
        var U = M[H];
        if (!t.isValidElementType(U)) {
          var Y = Q(U);
          return new d("Invalid " + V + " `" + K + "` of type " + ("`" + Y + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v($);
    }
    function x($) {
      function M(H, q, V, K, U) {
        if (!(H[q] instanceof $)) {
          var Y = $.name || m, J = Ee(H[q]);
          return new d("Invalid " + K + " `" + U + "` of type " + ("`" + J + "` supplied to `" + V + "`, expected ") + ("instance of `" + Y + "`."));
        }
        return null;
      }
      return v(M);
    }
    function L($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function M(H, q, V, K, U) {
        for (var Y = H[q], J = 0; J < $.length; J++)
          if (b(Y, $[J]))
            return null;
        var X = JSON.stringify($, function(we, N) {
          var Oe = se(N);
          return Oe === "symbol" ? String(N) : N;
        });
        return new d("Invalid " + K + " `" + U + "` of value `" + String(Y) + "` " + ("supplied to `" + V + "`, expected one of " + X + "."));
      }
      return v(M);
    }
    function D($) {
      function M(H, q, V, K, U) {
        if (typeof $ != "function")
          return new d("Property `" + U + "` of component `" + V + "` has invalid PropType notation inside objectOf.");
        var Y = H[q], J = Q(Y);
        if (J !== "object")
          return new d("Invalid " + K + " `" + U + "` of type " + ("`" + J + "` supplied to `" + V + "`, expected an object."));
        for (var X in Y)
          if (r(Y, X)) {
            var Z = $(Y, X, V, K, U + "." + X, n);
            if (Z instanceof Error)
              return Z;
          }
        return null;
      }
      return v(M);
    }
    function F($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var M = 0; M < $.length; M++) {
        var H = $[M];
        if (typeof H != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(H) + " at index " + M + "."
          ), s;
      }
      function q(V, K, U, Y, J) {
        for (var X = [], Z = 0; Z < $.length; Z++) {
          var we = $[Z], N = we(V, K, U, Y, J, n);
          if (N == null)
            return null;
          N.data && r(N.data, "expectedType") && X.push(N.data.expectedType);
        }
        var Oe = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new d("Invalid " + Y + " `" + J + "` supplied to " + ("`" + U + "`" + Oe + "."));
      }
      return v(q);
    }
    function h() {
      function $(M, H, q, V, K) {
        return z(M[H]) ? null : new d("Invalid " + V + " `" + K + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return v($);
    }
    function O($, M, H, q, V) {
      return new d(
        ($ || "React class") + ": " + M + " type `" + H + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V + "`."
      );
    }
    function I($) {
      function M(H, q, V, K, U) {
        var Y = H[q], J = Q(Y);
        if (J !== "object")
          return new d("Invalid " + K + " `" + U + "` of type `" + J + "` " + ("supplied to `" + V + "`, expected `object`."));
        for (var X in $) {
          var Z = $[X];
          if (typeof Z != "function")
            return O(V, K, U, X, se(Z));
          var we = Z(Y, X, V, K, U + "." + X, n);
          if (we)
            return we;
        }
        return null;
      }
      return v(M);
    }
    function P($) {
      function M(H, q, V, K, U) {
        var Y = H[q], J = Q(Y);
        if (J !== "object")
          return new d("Invalid " + K + " `" + U + "` of type `" + J + "` " + ("supplied to `" + V + "`, expected `object`."));
        var X = e({}, H[q], $);
        for (var Z in X) {
          var we = $[Z];
          if (r($, Z) && typeof we != "function")
            return O(V, K, U, Z, se(we));
          if (!we)
            return new d(
              "Invalid " + K + " `" + U + "` key `" + Z + "` supplied to `" + V + "`.\nBad object: " + JSON.stringify(H[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var N = we(Y, Z, V, K, U + "." + Z, n);
          if (N)
            return N;
        }
        return null;
      }
      return v(M);
    }
    function z($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(z);
          if ($ === null || a($))
            return !0;
          var M = f($);
          if (M) {
            var H = M.call($), q;
            if (M !== $.entries) {
              for (; !(q = H.next()).done; )
                if (!z(q.value))
                  return !1;
            } else
              for (; !(q = H.next()).done; ) {
                var V = q.value;
                if (V && !z(V[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re($, M) {
      return $ === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function Q($) {
      var M = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : re(M, $) ? "symbol" : M;
    }
    function se($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var M = Q($);
      if (M === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function ue($) {
      var M = se($);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function Ee($) {
      return !$.constructor || !$.constructor.name ? m : $.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, To;
}
var ko, ls;
function Hg() {
  if (ls) return ko;
  ls = 1;
  var t = fi();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, ko = function() {
    function r(s, a, l, c, u, f) {
      if (f !== t) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, ko;
}
if (process.env.NODE_ENV !== "production") {
  var Ug = Cl(), Wg = !0;
  Fo.exports = jg()(Ug.isElement, Wg);
} else
  Fo.exports = Hg()();
var qg = Fo.exports;
const S = /* @__PURE__ */ wl(qg);
function Kg(t, e) {
  var n, r, o;
  return /* @__PURE__ */ et.isValidElement(t) && e.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    t.type.muiName ?? ((o = (r = (n = t.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : o.muiName)
  ) !== -1;
}
const cs = (t) => t, Yg = () => {
  let t = cs;
  return {
    configure(e) {
      t = e;
    },
    generate(e) {
      return t(e);
    },
    reset() {
      t = cs;
    }
  };
}, Gg = Yg(), Jg = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function xl(t, e, n = "Mui") {
  const r = Jg[e];
  return r ? `${n}-${r}` : `${Gg.generate(t)}-${e}`;
}
function Zg(t, e, n = void 0) {
  const r = {};
  for (const o in t) {
    const i = t[o];
    let s = "", a = !0;
    for (let l = 0; l < i.length; l += 1) {
      const c = i[l];
      c && (s += (a === !0 ? "" : " ") + e(c), a = !1, n && n[c] && (s += " " + n[c]));
    }
    r[o] = s;
  }
  return r;
}
function Xg(t) {
  for (var e = 0, n, r = 0, o = t.length; o >= 4; ++r, o -= 4)
    n = t.charCodeAt(r) & 255 | (t.charCodeAt(++r) & 255) << 8 | (t.charCodeAt(++r) & 255) << 16 | (t.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, e = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      e ^= (t.charCodeAt(r + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(r + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(r) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Qg = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function ey(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var ty = /[A-Z]|^ms/g, ny = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Tl = function(e) {
  return e.charCodeAt(1) === 45;
}, us = function(e) {
  return e != null && typeof e != "boolean";
}, Ao = /* @__PURE__ */ ey(function(t) {
  return Tl(t) ? t : t.replace(ty, "-$&").toLowerCase();
}), ds = function(e, n) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ny, function(r, o, i) {
          return Ct = {
            name: o,
            styles: i,
            next: Ct
          }, o;
        });
  }
  return Qg[e] !== 1 && !Tl(e) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Fr(t, e, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return Ct = {
          name: o.name,
          styles: o.styles,
          next: Ct
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Ct = {
              name: s.name,
              styles: s.styles,
              next: Ct
            }, s = s.next;
        var a = i.styles + ";";
        return a;
      }
      return ry(t, e, n);
    }
  }
  var l = n;
  if (e == null)
    return l;
  var c = e[l];
  return c !== void 0 ? c : l;
}
function ry(t, e, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Fr(t, e, n[o]) + ";";
  else
    for (var i in n) {
      var s = n[i];
      if (typeof s != "object") {
        var a = s;
        e != null && e[a] !== void 0 ? r += i + "{" + e[a] + "}" : us(a) && (r += Ao(i) + ":" + ds(i, a) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (e == null || e[s[0]] === void 0))
        for (var l = 0; l < s.length; l++)
          us(s[l]) && (r += Ao(i) + ":" + ds(i, s[l]) + ";");
      else {
        var c = Fr(t, e, s);
        switch (i) {
          case "animation":
          case "animationName": {
            r += Ao(i) + ":" + c + ";";
            break;
          }
          default:
            r += i + "{" + c + "}";
        }
      }
    }
  return r;
}
var fs = /label:\s*([^\s;{]+)\s*(;|$)/g, Ct;
function kl(t, e, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var r = !0, o = "";
  Ct = void 0;
  var i = t[0];
  if (i == null || i.raw === void 0)
    r = !1, o += Fr(n, e, i);
  else {
    var s = i;
    o += s[0];
  }
  for (var a = 1; a < t.length; a++)
    if (o += Fr(n, e, t[a]), r) {
      var l = i;
      o += l[a];
    }
  fs.lastIndex = 0;
  for (var c = "", u; (u = fs.exec(o)) !== null; )
    c += "-" + u[1];
  var f = Xg(o) + c;
  return {
    name: f,
    styles: o,
    next: Ct
  };
}
/**
 * @mui/styled-engine v6.4.8
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function oy(t, e) {
  const n = Kd(t, e);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof t == "string" ? `"${t}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function iy(t, e) {
  Array.isArray(t.__emotion_styles) && (t.__emotion_styles = e(t.__emotion_styles));
}
const ps = [];
function ms(t) {
  return ps[0] = t, kl(ps);
}
var Bo = { exports: {} }, le = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hs;
function sy() {
  if (hs) return le;
  hs = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), s = Symbol.for("react.context"), a = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = Symbol.for("react.client.reference");
  function b(d) {
    if (typeof d == "object" && d !== null) {
      var v = d.$$typeof;
      switch (v) {
        case t:
          switch (d = d.type, d) {
            case n:
            case o:
            case r:
            case l:
            case c:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case s:
                case a:
                case f:
                case u:
                  return d;
                case i:
                  return d;
                default:
                  return v;
              }
          }
        case e:
          return v;
      }
    }
  }
  return le.ContextConsumer = i, le.ContextProvider = s, le.Element = t, le.ForwardRef = a, le.Fragment = n, le.Lazy = f, le.Memo = u, le.Portal = e, le.Profiler = o, le.StrictMode = r, le.Suspense = l, le.SuspenseList = c, le.isContextConsumer = function(d) {
    return b(d) === i;
  }, le.isContextProvider = function(d) {
    return b(d) === s;
  }, le.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === t;
  }, le.isForwardRef = function(d) {
    return b(d) === a;
  }, le.isFragment = function(d) {
    return b(d) === n;
  }, le.isLazy = function(d) {
    return b(d) === f;
  }, le.isMemo = function(d) {
    return b(d) === u;
  }, le.isPortal = function(d) {
    return b(d) === e;
  }, le.isProfiler = function(d) {
    return b(d) === o;
  }, le.isStrictMode = function(d) {
    return b(d) === r;
  }, le.isSuspense = function(d) {
    return b(d) === l;
  }, le.isSuspenseList = function(d) {
    return b(d) === c;
  }, le.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === n || d === o || d === r || d === l || d === c || d === m || typeof d == "object" && d !== null && (d.$$typeof === f || d.$$typeof === u || d.$$typeof === s || d.$$typeof === i || d.$$typeof === a || d.$$typeof === g || d.getModuleId !== void 0);
  }, le.typeOf = b, le;
}
var ce = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gs;
function ay() {
  return gs || (gs = 1, process.env.NODE_ENV !== "production" && function() {
    function t(d) {
      if (typeof d == "object" && d !== null) {
        var v = d.$$typeof;
        switch (v) {
          case e:
            switch (d = d.type, d) {
              case r:
              case i:
              case o:
              case c:
              case u:
                return d;
              default:
                switch (d = d && d.$$typeof, d) {
                  case a:
                  case l:
                  case m:
                  case f:
                    return d;
                  case s:
                    return d;
                  default:
                    return v;
                }
            }
          case n:
            return v;
        }
      }
    }
    var e = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), b = Symbol.for("react.client.reference");
    ce.ContextConsumer = s, ce.ContextProvider = a, ce.Element = e, ce.ForwardRef = l, ce.Fragment = r, ce.Lazy = m, ce.Memo = f, ce.Portal = n, ce.Profiler = i, ce.StrictMode = o, ce.Suspense = c, ce.SuspenseList = u, ce.isContextConsumer = function(d) {
      return t(d) === s;
    }, ce.isContextProvider = function(d) {
      return t(d) === a;
    }, ce.isElement = function(d) {
      return typeof d == "object" && d !== null && d.$$typeof === e;
    }, ce.isForwardRef = function(d) {
      return t(d) === l;
    }, ce.isFragment = function(d) {
      return t(d) === r;
    }, ce.isLazy = function(d) {
      return t(d) === m;
    }, ce.isMemo = function(d) {
      return t(d) === f;
    }, ce.isPortal = function(d) {
      return t(d) === n;
    }, ce.isProfiler = function(d) {
      return t(d) === i;
    }, ce.isStrictMode = function(d) {
      return t(d) === o;
    }, ce.isSuspense = function(d) {
      return t(d) === c;
    }, ce.isSuspenseList = function(d) {
      return t(d) === u;
    }, ce.isValidElementType = function(d) {
      return typeof d == "string" || typeof d == "function" || d === r || d === i || d === o || d === c || d === u || d === g || typeof d == "object" && d !== null && (d.$$typeof === m || d.$$typeof === f || d.$$typeof === a || d.$$typeof === s || d.$$typeof === l || d.$$typeof === b || d.getModuleId !== void 0);
    }, ce.typeOf = t;
  }()), ce;
}
process.env.NODE_ENV === "production" ? Bo.exports = sy() : Bo.exports = ay();
var Br = Bo.exports;
function ot(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function Al(t) {
  if (/* @__PURE__ */ et.isValidElement(t) || Br.isValidElementType(t) || !ot(t))
    return t;
  const e = {};
  return Object.keys(t).forEach((n) => {
    e[n] = Al(t[n]);
  }), e;
}
function je(t, e, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...t
  } : t;
  return ot(t) && ot(e) && Object.keys(e).forEach((o) => {
    /* @__PURE__ */ et.isValidElement(e[o]) || Br.isValidElementType(e[o]) ? r[o] = e[o] : ot(e[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(t, o) && ot(t[o]) ? r[o] = je(t[o], e[o], n) : n.clone ? r[o] = ot(e[o]) ? Al(e[o]) : e[o] : r[o] = e[o];
  }), r;
}
function xt(t, ...e) {
  const n = new URL(`https://mui.com/production-error/?code=${t}`);
  return e.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${t}; visit ${n} for the full message.`;
}
function pi(t) {
  if (typeof t != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : xt(7));
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function El(t, e = "") {
  return t.displayName || t.name || e;
}
function ys(t, e, n) {
  const r = El(e);
  return t.displayName || (r !== "" ? `${n}(${r})` : n);
}
function ly(t) {
  if (t != null) {
    if (typeof t == "string")
      return t;
    if (typeof t == "function")
      return El(t, "Component");
    if (typeof t == "object")
      switch (t.$$typeof) {
        case Br.ForwardRef:
          return ys(t, t.render, "ForwardRef");
        case Br.Memo:
          return ys(t, t.type, "memo");
        default:
          return;
      }
  }
}
const cy = (t) => {
  const e = Object.keys(t).map((n) => ({
    key: n,
    val: t[n]
  })) || [];
  return e.sort((n, r) => n.val - r.val), e.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function uy(t) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: e = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...o
  } = t, i = cy(e), s = Object.keys(i);
  function a(m) {
    return `@media (min-width:${typeof e[m] == "number" ? e[m] : m}${n})`;
  }
  function l(m) {
    return `@media (max-width:${(typeof e[m] == "number" ? e[m] : m) - r / 100}${n})`;
  }
  function c(m, g) {
    const b = s.indexOf(g);
    return `@media (min-width:${typeof e[m] == "number" ? e[m] : m}${n}) and (max-width:${(b !== -1 && typeof e[s[b]] == "number" ? e[s[b]] : g) - r / 100}${n})`;
  }
  function u(m) {
    return s.indexOf(m) + 1 < s.length ? c(m, s[s.indexOf(m) + 1]) : a(m);
  }
  function f(m) {
    const g = s.indexOf(m);
    return g === 0 ? a(s[1]) : g === s.length - 1 ? l(s[g]) : c(m, s[s.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: i,
    up: a,
    down: l,
    between: c,
    only: u,
    not: f,
    unit: n,
    ...o
  };
}
function dy(t, e) {
  if (!t.containerQueries)
    return e;
  const n = Object.keys(e).filter((r) => r.startsWith("@container")).sort((r, o) => {
    var s, a;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((s = r.match(i)) == null ? void 0 : s[1]) || 0) - +(((a = o.match(i)) == null ? void 0 : a[1]) || 0);
  });
  return n.length ? n.reduce((r, o) => {
    const i = e[o];
    return delete r[o], r[o] = i, r;
  }, {
    ...e
  }) : e;
}
function fy(t, e) {
  return e === "@" || e.startsWith("@") && (t.some((n) => e.startsWith(`@${n}`)) || !!e.match(/^@\d/));
}
function py(t, e) {
  const n = e.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${e})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : xt(18, `(${e})`));
    return null;
  }
  const [, r, o] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return t.containerQueries(o).up(i);
}
function my(t) {
  const e = (i, s) => i.replace("@media", s ? `@container ${s}` : "@container");
  function n(i, s) {
    i.up = (...a) => e(t.breakpoints.up(...a), s), i.down = (...a) => e(t.breakpoints.down(...a), s), i.between = (...a) => e(t.breakpoints.between(...a), s), i.only = (...a) => e(t.breakpoints.only(...a), s), i.not = (...a) => {
      const l = e(t.breakpoints.not(...a), s);
      return l.includes("not all and") ? l.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : l;
    };
  }
  const r = {}, o = (i) => (n(r, i), r);
  return n(o), {
    ...t,
    containerQueries: o
  };
}
const hy = {
  borderRadius: 4
}, $t = process.env.NODE_ENV !== "production" ? S.oneOfType([S.number, S.string, S.object, S.array]) : {};
function Vn(t, e) {
  return e ? je(t, e, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : t;
}
const Yr = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, bs = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (t) => `@media (min-width:${Yr[t]}px)`
}, gy = {
  containerQueries: (t) => ({
    up: (e) => {
      let n = typeof e == "number" ? e : Yr[e] || e;
      return typeof n == "number" && (n = `${n}px`), t ? `@container ${t} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function gt(t, e, n) {
  const r = t.theme || {};
  if (Array.isArray(e)) {
    const i = r.breakpoints || bs;
    return e.reduce((s, a, l) => (s[i.up(i.keys[l])] = n(e[l]), s), {});
  }
  if (typeof e == "object") {
    const i = r.breakpoints || bs;
    return Object.keys(e).reduce((s, a) => {
      if (fy(i.keys, a)) {
        const l = py(r.containerQueries ? r : gy, a);
        l && (s[l] = n(e[a], a));
      } else if (Object.keys(i.values || Yr).includes(a)) {
        const l = i.up(a);
        s[l] = n(e[a], a);
      } else {
        const l = a;
        s[l] = e[l];
      }
      return s;
    }, {});
  }
  return n(e);
}
function yy(t = {}) {
  var n;
  return ((n = t.keys) == null ? void 0 : n.reduce((r, o) => {
    const i = t.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function by(t, e) {
  return t.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, e);
}
function Gr(t, e, n = !0) {
  if (!e || typeof e != "string")
    return null;
  if (t && t.vars && n) {
    const r = `vars.${e}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, t);
    if (r != null)
      return r;
  }
  return e.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, t);
}
function _r(t, e, n, r = n) {
  let o;
  return typeof t == "function" ? o = t(n) : Array.isArray(t) ? o = t[n] || r : o = Gr(t, n) || r, e && (o = e(o, r, t)), o;
}
function Se(t) {
  const {
    prop: e,
    cssProperty: n = t.prop,
    themeKey: r,
    transform: o
  } = t, i = (s) => {
    if (s[e] == null)
      return null;
    const a = s[e], l = s.theme, c = Gr(l, r) || {};
    return gt(s, a, (f) => {
      let m = _r(c, o, f);
      return f === m && typeof f == "string" && (m = _r(c, o, `${e}${f === "default" ? "" : pi(f)}`, f)), n === !1 ? m : {
        [n]: m
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [e]: $t
  } : {}, i.filterProps = [e], i;
}
function vy(t) {
  const e = {};
  return (n) => (e[n] === void 0 && (e[n] = t(n)), e[n]);
}
const wy = {
  m: "margin",
  p: "padding"
}, Cy = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, vs = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Sy = vy((t) => {
  if (t.length > 2)
    if (vs[t])
      t = vs[t];
    else
      return [t];
  const [e, n] = t.split(""), r = wy[e], o = Cy[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), Jr = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Zr = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], xy = [...Jr, ...Zr];
function tr(t, e, n, r) {
  const o = Gr(t, e, !0) ?? n;
  return typeof o == "number" || typeof o == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${i}.`), typeof o == "string" ? `calc(${i} * ${o})` : o * i) : Array.isArray(o) ? (i) => {
    if (typeof i == "string")
      return i;
    const s = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > o.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${s} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${e}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${e}\` as a number.`].join(`
`)));
    const a = o[s];
    return i >= 0 ? a : typeof a == "number" ? -a : `-${a}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${e}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function mi(t) {
  return tr(t, "spacing", 8, "spacing");
}
function nr(t, e) {
  return typeof e == "string" || e == null ? e : t(e);
}
function Ty(t, e) {
  return (n) => t.reduce((r, o) => (r[o] = nr(e, n), r), {});
}
function ky(t, e, n, r) {
  if (!e.includes(n))
    return null;
  const o = Sy(n), i = Ty(o, r), s = t[n];
  return gt(t, s, i);
}
function Ol(t, e) {
  const n = mi(t.theme);
  return Object.keys(t).map((r) => ky(t, e, r, n)).reduce(Vn, {});
}
function ge(t) {
  return Ol(t, Jr);
}
ge.propTypes = process.env.NODE_ENV !== "production" ? Jr.reduce((t, e) => (t[e] = $t, t), {}) : {};
ge.filterProps = Jr;
function ye(t) {
  return Ol(t, Zr);
}
ye.propTypes = process.env.NODE_ENV !== "production" ? Zr.reduce((t, e) => (t[e] = $t, t), {}) : {};
ye.filterProps = Zr;
process.env.NODE_ENV !== "production" && xy.reduce((t, e) => (t[e] = $t, t), {});
function $l(t = 8, e = mi({
  spacing: t
})) {
  if (t.mui)
    return t;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const s = e(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function Xr(...t) {
  const e = t.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => e[i] ? Vn(o, e[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? t.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = t.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function qe(t) {
  return typeof t != "number" ? t : `${t}px solid`;
}
function Qe(t, e) {
  return Se({
    prop: t,
    themeKey: "borders",
    transform: e
  });
}
const Ay = Qe("border", qe), Ey = Qe("borderTop", qe), Oy = Qe("borderRight", qe), $y = Qe("borderBottom", qe), Ry = Qe("borderLeft", qe), Iy = Qe("borderColor"), My = Qe("borderTopColor"), Py = Qe("borderRightColor"), Ny = Qe("borderBottomColor"), Ly = Qe("borderLeftColor"), Dy = Qe("outline", qe), Fy = Qe("outlineColor"), Qr = (t) => {
  if (t.borderRadius !== void 0 && t.borderRadius !== null) {
    const e = tr(t.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: nr(e, r)
    });
    return gt(t, t.borderRadius, n);
  }
  return null;
};
Qr.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: $t
} : {};
Qr.filterProps = ["borderRadius"];
Xr(Ay, Ey, Oy, $y, Ry, Iy, My, Py, Ny, Ly, Qr, Dy, Fy);
const eo = (t) => {
  if (t.gap !== void 0 && t.gap !== null) {
    const e = tr(t.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: nr(e, r)
    });
    return gt(t, t.gap, n);
  }
  return null;
};
eo.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: $t
} : {};
eo.filterProps = ["gap"];
const to = (t) => {
  if (t.columnGap !== void 0 && t.columnGap !== null) {
    const e = tr(t.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: nr(e, r)
    });
    return gt(t, t.columnGap, n);
  }
  return null;
};
to.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: $t
} : {};
to.filterProps = ["columnGap"];
const no = (t) => {
  if (t.rowGap !== void 0 && t.rowGap !== null) {
    const e = tr(t.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: nr(e, r)
    });
    return gt(t, t.rowGap, n);
  }
  return null;
};
no.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: $t
} : {};
no.filterProps = ["rowGap"];
const By = Se({
  prop: "gridColumn"
}), _y = Se({
  prop: "gridRow"
}), zy = Se({
  prop: "gridAutoFlow"
}), Vy = Se({
  prop: "gridAutoColumns"
}), jy = Se({
  prop: "gridAutoRows"
}), Hy = Se({
  prop: "gridTemplateColumns"
}), Uy = Se({
  prop: "gridTemplateRows"
}), Wy = Se({
  prop: "gridTemplateAreas"
}), qy = Se({
  prop: "gridArea"
});
Xr(eo, to, no, By, _y, zy, Vy, jy, Hy, Uy, Wy, qy);
function un(t, e) {
  return e === "grey" ? e : t;
}
const Ky = Se({
  prop: "color",
  themeKey: "palette",
  transform: un
}), Yy = Se({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: un
}), Gy = Se({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: un
});
Xr(Ky, Yy, Gy);
function _e(t) {
  return t <= 1 && t !== 0 ? `${t * 100}%` : t;
}
const Jy = Se({
  prop: "width",
  transform: _e
}), hi = (t) => {
  if (t.maxWidth !== void 0 && t.maxWidth !== null) {
    const e = (n) => {
      var o, i, s, a, l;
      const r = ((s = (i = (o = t.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : s[n]) || Yr[n];
      return r ? ((l = (a = t.theme) == null ? void 0 : a.breakpoints) == null ? void 0 : l.unit) !== "px" ? {
        maxWidth: `${r}${t.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: _e(n)
      };
    };
    return gt(t, t.maxWidth, e);
  }
  return null;
};
hi.filterProps = ["maxWidth"];
const Zy = Se({
  prop: "minWidth",
  transform: _e
}), Xy = Se({
  prop: "height",
  transform: _e
}), Qy = Se({
  prop: "maxHeight",
  transform: _e
}), eb = Se({
  prop: "minHeight",
  transform: _e
});
Se({
  prop: "size",
  cssProperty: "width",
  transform: _e
});
Se({
  prop: "size",
  cssProperty: "height",
  transform: _e
});
const tb = Se({
  prop: "boxSizing"
});
Xr(Jy, hi, Zy, Xy, Qy, eb, tb);
const rr = {
  // borders
  border: {
    themeKey: "borders",
    transform: qe
  },
  borderTop: {
    themeKey: "borders",
    transform: qe
  },
  borderRight: {
    themeKey: "borders",
    transform: qe
  },
  borderBottom: {
    themeKey: "borders",
    transform: qe
  },
  borderLeft: {
    themeKey: "borders",
    transform: qe
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: qe
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Qr
  },
  // palette
  color: {
    themeKey: "palette",
    transform: un
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: un
  },
  backgroundColor: {
    themeKey: "palette",
    transform: un
  },
  // spacing
  p: {
    style: ye
  },
  pt: {
    style: ye
  },
  pr: {
    style: ye
  },
  pb: {
    style: ye
  },
  pl: {
    style: ye
  },
  px: {
    style: ye
  },
  py: {
    style: ye
  },
  padding: {
    style: ye
  },
  paddingTop: {
    style: ye
  },
  paddingRight: {
    style: ye
  },
  paddingBottom: {
    style: ye
  },
  paddingLeft: {
    style: ye
  },
  paddingX: {
    style: ye
  },
  paddingY: {
    style: ye
  },
  paddingInline: {
    style: ye
  },
  paddingInlineStart: {
    style: ye
  },
  paddingInlineEnd: {
    style: ye
  },
  paddingBlock: {
    style: ye
  },
  paddingBlockStart: {
    style: ye
  },
  paddingBlockEnd: {
    style: ye
  },
  m: {
    style: ge
  },
  mt: {
    style: ge
  },
  mr: {
    style: ge
  },
  mb: {
    style: ge
  },
  ml: {
    style: ge
  },
  mx: {
    style: ge
  },
  my: {
    style: ge
  },
  margin: {
    style: ge
  },
  marginTop: {
    style: ge
  },
  marginRight: {
    style: ge
  },
  marginBottom: {
    style: ge
  },
  marginLeft: {
    style: ge
  },
  marginX: {
    style: ge
  },
  marginY: {
    style: ge
  },
  marginInline: {
    style: ge
  },
  marginInlineStart: {
    style: ge
  },
  marginInlineEnd: {
    style: ge
  },
  marginBlock: {
    style: ge
  },
  marginBlockStart: {
    style: ge
  },
  marginBlockEnd: {
    style: ge
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (t) => ({
      "@media print": {
        display: t
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: eo
  },
  rowGap: {
    style: no
  },
  columnGap: {
    style: to
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: _e
  },
  maxWidth: {
    style: hi
  },
  minWidth: {
    transform: _e
  },
  height: {
    transform: _e
  },
  maxHeight: {
    transform: _e
  },
  minHeight: {
    transform: _e
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function nb(...t) {
  const e = t.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(e);
  return t.every((r) => n.size === Object.keys(r).length);
}
function rb(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ob() {
  function t(n, r, o, i) {
    const s = {
      [n]: r,
      theme: o
    }, a = i[n];
    if (!a)
      return {
        [n]: r
      };
    const {
      cssProperty: l = n,
      themeKey: c,
      transform: u,
      style: f
    } = a;
    if (r == null)
      return null;
    if (c === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const m = Gr(o, c) || {};
    return f ? f(s) : gt(s, r, (b) => {
      let d = _r(m, u, b);
      return b === d && typeof b == "string" && (d = _r(m, u, `${n}${b === "default" ? "" : pi(b)}`, b)), l === !1 ? d : {
        [l]: d
      };
    });
  }
  function e(n) {
    const {
      sx: r,
      theme: o = {}
    } = n || {};
    if (!r)
      return null;
    const i = o.unstable_sxConfig ?? rr;
    function s(a) {
      let l = a;
      if (typeof a == "function")
        l = a(o);
      else if (typeof a != "object")
        return a;
      if (!l)
        return null;
      const c = yy(o.breakpoints), u = Object.keys(c);
      let f = c;
      return Object.keys(l).forEach((m) => {
        const g = rb(l[m], o);
        if (g != null)
          if (typeof g == "object")
            if (i[m])
              f = Vn(f, t(m, g, o, i));
            else {
              const b = gt({
                theme: o
              }, g, (d) => ({
                [m]: d
              }));
              nb(b, g) ? f[m] = e({
                sx: g,
                theme: o
              }) : f = Vn(f, b);
            }
          else
            f = Vn(f, t(m, g, o, i));
      }), dy(o, by(u, f));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return e;
}
const gn = ob();
gn.filterProps = ["sx"];
function ib(t, e) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[t]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let o = n.getColorSchemeSelector(t);
    return o === "&" ? e : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: e
    });
  }
  return n.palette.mode === t ? e : {};
}
function ro(t = {}, ...e) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {},
    ...s
  } = t, a = uy(n), l = $l(o);
  let c = je({
    breakpoints: a,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: l,
    shape: {
      ...hy,
      ...i
    }
  }, s);
  return c = my(c), c.applyStyles = ib, c = e.reduce((u, f) => je(u, f), c), c.unstable_sxConfig = {
    ...rr,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, c.unstable_sx = function(f) {
    return gn({
      sx: f,
      theme: this
    });
  }, c;
}
const sb = (t) => {
  var r;
  const e = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = t == null ? void 0 : t.theme) == null ? void 0 : r.unstable_sxConfig) ?? rr;
  return Object.keys(t).forEach((o) => {
    n[o] ? e.systemProps[o] = t[o] : e.otherProps[o] = t[o];
  }), e;
};
function ab(t) {
  const {
    sx: e,
    ...n
  } = t, {
    systemProps: r,
    otherProps: o
  } = sb(n);
  let i;
  return Array.isArray(e) ? i = [r, ...e] : typeof e == "function" ? i = (...s) => {
    const a = e(...s);
    return ot(a) ? {
      ...r,
      ...a
    } : r;
  } : i = {
    ...r,
    ...e
  }, {
    ...o,
    sx: i
  };
}
function lb(t) {
  const {
    variants: e,
    ...n
  } = t, r = {
    variants: e,
    style: ms(n),
    isProcessed: !0
  };
  return r.style === n || e && e.forEach((o) => {
    typeof o.style != "function" && (o.style = ms(o.style));
  }), r;
}
const cb = ro();
function Eo(t) {
  return t !== "ownerState" && t !== "theme" && t !== "sx" && t !== "as";
}
function ub(t) {
  return t ? (e, n) => n[t] : null;
}
function db(t, e, n) {
  t.theme = mb(t.theme) ? n : t.theme[e] || t.theme;
}
function Ir(t, e) {
  const n = typeof e == "function" ? e(t) : e;
  if (Array.isArray(n))
    return n.flatMap((r) => Ir(t, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: o,
        ...i
      } = n;
      r = i;
    }
    return Rl(t, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function Rl(t, e, n = []) {
  var o;
  let r;
  e: for (let i = 0; i < e.length; i += 1) {
    const s = e[i];
    if (typeof s.props == "function") {
      if (r ?? (r = {
        ...t,
        ...t.ownerState,
        ownerState: t.ownerState
      }), !s.props(r))
        continue;
    } else
      for (const a in s.props)
        if (t[a] !== s.props[a] && ((o = t.ownerState) == null ? void 0 : o[a]) !== s.props[a])
          continue e;
    typeof s.style == "function" ? (r ?? (r = {
      ...t,
      ...t.ownerState,
      ownerState: t.ownerState
    }), n.push(s.style(r))) : n.push(s.style);
  }
  return n;
}
function Il(t = {}) {
  const {
    themeId: e,
    defaultTheme: n = cb,
    rootShouldForwardProp: r = Eo,
    slotShouldForwardProp: o = Eo
  } = t;
  function i(a) {
    db(a, e, n);
  }
  return (a, l = {}) => {
    iy(a, (w) => w.filter((x) => x !== gn));
    const {
      name: c,
      slot: u,
      skipVariantsResolver: f,
      skipSx: m,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: g = ub(Ml(u)),
      ...b
    } = l, d = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      u && u !== "Root" && u !== "root" || !1
    ), v = m || !1;
    let C = Eo;
    u === "Root" || u === "root" ? C = r : u ? C = o : hb(a) && (C = void 0);
    const R = oy(a, {
      shouldForwardProp: C,
      label: pb(c, u),
      ...b
    }), E = (w) => {
      if (typeof w == "function" && w.__emotion_real !== w)
        return function(L) {
          return Ir(L, w);
        };
      if (ot(w)) {
        const x = lb(w);
        return x.variants ? function(D) {
          return Ir(D, x);
        } : x.style;
      }
      return w;
    }, y = (...w) => {
      const x = [], L = w.map(E), D = [];
      if (x.push(i), c && g && D.push(function(I) {
        var Q, se;
        const z = (se = (Q = I.theme.components) == null ? void 0 : Q[c]) == null ? void 0 : se.styleOverrides;
        if (!z)
          return null;
        const re = {};
        for (const ue in z)
          re[ue] = Ir(I, z[ue]);
        return g(I, re);
      }), c && !d && D.push(function(I) {
        var re, Q;
        const P = I.theme, z = (Q = (re = P == null ? void 0 : P.components) == null ? void 0 : re[c]) == null ? void 0 : Q.variants;
        return z ? Rl(I, z) : null;
      }), v || D.push(gn), Array.isArray(L[0])) {
        const O = L.shift(), I = new Array(x.length).fill(""), P = new Array(D.length).fill("");
        let z;
        z = [...I, ...O, ...P], z.raw = [...I, ...O.raw, ...P], x.unshift(z);
      }
      const F = [...x, ...L, ...D], h = R(...F);
      return a.muiName && (h.muiName = a.muiName), process.env.NODE_ENV !== "production" && (h.displayName = fb(c, u, a)), h;
    };
    return R.withConfig && (y.withConfig = R.withConfig), y;
  };
}
function fb(t, e, n) {
  return t ? `${t}${pi(e || "")}` : `Styled(${ly(n)})`;
}
function pb(t, e) {
  let n;
  return process.env.NODE_ENV !== "production" && t && (n = `${t}-${Ml(e || "Root")}`), n;
}
function mb(t) {
  for (const e in t)
    return !1;
  return !0;
}
function hb(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96;
}
function Ml(t) {
  return t && t.charAt(0).toLowerCase() + t.slice(1);
}
const gb = Il();
function zr(t, e) {
  const n = {
    ...e
  };
  for (const r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      const o = r;
      if (o === "components" || o === "slots")
        n[o] = {
          ...t[o],
          ...n[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = t[o], s = e[o];
        if (!s)
          n[o] = i || {};
        else if (!i)
          n[o] = s;
        else {
          n[o] = {
            ...s
          };
          for (const a in i)
            if (Object.prototype.hasOwnProperty.call(i, a)) {
              const l = a;
              n[o][l] = zr(i[l], s[l]);
            }
        }
      } else n[o] === void 0 && (n[o] = t[o]);
    }
  return n;
}
function yb(t) {
  const {
    theme: e,
    name: n,
    props: r
  } = t;
  return !e || !e.components || !e.components[n] || !e.components[n].defaultProps ? r : zr(e.components[n].defaultProps, r);
}
function bb(t) {
  return Object.keys(t).length === 0;
}
function vb(t = null) {
  const e = et.useContext(Ad);
  return !e || bb(e) ? t : e;
}
const wb = ro();
function gi(t = wb) {
  return vb(t);
}
function Cb({
  props: t,
  name: e,
  defaultTheme: n,
  themeId: r
}) {
  let o = gi(n);
  return r && (o = o[r] || o), yb({
    theme: o,
    name: e,
    props: t
  });
}
const Sb = (t, e) => t.filter((n) => e.includes(n)), kn = (t, e, n) => {
  const r = t.keys[0];
  Array.isArray(e) ? e.forEach((o, i) => {
    n((s, a) => {
      i <= t.keys.length - 1 && (i === 0 ? Object.assign(s, a) : s[t.up(t.keys[i])] = a);
    }, o);
  }) : e && typeof e == "object" ? (Object.keys(e).length > t.keys.length ? t.keys : Sb(t.keys, Object.keys(e))).forEach((i) => {
    if (t.keys.includes(i)) {
      const s = e[i];
      s !== void 0 && n((a, l) => {
        r === i ? Object.assign(a, l) : a[t.up(i)] = l;
      }, s);
    }
  }) : (typeof e == "number" || typeof e == "string") && n((o, i) => {
    Object.assign(o, i);
  }, e);
};
function Vr(t) {
  return `--Grid-${t}Spacing`;
}
function oo(t) {
  return `--Grid-parent-${t}Spacing`;
}
const ws = "--Grid-columns", dn = "--Grid-parent-columns", xb = ({
  theme: t,
  ownerState: e
}) => {
  const n = {};
  return kn(t.breakpoints, e.size, (r, o) => {
    let i = {};
    o === "grow" && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), o === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof o == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${o} / var(${dn}) - (var(${dn}) - ${o}) * (var(${oo("column")}) / var(${dn})))`
    }), r(n, i);
  }), n;
}, Tb = ({
  theme: t,
  ownerState: e
}) => {
  const n = {};
  return kn(t.breakpoints, e.offset, (r, o) => {
    let i = {};
    o === "auto" && (i = {
      marginLeft: "auto"
    }), typeof o == "number" && (i = {
      marginLeft: o === 0 ? "0px" : `calc(100% * ${o} / var(${dn}) + var(${oo("column")}) * ${o} / var(${dn}))`
    }), r(n, i);
  }), n;
}, kb = ({
  theme: t,
  ownerState: e
}) => {
  if (!e.container)
    return {};
  const n = {
    [ws]: 12
  };
  return kn(t.breakpoints, e.columns, (r, o) => {
    const i = o ?? 12;
    r(n, {
      [ws]: i,
      "> *": {
        [dn]: i
      }
    });
  }), n;
}, Ab = ({
  theme: t,
  ownerState: e
}) => {
  if (!e.container)
    return {};
  const n = {};
  return kn(t.breakpoints, e.rowSpacing, (r, o) => {
    var s;
    const i = typeof o == "string" ? o : (s = t.spacing) == null ? void 0 : s.call(t, o);
    r(n, {
      [Vr("row")]: i,
      "> *": {
        [oo("row")]: i
      }
    });
  }), n;
}, Eb = ({
  theme: t,
  ownerState: e
}) => {
  if (!e.container)
    return {};
  const n = {};
  return kn(t.breakpoints, e.columnSpacing, (r, o) => {
    var s;
    const i = typeof o == "string" ? o : (s = t.spacing) == null ? void 0 : s.call(t, o);
    r(n, {
      [Vr("column")]: i,
      "> *": {
        [oo("column")]: i
      }
    });
  }), n;
}, Ob = ({
  theme: t,
  ownerState: e
}) => {
  if (!e.container)
    return {};
  const n = {};
  return kn(t.breakpoints, e.direction, (r, o) => {
    r(n, {
      flexDirection: o
    });
  }), n;
}, $b = ({
  ownerState: t
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...t.container && {
    display: "flex",
    flexWrap: "wrap",
    ...t.wrap && t.wrap !== "wrap" && {
      flexWrap: t.wrap
    },
    gap: `var(${Vr("row")}) var(${Vr("column")})`
  }
}), Rb = (t) => {
  const e = [];
  return Object.entries(t).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && e.push(`grid-${n}-${String(r)}`);
  }), e;
}, Ib = (t, e = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(t))
    return [`spacing-${e}-${String(t)}`];
  if (typeof t == "object" && !Array.isArray(t)) {
    const r = [];
    return Object.entries(t).forEach(([o, i]) => {
      n(i) && r.push(`spacing-${o}-${String(i)}`);
    }), r;
  }
  return [];
}, Mb = (t) => t === void 0 ? [] : typeof t == "object" ? Object.entries(t).map(([e, n]) => `direction-${e}-${n}`) : [`direction-xs-${String(t)}`], Pb = (t) => ["item", "zeroMinWidth"].includes(t) ? `The \`${t}\` prop has been removed and is no longer necessary. You can safely remove it.` : `The \`${t}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`, Cs = [];
function Nb(t, e) {
  const n = [];
  t.item !== void 0 && (delete t.item, n.push("item")), t.zeroMinWidth !== void 0 && (delete t.zeroMinWidth, n.push("zeroMinWidth")), e.keys.forEach((r) => {
    t[r] !== void 0 && (n.push(r), delete t[r]);
  }), process.env.NODE_ENV !== "production" && n.forEach((r) => {
    Cs.includes(r) || (Cs.push(r), console.warn(`MUI Grid2: ${Pb(r)}
`));
  });
}
const Lb = ro(), Db = gb("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (t, e) => e.root
});
function Fb(t) {
  return Cb({
    props: t,
    name: "MuiGrid",
    defaultTheme: Lb
  });
}
function Bb(t = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: e = Db,
    useThemeProps: n = Fb,
    useTheme: r = gi,
    componentName: o = "MuiGrid"
  } = t, i = (c, u) => {
    const {
      container: f,
      direction: m,
      spacing: g,
      wrap: b,
      size: d
    } = c, v = {
      root: ["root", f && "container", b !== "wrap" && `wrap-xs-${String(b)}`, ...Mb(m), ...Rb(d), ...f ? Ib(g, u.breakpoints.keys[0]) : []]
    };
    return Zg(v, (C) => xl(o, C), {});
  };
  function s(c, u, f = () => !0) {
    const m = {};
    return c === null || (Array.isArray(c) ? c.forEach((g, b) => {
      g !== null && f(g) && u.keys[b] && (m[u.keys[b]] = g);
    }) : typeof c == "object" ? Object.keys(c).forEach((g) => {
      const b = c[g];
      b != null && f(b) && (m[g] = b);
    }) : m[u.keys[0]] = c), m;
  }
  const a = e(kb, Eb, Ab, xb, Ob, $b, Tb), l = /* @__PURE__ */ et.forwardRef(function(u, f) {
    const m = r(), g = n(u), b = ab(g);
    Nb(b, m.breakpoints);
    const {
      className: d,
      children: v,
      columns: C = 12,
      container: R = !1,
      component: E = "div",
      direction: y = "row",
      wrap: w = "wrap",
      size: x = {},
      offset: L = {},
      spacing: D = 0,
      rowSpacing: F = D,
      columnSpacing: h = D,
      unstable_level: O = 0,
      ...I
    } = b, P = s(x, m.breakpoints, (M) => M !== !1), z = s(L, m.breakpoints), re = u.columns ?? (O ? void 0 : C), Q = u.spacing ?? (O ? void 0 : D), se = u.rowSpacing ?? u.spacing ?? (O ? void 0 : F), ue = u.columnSpacing ?? u.spacing ?? (O ? void 0 : h), Ee = {
      ...b,
      level: O,
      columns: re,
      container: R,
      direction: y,
      wrap: w,
      spacing: Q,
      rowSpacing: se,
      columnSpacing: ue,
      size: P,
      offset: z
    }, $ = i(Ee, m);
    return /* @__PURE__ */ p(a, {
      ref: f,
      as: E,
      ownerState: Ee,
      className: Ce($.root, d),
      ...I,
      children: et.Children.map(v, (M) => {
        var H;
        return /* @__PURE__ */ et.isValidElement(M) && Kg(M, ["Grid"]) && R && M.props.container ? /* @__PURE__ */ et.cloneElement(M, {
          unstable_level: ((H = M.props) == null ? void 0 : H.unstable_level) ?? O + 1
        }) : M;
      })
    });
  });
  return process.env.NODE_ENV !== "production" && (l.propTypes = {
    children: S.node,
    className: S.string,
    columns: S.oneOfType([S.arrayOf(S.number), S.number, S.object]),
    columnSpacing: S.oneOfType([S.arrayOf(S.oneOfType([S.number, S.string])), S.number, S.object, S.string]),
    component: S.elementType,
    container: S.bool,
    direction: S.oneOfType([S.oneOf(["column-reverse", "column", "row-reverse", "row"]), S.arrayOf(S.oneOf(["column-reverse", "column", "row-reverse", "row"])), S.object]),
    offset: S.oneOfType([S.string, S.number, S.arrayOf(S.oneOfType([S.string, S.number])), S.object]),
    rowSpacing: S.oneOfType([S.arrayOf(S.oneOfType([S.number, S.string])), S.number, S.object, S.string]),
    size: S.oneOfType([S.string, S.bool, S.number, S.arrayOf(S.oneOfType([S.string, S.bool, S.number])), S.object]),
    spacing: S.oneOfType([S.arrayOf(S.oneOfType([S.number, S.string])), S.number, S.object, S.string]),
    sx: S.oneOfType([S.arrayOf(S.oneOfType([S.func, S.object, S.bool])), S.func, S.object]),
    wrap: S.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), l.muiName = "Grid", l;
}
function _b(t, e) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = e ? {
    ...e.propTypes
  } : null;
  return (o) => (i, s, a, l, c, ...u) => {
    const f = c || s, m = n == null ? void 0 : n[f];
    if (m) {
      const g = m(i, s, a, l, c, ...u);
      if (g)
        return g;
    }
    return typeof i[s] < "u" && !i[o] ? new Error(`The prop \`${f}\` of \`${t}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
const Pl = "$$material";
function zb(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
function yi(t, e = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (t < e || t > n) && console.error(`MUI: The value provided ${t} is out of range [${e}, ${n}].`), zb(t, e, n);
}
function Vb(t) {
  t = t.slice(1);
  const e = new RegExp(`.{1,${t.length >= 6 ? 2 : 1}}`, "g");
  let n = t.match(e);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && t.length !== t.trim().length && console.error(`MUI: The color: "${t}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Tt(t) {
  if (t.type)
    return t;
  if (t.charAt(0) === "#")
    return Tt(Vb(t));
  const e = t.indexOf("("), n = t.substring(0, e);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${t}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : xt(9, t));
  let r = t.substring(e + 1, t.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : xt(10, o));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const jb = (t) => {
  const e = Tt(t);
  return e.values.slice(0, 3).map((n, r) => e.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, Fn = (t, e) => {
  try {
    return jb(t);
  } catch {
    return e && process.env.NODE_ENV !== "production" && console.warn(e), t;
  }
};
function io(t) {
  const {
    type: e,
    colorSpace: n
  } = t;
  let {
    values: r
  } = t;
  return e.includes("rgb") ? r = r.map((o, i) => i < 3 ? parseInt(o, 10) : o) : e.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), e.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${e}(${r})`;
}
function Nl(t) {
  t = Tt(t);
  const {
    values: e
  } = t, n = e[0], r = e[1] / 100, o = e[2] / 100, i = r * Math.min(o, 1 - o), s = (c, u = (c + n / 30) % 12) => o - i * Math.max(Math.min(u - 3, 9 - u, 1), -1);
  let a = "rgb";
  const l = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return t.type === "hsla" && (a += "a", l.push(e[3])), io({
    type: a,
    values: l
  });
}
function _o(t) {
  t = Tt(t);
  let e = t.type === "hsl" || t.type === "hsla" ? Tt(Nl(t)).values : t.values;
  return e = e.map((n) => (t.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
}
function Ss(t, e) {
  const n = _o(t), r = _o(e);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Hb(t, e) {
  return t = Tt(t), e = yi(e), (t.type === "rgb" || t.type === "hsl") && (t.type += "a"), t.type === "color" ? t.values[3] = `/${e}` : t.values[3] = e, io(t);
}
function xr(t, e, n) {
  try {
    return Hb(t, e);
  } catch {
    return t;
  }
}
function bi(t, e) {
  if (t = Tt(t), e = yi(e), t.type.includes("hsl"))
    t.values[2] *= 1 - e;
  else if (t.type.includes("rgb") || t.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      t.values[n] *= 1 - e;
  return io(t);
}
function de(t, e, n) {
  try {
    return bi(t, e);
  } catch {
    return t;
  }
}
function vi(t, e) {
  if (t = Tt(t), e = yi(e), t.type.includes("hsl"))
    t.values[2] += (100 - t.values[2]) * e;
  else if (t.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      t.values[n] += (255 - t.values[n]) * e;
  else if (t.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      t.values[n] += (1 - t.values[n]) * e;
  return io(t);
}
function fe(t, e, n) {
  try {
    return vi(t, e);
  } catch {
    return t;
  }
}
function Ub(t, e = 0.15) {
  return _o(t) > 0.5 ? bi(t, e) : vi(t, e);
}
function Tr(t, e, n) {
  try {
    return Ub(t, e);
  } catch {
    return t;
  }
}
const Wb = /* @__PURE__ */ et.createContext(void 0);
process.env.NODE_ENV !== "production" && (S.node, S.object);
function qb(t) {
  const {
    theme: e,
    name: n,
    props: r
  } = t;
  if (!e || !e.components || !e.components[n])
    return r;
  const o = e.components[n];
  return o.defaultProps ? zr(o.defaultProps, r) : !o.styleOverrides && !o.variants ? zr(o, r) : r;
}
function Kb({
  props: t,
  name: e
}) {
  const n = et.useContext(Wb);
  return qb({
    props: t,
    name: e,
    theme: {
      components: n
    }
  });
}
function Yb(t = "") {
  function e(...r) {
    if (!r.length)
      return "";
    const o = r[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${t ? `${t}-` : ""}${o}${e(...r.slice(1))})` : `, ${o}`;
  }
  return (r, ...o) => `var(--${t ? `${t}-` : ""}${r}${e(...o)})`;
}
const xs = (t, e, n, r = []) => {
  let o = t;
  e.forEach((i, s) => {
    s === e.length - 1 ? Array.isArray(o) ? o[Number(i)] = n : o && typeof o == "object" && (o[i] = n) : o && typeof o == "object" && (o[i] || (o[i] = r.includes(i) ? [] : {}), o = o[i]);
  });
}, Gb = (t, e, n) => {
  function r(o, i = [], s = []) {
    Object.entries(o).forEach(([a, l]) => {
      (!n || !n([...i, a])) && l != null && (typeof l == "object" && Object.keys(l).length > 0 ? r(l, [...i, a], Array.isArray(l) ? [...s, a] : s) : e([...i, a], l, s));
    });
  }
  r(t);
}, Jb = (t, e) => typeof e == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => t.includes(r)) || t[t.length - 1].toLowerCase().includes("opacity") ? e : `${e}px` : e;
function Oo(t, e) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = e || {}, o = {}, i = {}, s = {};
  return Gb(
    t,
    (a, l, c) => {
      if ((typeof l == "string" || typeof l == "number") && (!r || !r(a, l))) {
        const u = `--${n ? `${n}-` : ""}${a.join("-")}`, f = Jb(a, l);
        Object.assign(o, {
          [u]: f
        }), xs(i, a, `var(${u})`, c), xs(s, a, `var(${u}, ${f})`, c);
      }
    },
    (a) => a[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: s
  };
}
function Zb(t, e = {}) {
  const {
    getSelector: n = v,
    disableCssColorScheme: r,
    colorSchemeSelector: o
  } = e, {
    colorSchemes: i = {},
    components: s,
    defaultColorScheme: a = "light",
    ...l
  } = t, {
    vars: c,
    css: u,
    varsWithDefaults: f
  } = Oo(l, e);
  let m = f;
  const g = {}, {
    [a]: b,
    ...d
  } = i;
  if (Object.entries(d || {}).forEach(([E, y]) => {
    const {
      vars: w,
      css: x,
      varsWithDefaults: L
    } = Oo(y, e);
    m = je(m, L), g[E] = {
      css: x,
      vars: w
    };
  }), b) {
    const {
      css: E,
      vars: y,
      varsWithDefaults: w
    } = Oo(b, e);
    m = je(m, w), g[a] = {
      css: E,
      vars: y
    };
  }
  function v(E, y) {
    var x, L;
    let w = o;
    if (o === "class" && (w = ".%s"), o === "data" && (w = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (w = `[${o}="%s"]`), E) {
      if (w === "media")
        return t.defaultColorScheme === E ? ":root" : {
          [`@media (prefers-color-scheme: ${((L = (x = i[E]) == null ? void 0 : x.palette) == null ? void 0 : L.mode) || E})`]: {
            ":root": y
          }
        };
      if (w)
        return t.defaultColorScheme === E ? `:root, ${w.replace("%s", String(E))}` : w.replace("%s", String(E));
    }
    return ":root";
  }
  return {
    vars: m,
    generateThemeVars: () => {
      let E = {
        ...c
      };
      return Object.entries(g).forEach(([, {
        vars: y
      }]) => {
        E = je(E, y);
      }), E;
    },
    generateStyleSheets: () => {
      var D, F;
      const E = [], y = t.defaultColorScheme || "light";
      function w(h, O) {
        Object.keys(O).length && E.push(typeof h == "string" ? {
          [h]: {
            ...O
          }
        } : h);
      }
      w(n(void 0, {
        ...u
      }), u);
      const {
        [y]: x,
        ...L
      } = g;
      if (x) {
        const {
          css: h
        } = x, O = (F = (D = i[y]) == null ? void 0 : D.palette) == null ? void 0 : F.mode, I = !r && O ? {
          colorScheme: O,
          ...h
        } : {
          ...h
        };
        w(n(y, {
          ...I
        }), I);
      }
      return Object.entries(L).forEach(([h, {
        css: O
      }]) => {
        var z, re;
        const I = (re = (z = i[h]) == null ? void 0 : z.palette) == null ? void 0 : re.mode, P = !r && I ? {
          colorScheme: I,
          ...O
        } : {
          ...O
        };
        w(n(h, {
          ...P
        }), P);
      }), E;
    }
  };
}
function Xb(t) {
  return function(n) {
    return t === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : t ? t.startsWith("data-") && !t.includes("%s") ? `[${t}="${n}"] &` : t === "class" ? `.${n} &` : t === "data" ? `[data-${n}] &` : `${t.replace("%s", n)} &` : "&";
  };
}
const Gn = {
  black: "#000",
  white: "#fff"
}, Qb = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Zt = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Xt = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, In = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Qt = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, en = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, tn = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function Ll() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Gn.white,
      default: Gn.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const e0 = Ll();
function Dl() {
  return {
    text: {
      primary: Gn.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Gn.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Ts = Dl();
function ks(t, e, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  t[e] || (t.hasOwnProperty(n) ? t[e] = t[n] : e === "light" ? t.light = vi(t.main, o) : e === "dark" && (t.dark = bi(t.main, i)));
}
function t0(t = "light") {
  return t === "dark" ? {
    main: Qt[200],
    light: Qt[50],
    dark: Qt[400]
  } : {
    main: Qt[700],
    light: Qt[400],
    dark: Qt[800]
  };
}
function n0(t = "light") {
  return t === "dark" ? {
    main: Zt[200],
    light: Zt[50],
    dark: Zt[400]
  } : {
    main: Zt[500],
    light: Zt[300],
    dark: Zt[700]
  };
}
function r0(t = "light") {
  return t === "dark" ? {
    main: Xt[500],
    light: Xt[300],
    dark: Xt[700]
  } : {
    main: Xt[700],
    light: Xt[400],
    dark: Xt[800]
  };
}
function o0(t = "light") {
  return t === "dark" ? {
    main: en[400],
    light: en[300],
    dark: en[700]
  } : {
    main: en[700],
    light: en[500],
    dark: en[900]
  };
}
function i0(t = "light") {
  return t === "dark" ? {
    main: tn[400],
    light: tn[300],
    dark: tn[700]
  } : {
    main: tn[800],
    light: tn[500],
    dark: tn[900]
  };
}
function s0(t = "light") {
  return t === "dark" ? {
    main: In[400],
    light: In[300],
    dark: In[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: In[500],
    dark: In[900]
  };
}
function wi(t) {
  const {
    mode: e = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...o
  } = t, i = t.primary || t0(e), s = t.secondary || n0(e), a = t.error || r0(e), l = t.info || o0(e), c = t.success || i0(e), u = t.warning || s0(e);
  function f(d) {
    const v = Ss(d, Ts.text.primary) >= n ? Ts.text.primary : e0.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const C = Ss(d, v);
      C < 3 && console.error([`MUI: The contrast ratio of ${C}:1 for ${v} on ${d}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return v;
  }
  const m = ({
    color: d,
    name: v,
    mainShade: C = 500,
    lightShade: R = 300,
    darkShade: E = 700
  }) => {
    if (d = {
      ...d
    }, !d.main && d[C] && (d.main = d[C]), !d.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${C}\` property.` : xt(11, v ? ` (${v})` : "", C));
    if (typeof d.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${v ? ` (${v})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(d.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : xt(12, v ? ` (${v})` : "", JSON.stringify(d.main)));
    return ks(d, "light", R, r), ks(d, "dark", E, r), d.contrastText || (d.contrastText = f(d.main)), d;
  };
  let g;
  return e === "light" ? g = Ll() : e === "dark" && (g = Dl()), process.env.NODE_ENV !== "production" && (g || console.error(`MUI: The palette mode \`${e}\` is not supported.`)), je({
    // A collection of common colors.
    common: {
      ...Gn
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: e,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: a,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: u,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: l,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: c,
      name: "success"
    }),
    // The grey colors.
    grey: Qb,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...g
  }, o);
}
function a0(t) {
  const e = {};
  return Object.entries(t).forEach((r) => {
    const [o, i] = r;
    typeof i == "object" && (e[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), e;
}
function l0(t, e) {
  return {
    toolbar: {
      minHeight: 56,
      [t.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [t.up("sm")]: {
        minHeight: 64
      }
    },
    ...e
  };
}
function c0(t) {
  return Math.round(t * 1e5) / 1e5;
}
const As = {
  textTransform: "uppercase"
}, Es = '"Roboto", "Helvetica", "Arial", sans-serif';
function u0(t, e) {
  const {
    fontFamily: n = Es,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: a = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: c,
    pxToRem: u,
    ...f
  } = typeof e == "function" ? e(t) : e;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = r / 14, g = u || ((v) => `${v / l * m}rem`), b = (v, C, R, E, y) => ({
    fontFamily: n,
    fontWeight: v,
    fontSize: g(C),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: R,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === Es ? {
      letterSpacing: `${c0(E / C)}em`
    } : {},
    ...y,
    ...c
  }), d = {
    h1: b(o, 96, 1.167, -1.5),
    h2: b(o, 60, 1.2, -0.5),
    h3: b(i, 48, 1.167, 0),
    h4: b(i, 34, 1.235, 0.25),
    h5: b(i, 24, 1.334, 0),
    h6: b(s, 20, 1.6, 0.15),
    subtitle1: b(i, 16, 1.75, 0.15),
    subtitle2: b(s, 14, 1.57, 0.1),
    body1: b(i, 16, 1.5, 0.15),
    body2: b(i, 14, 1.43, 0.15),
    button: b(s, 14, 1.75, 0.4, As),
    caption: b(i, 12, 1.66, 0.4),
    overline: b(i, 12, 2.66, 1, As),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return je({
    htmlFontSize: l,
    pxToRem: g,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: a,
    ...d
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const d0 = 0.2, f0 = 0.14, p0 = 0.12;
function pe(...t) {
  return [`${t[0]}px ${t[1]}px ${t[2]}px ${t[3]}px rgba(0,0,0,${d0})`, `${t[4]}px ${t[5]}px ${t[6]}px ${t[7]}px rgba(0,0,0,${f0})`, `${t[8]}px ${t[9]}px ${t[10]}px ${t[11]}px rgba(0,0,0,${p0})`].join(",");
}
const m0 = ["none", pe(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), pe(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), pe(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), pe(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), pe(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), pe(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), pe(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), pe(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), pe(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), pe(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), pe(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), pe(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), pe(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), pe(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), pe(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), pe(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), pe(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), pe(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), pe(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), pe(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), pe(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), pe(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), pe(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), pe(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], h0 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, g0 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Os(t) {
  return `${Math.round(t)}ms`;
}
function y0(t) {
  if (!t)
    return 0;
  const e = t / 36;
  return Math.min(Math.round((4 + 15 * e ** 0.25 + e / 5) * 10), 3e3);
}
function b0(t) {
  const e = {
    ...h0,
    ...t.easing
  }, n = {
    ...g0,
    ...t.duration
  };
  return {
    getAutoHeightDuration: y0,
    create: (o = ["all"], i = {}) => {
      const {
        duration: s = n.standard,
        easing: a = e.easeInOut,
        delay: l = 0,
        ...c
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const u = (m) => typeof m == "string", f = (m) => !Number.isNaN(parseFloat(m));
        !u(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(s) && !u(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), u(a) || console.error('MUI: Argument "easing" must be a string.'), !f(l) && !u(l) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((u) => `${u} ${typeof s == "string" ? s : Os(s)} ${a} ${typeof l == "string" ? l : Os(l)}`).join(",");
    },
    ...t,
    easing: e,
    duration: n
  };
}
const v0 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function w0(t) {
  return ot(t) || typeof t > "u" || typeof t == "string" || typeof t == "boolean" || typeof t == "number" || Array.isArray(t);
}
function Fl(t = {}) {
  const e = {
    ...t
  };
  function n(r) {
    const o = Object.entries(r);
    for (let i = 0; i < o.length; i++) {
      const [s, a] = o[i];
      !w0(a) || s.startsWith("unstable_") ? delete r[s] : ot(a) && (r[s] = {
        ...a
      }, n(r[s]));
    }
  }
  return n(e), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(e, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function zo(t = {}, ...e) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: o,
    palette: i = {},
    transitions: s = {},
    typography: a = {},
    shape: l,
    ...c
  } = t;
  if (t.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  t.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : xt(20));
  const u = wi(i), f = ro(t);
  let m = je(f, {
    mixins: l0(f.breakpoints, r),
    palette: u,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: m0.slice(),
    typography: u0(u, a),
    transitions: b0(s),
    zIndex: {
      ...v0
    }
  });
  if (m = je(m, c), m = e.reduce((g, b) => je(g, b), m), process.env.NODE_ENV !== "production") {
    const g = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], b = (d, v) => {
      let C;
      for (C in d) {
        const R = d[C];
        if (g.includes(C) && Object.keys(R).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const E = xl("", C);
            console.error([`MUI: The \`${v}\` component increases the CSS specificity of the \`${C}\` internal state.`, "You can not override it like this: ", JSON.stringify(d, null, 2), "", `Instead, you need to use the '&.${E}' syntax:`, JSON.stringify({
              root: {
                [`&.${E}`]: R
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          d[C] = {};
        }
      }
    };
    Object.keys(m.components).forEach((d) => {
      const v = m.components[d].styleOverrides;
      v && d.startsWith("Mui") && b(v, d);
    });
  }
  return m.unstable_sxConfig = {
    ...rr,
    ...c == null ? void 0 : c.unstable_sxConfig
  }, m.unstable_sx = function(b) {
    return gn({
      sx: b,
      theme: this
    });
  }, m.toRuntimeSource = Fl, m;
}
function C0(t) {
  let e;
  return t < 1 ? e = 5.11916 * t ** 2 : e = 4.5 * Math.log(t + 1) + 2, Math.round(e * 10) / 1e3;
}
const S0 = [...Array(25)].map((t, e) => {
  if (e === 0)
    return "none";
  const n = C0(e);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Bl(t) {
  return {
    inputPlaceholder: t === "dark" ? 0.5 : 0.42,
    inputUnderline: t === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: t === "dark" ? 0.2 : 0.12,
    switchTrack: t === "dark" ? 0.3 : 0.38
  };
}
function _l(t) {
  return t === "dark" ? S0 : [];
}
function x0(t) {
  const {
    palette: e = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...o
  } = t, i = wi(e);
  return {
    palette: i,
    opacity: {
      ...Bl(i.mode),
      ...n
    },
    overlays: r || _l(i.mode),
    ...o
  };
}
function T0(t) {
  var e;
  return !!t[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!t[0].match(/sxConfig$/) || // ends with sxConfig
  t[0] === "palette" && !!((e = t[1]) != null && e.match(/(mode|contrastThreshold|tonalOffset)/));
}
const k0 = (t) => [...[...Array(25)].map((e, n) => `--${t ? `${t}-` : ""}overlays-${n}`), `--${t ? `${t}-` : ""}palette-AppBar-darkBg`, `--${t ? `${t}-` : ""}palette-AppBar-darkColor`], A0 = (t) => (e, n) => {
  const r = t.rootSelector || ":root", o = t.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), t.defaultColorScheme === e) {
    if (e === "dark") {
      const s = {};
      return k0(t.cssVarPrefix).forEach((a) => {
        s[a] = n[a], delete n[a];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : i ? {
        [i.replace("%s", e)]: s,
        [`${r}, ${i.replace("%s", e)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(e))}`;
  } else if (e) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(e)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(e));
  }
  return r;
};
function E0(t, e) {
  e.forEach((n) => {
    t[n] || (t[n] = {});
  });
}
function T(t, e, n) {
  !t[e] && n && (t[e] = n);
}
function Bn(t) {
  return typeof t != "string" || !t.startsWith("hsl") ? t : Nl(t);
}
function pt(t, e) {
  `${e}Channel` in t || (t[`${e}Channel`] = Fn(Bn(t[e]), `MUI: Can't create \`palette.${e}Channel\` because \`palette.${e}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${e}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function O0(t) {
  return typeof t == "number" ? `${t}px` : typeof t == "string" || typeof t == "function" || Array.isArray(t) ? t : "8px";
}
const nt = (t) => {
  try {
    return t();
  } catch {
  }
}, $0 = (t = "mui") => Yb(t);
function $o(t, e, n, r) {
  if (!e)
    return;
  e = e === !0 ? {} : e;
  const o = r === "dark" ? "dark" : "light";
  if (!n) {
    t[r] = x0({
      ...e,
      palette: {
        mode: o,
        ...e == null ? void 0 : e.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...s
  } = zo({
    ...n,
    palette: {
      mode: o,
      ...e == null ? void 0 : e.palette
    }
  });
  return t[r] = {
    ...e,
    palette: i,
    opacity: {
      ...Bl(o),
      ...e == null ? void 0 : e.opacity
    },
    overlays: (e == null ? void 0 : e.overlays) || _l(o)
  }, s;
}
function R0(t = {}, ...e) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: s = T0,
    colorSchemeSelector: a = n.light && n.dark ? "media" : void 0,
    rootSelector: l = ":root",
    ...c
  } = t, u = Object.keys(n)[0], f = r || (n.light && u !== "light" ? "light" : u), m = $0(i), {
    [f]: g,
    light: b,
    dark: d,
    ...v
  } = n, C = {
    ...v
  };
  let R = g;
  if ((f === "dark" && !("dark" in n) || f === "light" && !("light" in n)) && (R = !0), !R)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${f}\` option is either missing or invalid.` : xt(21, f));
  const E = $o(C, R, c, f);
  b && !C.light && $o(C, b, void 0, "light"), d && !C.dark && $o(C, d, void 0, "dark");
  let y = {
    defaultColorScheme: f,
    ...E,
    cssVarPrefix: i,
    colorSchemeSelector: a,
    rootSelector: l,
    getCssVar: m,
    colorSchemes: C,
    font: {
      ...a0(E.typography),
      ...E.font
    },
    spacing: O0(c.spacing)
  };
  Object.keys(y.colorSchemes).forEach((F) => {
    const h = y.colorSchemes[F].palette, O = (I) => {
      const P = I.split("-"), z = P[1], re = P[2];
      return m(I, h[z][re]);
    };
    if (h.mode === "light" && (T(h.common, "background", "#fff"), T(h.common, "onBackground", "#000")), h.mode === "dark" && (T(h.common, "background", "#000"), T(h.common, "onBackground", "#fff")), E0(h, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), h.mode === "light") {
      T(h.Alert, "errorColor", de(h.error.light, 0.6)), T(h.Alert, "infoColor", de(h.info.light, 0.6)), T(h.Alert, "successColor", de(h.success.light, 0.6)), T(h.Alert, "warningColor", de(h.warning.light, 0.6)), T(h.Alert, "errorFilledBg", O("palette-error-main")), T(h.Alert, "infoFilledBg", O("palette-info-main")), T(h.Alert, "successFilledBg", O("palette-success-main")), T(h.Alert, "warningFilledBg", O("palette-warning-main")), T(h.Alert, "errorFilledColor", nt(() => h.getContrastText(h.error.main))), T(h.Alert, "infoFilledColor", nt(() => h.getContrastText(h.info.main))), T(h.Alert, "successFilledColor", nt(() => h.getContrastText(h.success.main))), T(h.Alert, "warningFilledColor", nt(() => h.getContrastText(h.warning.main))), T(h.Alert, "errorStandardBg", fe(h.error.light, 0.9)), T(h.Alert, "infoStandardBg", fe(h.info.light, 0.9)), T(h.Alert, "successStandardBg", fe(h.success.light, 0.9)), T(h.Alert, "warningStandardBg", fe(h.warning.light, 0.9)), T(h.Alert, "errorIconColor", O("palette-error-main")), T(h.Alert, "infoIconColor", O("palette-info-main")), T(h.Alert, "successIconColor", O("palette-success-main")), T(h.Alert, "warningIconColor", O("palette-warning-main")), T(h.AppBar, "defaultBg", O("palette-grey-100")), T(h.Avatar, "defaultBg", O("palette-grey-400")), T(h.Button, "inheritContainedBg", O("palette-grey-300")), T(h.Button, "inheritContainedHoverBg", O("palette-grey-A100")), T(h.Chip, "defaultBorder", O("palette-grey-400")), T(h.Chip, "defaultAvatarColor", O("palette-grey-700")), T(h.Chip, "defaultIconColor", O("palette-grey-700")), T(h.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), T(h.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), T(h.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), T(h.LinearProgress, "primaryBg", fe(h.primary.main, 0.62)), T(h.LinearProgress, "secondaryBg", fe(h.secondary.main, 0.62)), T(h.LinearProgress, "errorBg", fe(h.error.main, 0.62)), T(h.LinearProgress, "infoBg", fe(h.info.main, 0.62)), T(h.LinearProgress, "successBg", fe(h.success.main, 0.62)), T(h.LinearProgress, "warningBg", fe(h.warning.main, 0.62)), T(h.Skeleton, "bg", `rgba(${O("palette-text-primaryChannel")} / 0.11)`), T(h.Slider, "primaryTrack", fe(h.primary.main, 0.62)), T(h.Slider, "secondaryTrack", fe(h.secondary.main, 0.62)), T(h.Slider, "errorTrack", fe(h.error.main, 0.62)), T(h.Slider, "infoTrack", fe(h.info.main, 0.62)), T(h.Slider, "successTrack", fe(h.success.main, 0.62)), T(h.Slider, "warningTrack", fe(h.warning.main, 0.62));
      const I = Tr(h.background.default, 0.8);
      T(h.SnackbarContent, "bg", I), T(h.SnackbarContent, "color", nt(() => h.getContrastText(I))), T(h.SpeedDialAction, "fabHoverBg", Tr(h.background.paper, 0.15)), T(h.StepConnector, "border", O("palette-grey-400")), T(h.StepContent, "border", O("palette-grey-400")), T(h.Switch, "defaultColor", O("palette-common-white")), T(h.Switch, "defaultDisabledColor", O("palette-grey-100")), T(h.Switch, "primaryDisabledColor", fe(h.primary.main, 0.62)), T(h.Switch, "secondaryDisabledColor", fe(h.secondary.main, 0.62)), T(h.Switch, "errorDisabledColor", fe(h.error.main, 0.62)), T(h.Switch, "infoDisabledColor", fe(h.info.main, 0.62)), T(h.Switch, "successDisabledColor", fe(h.success.main, 0.62)), T(h.Switch, "warningDisabledColor", fe(h.warning.main, 0.62)), T(h.TableCell, "border", fe(xr(h.divider, 1), 0.88)), T(h.Tooltip, "bg", xr(h.grey[700], 0.92));
    }
    if (h.mode === "dark") {
      T(h.Alert, "errorColor", fe(h.error.light, 0.6)), T(h.Alert, "infoColor", fe(h.info.light, 0.6)), T(h.Alert, "successColor", fe(h.success.light, 0.6)), T(h.Alert, "warningColor", fe(h.warning.light, 0.6)), T(h.Alert, "errorFilledBg", O("palette-error-dark")), T(h.Alert, "infoFilledBg", O("palette-info-dark")), T(h.Alert, "successFilledBg", O("palette-success-dark")), T(h.Alert, "warningFilledBg", O("palette-warning-dark")), T(h.Alert, "errorFilledColor", nt(() => h.getContrastText(h.error.dark))), T(h.Alert, "infoFilledColor", nt(() => h.getContrastText(h.info.dark))), T(h.Alert, "successFilledColor", nt(() => h.getContrastText(h.success.dark))), T(h.Alert, "warningFilledColor", nt(() => h.getContrastText(h.warning.dark))), T(h.Alert, "errorStandardBg", de(h.error.light, 0.9)), T(h.Alert, "infoStandardBg", de(h.info.light, 0.9)), T(h.Alert, "successStandardBg", de(h.success.light, 0.9)), T(h.Alert, "warningStandardBg", de(h.warning.light, 0.9)), T(h.Alert, "errorIconColor", O("palette-error-main")), T(h.Alert, "infoIconColor", O("palette-info-main")), T(h.Alert, "successIconColor", O("palette-success-main")), T(h.Alert, "warningIconColor", O("palette-warning-main")), T(h.AppBar, "defaultBg", O("palette-grey-900")), T(h.AppBar, "darkBg", O("palette-background-paper")), T(h.AppBar, "darkColor", O("palette-text-primary")), T(h.Avatar, "defaultBg", O("palette-grey-600")), T(h.Button, "inheritContainedBg", O("palette-grey-800")), T(h.Button, "inheritContainedHoverBg", O("palette-grey-700")), T(h.Chip, "defaultBorder", O("palette-grey-700")), T(h.Chip, "defaultAvatarColor", O("palette-grey-300")), T(h.Chip, "defaultIconColor", O("palette-grey-300")), T(h.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), T(h.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), T(h.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), T(h.LinearProgress, "primaryBg", de(h.primary.main, 0.5)), T(h.LinearProgress, "secondaryBg", de(h.secondary.main, 0.5)), T(h.LinearProgress, "errorBg", de(h.error.main, 0.5)), T(h.LinearProgress, "infoBg", de(h.info.main, 0.5)), T(h.LinearProgress, "successBg", de(h.success.main, 0.5)), T(h.LinearProgress, "warningBg", de(h.warning.main, 0.5)), T(h.Skeleton, "bg", `rgba(${O("palette-text-primaryChannel")} / 0.13)`), T(h.Slider, "primaryTrack", de(h.primary.main, 0.5)), T(h.Slider, "secondaryTrack", de(h.secondary.main, 0.5)), T(h.Slider, "errorTrack", de(h.error.main, 0.5)), T(h.Slider, "infoTrack", de(h.info.main, 0.5)), T(h.Slider, "successTrack", de(h.success.main, 0.5)), T(h.Slider, "warningTrack", de(h.warning.main, 0.5));
      const I = Tr(h.background.default, 0.98);
      T(h.SnackbarContent, "bg", I), T(h.SnackbarContent, "color", nt(() => h.getContrastText(I))), T(h.SpeedDialAction, "fabHoverBg", Tr(h.background.paper, 0.15)), T(h.StepConnector, "border", O("palette-grey-600")), T(h.StepContent, "border", O("palette-grey-600")), T(h.Switch, "defaultColor", O("palette-grey-300")), T(h.Switch, "defaultDisabledColor", O("palette-grey-600")), T(h.Switch, "primaryDisabledColor", de(h.primary.main, 0.55)), T(h.Switch, "secondaryDisabledColor", de(h.secondary.main, 0.55)), T(h.Switch, "errorDisabledColor", de(h.error.main, 0.55)), T(h.Switch, "infoDisabledColor", de(h.info.main, 0.55)), T(h.Switch, "successDisabledColor", de(h.success.main, 0.55)), T(h.Switch, "warningDisabledColor", de(h.warning.main, 0.55)), T(h.TableCell, "border", de(xr(h.divider, 1), 0.68)), T(h.Tooltip, "bg", xr(h.grey[700], 0.92));
    }
    pt(h.background, "default"), pt(h.background, "paper"), pt(h.common, "background"), pt(h.common, "onBackground"), pt(h, "divider"), Object.keys(h).forEach((I) => {
      const P = h[I];
      I !== "tonalOffset" && P && typeof P == "object" && (P.main && T(h[I], "mainChannel", Fn(Bn(P.main))), P.light && T(h[I], "lightChannel", Fn(Bn(P.light))), P.dark && T(h[I], "darkChannel", Fn(Bn(P.dark))), P.contrastText && T(h[I], "contrastTextChannel", Fn(Bn(P.contrastText))), I === "text" && (pt(h[I], "primary"), pt(h[I], "secondary")), I === "action" && (P.active && pt(h[I], "active"), P.selected && pt(h[I], "selected")));
    });
  }), y = e.reduce((F, h) => je(F, h), y);
  const w = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: s,
    getSelector: A0(y)
  }, {
    vars: x,
    generateThemeVars: L,
    generateStyleSheets: D
  } = Zb(y, w);
  return y.vars = x, Object.entries(y.colorSchemes[y.defaultColorScheme]).forEach(([F, h]) => {
    y[F] = h;
  }), y.generateThemeVars = L, y.generateStyleSheets = D, y.generateSpacing = function() {
    return $l(c.spacing, mi(this));
  }, y.getColorSchemeSelector = Xb(a), y.spacing = y.generateSpacing(), y.shouldSkipGeneratingVar = s, y.unstable_sxConfig = {
    ...rr,
    ...c == null ? void 0 : c.unstable_sxConfig
  }, y.unstable_sx = function(h) {
    return gn({
      sx: h,
      theme: this
    });
  }, y.toRuntimeSource = Fl, y;
}
function $s(t, e, n) {
  t.colorSchemes && n && (t.colorSchemes[e] = {
    ...n !== !0 && n,
    palette: wi({
      ...n === !0 ? {} : n.palette,
      mode: e
    })
    // cast type to skip module augmentation test
  });
}
function I0(t = {}, ...e) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: o = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode,
    ...s
  } = t, a = i || "light", l = o == null ? void 0 : o[a], c = {
    ...o,
    ...n ? {
      [a]: {
        ...typeof l != "boolean" && l,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in t))
      return zo(t, ...e);
    let u = n;
    "palette" in t || c[a] && (c[a] !== !0 ? u = c[a].palette : a === "dark" && (u = {
      mode: "dark"
    }));
    const f = zo({
      ...t,
      palette: u
    }, ...e);
    return f.defaultColorScheme = a, f.colorSchemes = c, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...c.light !== !0 && c.light,
      palette: f.palette
    }, $s(f, "dark", c.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...c.dark !== !0 && c.dark,
      palette: f.palette
    }, $s(f, "light", c.light)), f;
  }
  return !n && !("light" in c) && a === "light" && (c.light = !0), R0({
    ...s,
    colorSchemes: c,
    defaultColorScheme: a,
    ...typeof r != "boolean" && r
  }, ...e);
}
const zl = I0();
function Ci() {
  const t = gi(zl);
  return process.env.NODE_ENV !== "production" && et.useDebugValue(t), t[Pl] || t;
}
function M0(t) {
  return t !== "ownerState" && t !== "theme" && t !== "sx" && t !== "as";
}
const P0 = (t) => M0(t) && t !== "classes", N0 = Il({
  themeId: Pl,
  defaultTheme: zl,
  rootShouldForwardProp: P0
});
process.env.NODE_ENV !== "production" && (S.node, S.object.isRequired);
function L0(t) {
  return Kb(t);
}
const me = Bb({
  createStyledComponent: N0("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (t, e) => {
      const {
        ownerState: n
      } = t;
      return [e.root, n.container && e.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (t) => L0({
    props: t,
    name: "MuiGrid2"
  }),
  useTheme: Ci
});
process.env.NODE_ENV !== "production" && (me.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: S.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: S.oneOfType([S.arrayOf(S.number), S.number, S.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: S.oneOfType([S.arrayOf(S.oneOfType([S.number, S.string])), S.number, S.object, S.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: S.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: S.oneOfType([S.oneOf(["column-reverse", "column", "row-reverse", "row"]), S.arrayOf(S.oneOf(["column-reverse", "column", "row-reverse", "row"])), S.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: S.oneOfType([S.string, S.number, S.arrayOf(S.oneOfType([S.string, S.number])), S.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: S.oneOfType([S.arrayOf(S.oneOfType([S.number, S.string])), S.number, S.object, S.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: S.oneOfType([S.string, S.bool, S.number, S.arrayOf(S.oneOfType([S.string, S.bool, S.number])), S.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: S.oneOfType([S.arrayOf(S.oneOfType([S.number, S.string])), S.number, S.object, S.string]),
  /**
   * @ignore
   */
  sx: S.oneOfType([S.arrayOf(S.oneOfType([S.func, S.object, S.bool])), S.func, S.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: S.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: S.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (process.env.NODE_ENV !== "production") {
  const t = me, e = _b("Grid2", t);
  t.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...t.propTypes,
    direction: e("container"),
    spacing: e("container"),
    wrap: e("container")
  };
}
const Si = [
  "primary",
  "secondary",
  "grey1",
  "grey2",
  "brown",
  "purple1",
  "purple2",
  "purple3",
  "blue-gray",
  "blue1",
  "blue2",
  "blue3",
  "turquoise",
  "green1",
  "green2",
  "green3",
  "green4",
  "yellow",
  "orange1",
  "orange2",
  "orange3",
  "red1",
  "red2",
  "pink"
], D0 = {
  grey1: "#e0e0e055",
  grey2: "#bdbdbd77",
  brown: "#bcaaa4",
  purple1: "#e1bee7",
  purple2: "#7b1fa288",
  purple3: "#b39ddb",
  "blue-gray": "#cfd8dc",
  blue1: "#82b1ff88",
  blue2: "#b3e5fc",
  blue3: "#b2ebf2",
  turquoise: "#b2dfdb",
  green1: "#c8e6c9",
  green2: "#a5d6a7",
  green3: "#81c784",
  green4: "#e6ee9c",
  yellow: "#fff176",
  orange1: "#ffe082",
  orange2: "#ffcc80",
  orange3: "#ffab91",
  red1: "#b71c1c77",
  red2: "#e57373cc",
  pink: "#f8bbd0"
}, F0 = {
  grey1: "#424242",
  grey2: "#bdbdbd77",
  brown: "#5d4037",
  purple1: "#ba68c8",
  purple2: "#8e24aa",
  purple3: "#9575cd",
  "blue-gray": "#607d8b",
  blue1: "#3949ab",
  blue2: "#1e88e5cc",
  blue3: "#6E93FA",
  turquoise: "#009688",
  green1: "#4caf50",
  green2: "#2e7d32",
  green3: "#7cb342",
  green4: "#afb42b",
  yellow: "#ffd600",
  orange1: "#ffab00",
  orange2: "#ff6d00",
  orange3: "#dd2c00",
  red1: "#c62828",
  red2: "#ef5350",
  pink: "#ff4081cc"
}, B0 = {
  grey1: "#3c3c434c",
  grey2: "#3c3c432d",
  brown: "#4e342e",
  purple1: "#ab47bc",
  purple2: "#7b1fa2",
  purple3: "#7e57c2",
  "blue-gray": "#37474f",
  blue1: "#0d47a1",
  blue2: "#1976d2",
  blue3: "#03a9f4",
  turquoise: "#00796b",
  green1: "#1b5e20",
  green2: "#4caf50",
  green3: "#689f38",
  green4: "#9e9d24",
  yellow: "#ffd600",
  orange1: "#ffb300",
  orange2: "#f57c00",
  orange3: "#d84315",
  red1: "#d50000",
  red2: "#ef5350",
  pink: "#f06292"
}, _0 = {
  grey1: "#ebebf599",
  grey2: "#ebebf54c",
  brown: "#8d6e63",
  purple1: "#ce93d8",
  purple2: "#ab47bc",
  purple3: "#9575cd",
  "blue-gray": "#90a4ae",
  blue1: "#2962ff",
  blue2: "#0a84ffff",
  blue3: "#64d2ffff",
  turquoise: "#009688",
  green1: "#388e3c",
  green2: "#30d158ff",
  green3: "#aed581",
  green4: "#d4e157",
  yellow: "#ffd60aff",
  orange1: "#ffd54f",
  orange2: "#ff9f0aff",
  orange3: "#ef6c00",
  red1: "#d32f2f",
  red2: "#ff453aff",
  pink: "#ff375fff"
};
function or(t, e) {
  return (e ? F0 : D0)[t] ?? "";
}
function An(t, e) {
  return (e ? _0 : B0)[t] ?? "";
}
const Vl = ({ sx: t, className: e, onColorChange: n }) => {
  const r = ut(), o = r.palette.mode === "dark";
  return /* @__PURE__ */ _(me, { container: !0, spacing: 1, sx: t, className: Ce("rte-background-color-picker", e), children: [
    /* @__PURE__ */ p(me, { size: { xs: 2 }, children: /* @__PURE__ */ p(
      fn,
      {
        className: Ce(
          "rte-background-color-picker-color-selection",
          "rte-background-color-picker-color-selection-unset"
        ),
        onClick: () => n(void 0),
        children: /* @__PURE__ */ p(Et, { className: "rte-background-color-picker-no-color-icon" })
      }
    ) }),
    Si.slice(1).map((i) => {
      const s = or(i, o);
      return /* @__PURE__ */ p(me, { size: { xs: 2 }, children: /* @__PURE__ */ p(
        fn,
        {
          className: "rte-background-color-picker-color-selection",
          sx: {
            backgroundColor: s || r.palette.text.primary,
            borderColor: s.length > 0 ? pn(s, 0.6) : r.palette.text.primary
          },
          onClick: () => n(i)
        }
      ) }, i);
    })
  ] });
}, z0 = (t) => {
  switch (t) {
    case "meta":
      return 0;
    case "shift":
      return 1;
    case "alt":
      return 2;
    case "tab":
      return 3;
    case "enter":
      return 4;
    default:
      return 999;
  }
};
function jl(t) {
  switch (t) {
    case "meta":
      return Rs() ? "⌘" : "Ctrl";
    case "alt":
      return Rs() ? "⌥" : "Alt";
    case "shift":
      return "⇧";
    case "tab":
      return "Tab";
    case "enter":
      return "Enter";
    default:
      return t.toUpperCase();
  }
}
function Hl(t) {
  return qu(t, (e) => z0(e));
}
function Rs() {
  return navigator.platform.toUpperCase().indexOf("MAC") >= 0 || navigator.platform === "iPhone";
}
const V0 = ({ sx: t, shortcutComponents: e, className: n }) => /* @__PURE__ */ p(it, { variant: "caption", fontSize: 10, fontWeight: "500", color: "textSecondary", className: n, sx: t, children: Ku(Hl(e)).map((r) => jl(r)).value() }), Ke = ({
  key: t,
  icon: e,
  titleKey: n,
  shortcutComponents: r,
  isDestructive: o = !1,
  rounded: i = !0,
  className: s,
  ...a
}) => {
  const { t: l } = ee();
  return /* @__PURE__ */ _(
    Ut,
    {
      className: Ce(s, "rte-editor-menu-item", i && "rte-rounded", o && "rte-destructive"),
      ...a,
      children: [
        e && /* @__PURE__ */ p(pa, { children: e }),
        /* @__PURE__ */ p(Yo, { primary: l(n) }),
        r && /* @__PURE__ */ p(V0, { className: "keyboard-shortcuts-container", shortcutComponents: r })
      ]
    },
    t
  );
}, xi = ({ sx: t, className: e, value: n, onValueChanged: r }) => {
  const o = ut();
  return /* @__PURE__ */ p(me, { container: !0, spacing: 1, sx: t, className: Ce("rte-text-color-picker", e), children: Si.map((i, s) => {
    const a = j0(i, o);
    return /* @__PURE__ */ p(me, { size: { xs: 2 }, children: /* @__PURE__ */ p(
      fn,
      {
        className: "rte-text-color-picker-color-option",
        sx: {
          backgroundColor: a,
          borderColor: a != o.palette.common.white ? pn(a, 0.6) : o.palette.divider
        },
        onClick: () => r(i),
        children: n === i && /* @__PURE__ */ p(
          Pa,
          {
            className: "rte-text-color-picker-color-option-selected-icon",
            sx: {
              color: o.palette.getContrastText(a)
            }
          }
        )
      }
    ) }, i ?? s);
  }) });
};
function j0(t, e) {
  return t === "primary" ? e.palette.text.primary : t === "secondary" ? e.palette.mode === "light" ? e.palette.common.white : e.palette.common.black : An(t, e.palette.mode === "dark");
}
function Wt() {
  var t, e;
  return ((e = (t = document.getElementsByClassName("rte-editor-root").item(0)) == null ? void 0 : t.classList) == null ? void 0 : e.contains("dark-mode")) ?? !1;
}
const H0 = Wu.extend({
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            renderHTML: (t) => {
              if (!t.color)
                return {};
              const e = t.color, n = An(e, Wt());
              return {
                "data-color": e != "primary" ? e : void 0,
                style: n.length > 0 ? `color: ${n}` : "",
                class: e === "secondary" ? "secondary-text" : void 0
              };
            },
            parseHTML: (t) => t.getAttribute("data-color")
          }
        }
      }
    ];
  }
});
function Is(t) {
  const e = /(#[0-9a-f]{3,6})\b/gi, n = [];
  return t.descendants((r, o) => {
    r.text && Array.from(r.text.matchAll(e)).forEach((i) => {
      const s = i[0], a = i.index || 0, l = o + a, c = l + s.length, u = Ma.inline(l, c, {
        class: "rte-color-swatch",
        style: `--color: ${s}`
      });
      n.push(u);
    });
  }), Ia.create(t, n);
}
const U0 = Le.create({
  name: "colorHighlighter",
  addProseMirrorPlugins() {
    return [
      new bt({
        state: {
          init(t, { doc: e }) {
            return Is(e);
          },
          apply(t, e) {
            return t.docChanged ? Is(t.doc) : e;
          }
        },
        props: {
          decorations(t) {
            return this.getState(t);
          }
        }
      })
    ];
  }
}), W0 = Le.create({
  name: "emojiReplacer",
  addInputRules() {
    return [
      k({ find: /-___- $/, replace: "😑 " }),
      k({ find: /:'-\) $/, replace: "😂 " }),
      k({ find: /':-\) $/, replace: "😅 " }),
      k({ find: /':-D $/, replace: "😅 " }),
      k({ find: />:-\) $/, replace: "😆 " }),
      k({ find: /-__- $/, replace: "😑 " }),
      k({ find: /':-\( $/, replace: "😓 " }),
      k({ find: /:'-\( $/, replace: "😢 " }),
      k({ find: />:-\( $/, replace: "😠 " }),
      k({ find: /O:-\) $/, replace: "😇 " }),
      k({ find: /0:-3 $/, replace: "😇 " }),
      k({ find: /0:-\) $/, replace: "😇 " }),
      k({ find: /0;\^\) $/, replace: "😇 " }),
      k({ find: /O;-\) $/, replace: "😇 " }),
      k({ find: /0;-\) $/, replace: "😇 " }),
      k({ find: /O:-3 $/, replace: "😇 " }),
      k({ find: /:'\) $/, replace: "😂 " }),
      k({ find: /:-D $/, replace: "😃 " }),
      k({ find: /':\) $/, replace: "😅 " }),
      k({ find: /'=\) $/, replace: "😅 " }),
      k({ find: /':D $/, replace: "😅 " }),
      k({ find: /'=D $/, replace: "😅 " }),
      k({ find: />:\) $/, replace: "😆 " }),
      k({ find: />;\) $/, replace: "😆 " }),
      k({ find: />=\) $/, replace: "😆 " }),
      k({ find: /;-\) $/, replace: "😉 " }),
      k({ find: /\*-\) $/, replace: "😉 " }),
      k({ find: /;-\] $/, replace: "😉 " }),
      k({ find: /;\^\) $/, replace: "😉 " }),
      k({ find: /B-\) $/, replace: "😎 " }),
      k({ find: /8-\) $/, replace: "😎 " }),
      k({ find: /B-D $/, replace: "😎 " }),
      k({ find: /8-D $/, replace: "😎 " }),
      k({ find: /:-\* $/, replace: "😘 " }),
      k({ find: /:\^\* $/, replace: "😘 " }),
      k({ find: /:-\) $/, replace: "🙂 " }),
      k({ find: /-_- $/, replace: "😑 " }),
      k({ find: /:-X $/, replace: "😶 " }),
      k({ find: /:-# $/, replace: "😶 " }),
      k({ find: /:-x $/, replace: "😶 " }),
      k({ find: />.< $/, replace: "😣 " }),
      k({ find: /:-O $/, replace: "😮 " }),
      k({ find: /:-o $/, replace: "😮 " }),
      k({ find: /O_O $/, replace: "😮 " }),
      k({ find: />:O $/, replace: "😮 " }),
      k({ find: /:-P $/, replace: "😛 " }),
      k({ find: /:-p $/, replace: "😛 " }),
      k({ find: /:-Þ $/, replace: "😛 " }),
      k({ find: /:-þ $/, replace: "😛 " }),
      k({ find: /:-b $/, replace: "😛 " }),
      k({ find: />:P $/, replace: "😜 " }),
      k({ find: /X-P $/, replace: "😜 " }),
      k({ find: /x-p $/, replace: "😜 " }),
      k({ find: /':\( $/, replace: "😓 " }),
      k({ find: /'=\( $/, replace: "😓 " }),
      k({ find: />:\\ $/, replace: "😕 " }),
      k({ find: />:\/ $/, replace: "😕 " }),
      k({ find: /:-\/ $/, replace: "😕 " }),
      k({ find: /:-. $/, replace: "😕 " }),
      k({ find: />:\[ $/, replace: "😞 " }),
      k({ find: /:-\( $/, replace: "😞 " }),
      k({ find: /:-\[ $/, replace: "😞 " }),
      k({ find: /:'\( $/, replace: "😢 " }),
      k({ find: /;-\( $/, replace: "😢 " }),
      k({ find: /#-\) $/, replace: "😵 " }),
      k({ find: /%-\) $/, replace: "😵 " }),
      k({ find: /X-\) $/, replace: "😵 " }),
      k({ find: />:\( $/, replace: "😠 " }),
      k({ find: /0:3 $/, replace: "😇 " }),
      k({ find: /0:\) $/, replace: "😇 " }),
      k({ find: /O:\) $/, replace: "😇 " }),
      k({ find: /O=\) $/, replace: "😇 " }),
      k({ find: /O:3 $/, replace: "😇 " }),
      k({ find: /<\/3 $/, replace: "💔 " }),
      k({ find: /:D $/, replace: "😃 " }),
      k({ find: /=D $/, replace: "😃 " }),
      k({ find: /;\) $/, replace: "😉 " }),
      k({ find: /\*\) $/, replace: "😉 " }),
      k({ find: /;\] $/, replace: "😉 " }),
      k({ find: /;D $/, replace: "😉 " }),
      k({ find: /B\) $/, replace: "😎 " }),
      k({ find: /8\) $/, replace: "😎 " }),
      k({ find: /:\* $/, replace: "😘 " }),
      k({ find: /=\* $/, replace: "😘 " }),
      k({ find: /:\) $/, replace: "🙂 " }),
      k({ find: /=\] $/, replace: "🙂 " }),
      k({ find: /=\) $/, replace: "🙂 " }),
      k({ find: /:\] $/, replace: "🙂 " }),
      k({ find: /:X $/, replace: "😶 " }),
      k({ find: /:# $/, replace: "😶 " }),
      k({ find: /=X $/, replace: "😶 " }),
      k({ find: /=x $/, replace: "😶 " }),
      k({ find: /:x $/, replace: "😶 " }),
      k({ find: /=# $/, replace: "😶 " }),
      k({ find: /:O $/, replace: "😮 " }),
      k({ find: /:o $/, replace: "😮 " }),
      k({ find: /:P $/, replace: "😛 " }),
      k({ find: /=P $/, replace: "😛 " }),
      k({ find: /:p $/, replace: "😛  " }),
      k({ find: /=p $/, replace: "😛 " }),
      k({ find: /:Þ $/, replace: "😛 " }),
      k({ find: /:þ $/, replace: "😛 " }),
      k({ find: /:b $/, replace: "😛 " }),
      k({ find: /d: $/, replace: "😛 " }),
      k({ find: /:\/ $/, replace: "😕 " }),
      k({ find: /:\\ $/, replace: "😕 " }),
      k({ find: /=\/ $/, replace: "😕 " }),
      k({ find: /=\\ $/, replace: "😕 " }),
      k({ find: /:L $/, replace: "😕 " }),
      k({ find: /=L $/, replace: "😕 " }),
      k({ find: /:\( $/, replace: "😞 " }),
      k({ find: /:\[ $/, replace: "😞 " }),
      k({ find: /=\( $/, replace: "😞 " }),
      k({ find: /;\( $/, replace: "😢 " }),
      k({ find: /D: $/, replace: "😨 " }),
      k({ find: /:\$ $/, replace: "😳 " }),
      k({ find: /=\$ $/, replace: "😳 " }),
      k({ find: /#\) $/, replace: "😵 " }),
      k({ find: /%\) $/, replace: "😵 " }),
      k({ find: /X\) $/, replace: "😵 " }),
      k({ find: /:@ $/, replace: "😠 " }),
      k({ find: /<3 $/, replace: "❤️ " }),
      k({ find: /\/shrug $/, replace: "¯\\_(ツ)_/¯" })
    ];
  }
}), q0 = Ca.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (t) => t.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (t) => t.fontSize ? {
              style: `font-size: ${t.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  addCommands() {
    return {
      setFontSize: (t) => ({ chain: e }) => {
        e().setMark("textStyle", { fontSize: `${t}rem` }).run();
      },
      unsetFontSize: () => ({ chain: t }) => {
        t().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
      }
    };
  }
}), K0 = xd.extend({
  addAttributes() {
    return {
      color: {
        default: null,
        renderHTML: (t) => {
          if (!t.color)
            return {};
          const e = t.color, n = or(e, Wt());
          return {
            "data-color": e,
            style: n.length > 0 ? `background-color: ${n}` : void 0,
            class: e === "secondary" ? "rte-secondary-background" : void 0
          };
        },
        parseHTML: (t) => t.getAttribute("data-color")
      }
    };
  }
}), Y0 = Td.extend({
  name: "customLink",
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      color: {
        default: null,
        renderHTML: (e) => {
          if (!e.color)
            return {};
          const n = e.color, r = An(n, Wt());
          return {
            "data-color": n != "primary" ? n : void 0,
            style: r.length > 0 ? `color: ${r}; text-decoration-color: ${r}` : "",
            class: n === "secondary" ? "rte-secondary-text" : void 0
          };
        },
        parseHTML: (e) => e.getAttribute("data-color")
      }
    };
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  addCommands() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      setLinkColor: (e) => ({ state: n, commands: r }) => (r.updateAttributes("customLink", { color: e }), n.tr),
      unsetLinkColor: () => ({ state: e, commands: n }) => (n.updateAttributes("customLink", { color: void 0 }), e.tr)
    };
  }
});
function G0(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Ti = G0, J0 = typeof Cr == "object" && Cr && Cr.Object === Object && Cr, Z0 = J0, X0 = Z0, Q0 = typeof self == "object" && self && self.Object === Object && self, ev = X0 || Q0 || Function("return this")(), Ul = ev, tv = Ul, nv = function() {
  return tv.Date.now();
}, rv = nv, ov = /\s/;
function iv(t) {
  for (var e = t.length; e-- && ov.test(t.charAt(e)); )
    ;
  return e;
}
var sv = iv, av = sv, lv = /^\s+/;
function cv(t) {
  return t && t.slice(0, av(t) + 1).replace(lv, "");
}
var uv = cv, dv = Ul, fv = dv.Symbol, Wl = fv, Ms = Wl, ql = Object.prototype, pv = ql.hasOwnProperty, mv = ql.toString, Mn = Ms ? Ms.toStringTag : void 0;
function hv(t) {
  var e = pv.call(t, Mn), n = t[Mn];
  try {
    t[Mn] = void 0;
    var r = !0;
  } catch {
  }
  var o = mv.call(t);
  return r && (e ? t[Mn] = n : delete t[Mn]), o;
}
var gv = hv, yv = Object.prototype, bv = yv.toString;
function vv(t) {
  return bv.call(t);
}
var wv = vv, Ps = Wl, Cv = gv, Sv = wv, xv = "[object Null]", Tv = "[object Undefined]", Ns = Ps ? Ps.toStringTag : void 0;
function kv(t) {
  return t == null ? t === void 0 ? Tv : xv : Ns && Ns in Object(t) ? Cv(t) : Sv(t);
}
var Av = kv;
function Ev(t) {
  return t != null && typeof t == "object";
}
var Ov = Ev, $v = Av, Rv = Ov, Iv = "[object Symbol]";
function Mv(t) {
  return typeof t == "symbol" || Rv(t) && $v(t) == Iv;
}
var Pv = Mv, Nv = uv, Ls = Ti, Lv = Pv, Ds = NaN, Dv = /^[-+]0x[0-9a-f]+$/i, Fv = /^0b[01]+$/i, Bv = /^0o[0-7]+$/i, _v = parseInt;
function zv(t) {
  if (typeof t == "number")
    return t;
  if (Lv(t))
    return Ds;
  if (Ls(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Ls(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = Nv(t);
  var n = Fv.test(t);
  return n || Bv.test(t) ? _v(t.slice(2), n ? 2 : 8) : Dv.test(t) ? Ds : +t;
}
var Vv = zv, jv = Ti, Ro = rv, Fs = Vv, Hv = "Expected a function", Uv = Math.max, Wv = Math.min;
function qv(t, e, n) {
  var r, o, i, s, a, l, c = 0, u = !1, f = !1, m = !0;
  if (typeof t != "function")
    throw new TypeError(Hv);
  e = Fs(e) || 0, jv(n) && (u = !!n.leading, f = "maxWait" in n, i = f ? Uv(Fs(n.maxWait) || 0, e) : i, m = "trailing" in n ? !!n.trailing : m);
  function g(x) {
    var L = r, D = o;
    return r = o = void 0, c = x, s = t.apply(D, L), s;
  }
  function b(x) {
    return c = x, a = setTimeout(C, e), u ? g(x) : s;
  }
  function d(x) {
    var L = x - l, D = x - c, F = e - L;
    return f ? Wv(F, i - D) : F;
  }
  function v(x) {
    var L = x - l, D = x - c;
    return l === void 0 || L >= e || L < 0 || f && D >= i;
  }
  function C() {
    var x = Ro();
    if (v(x))
      return R(x);
    a = setTimeout(C, d(x));
  }
  function R(x) {
    return a = void 0, m && r ? g(x) : (r = o = void 0, s);
  }
  function E() {
    a !== void 0 && clearTimeout(a), c = 0, r = l = o = a = void 0;
  }
  function y() {
    return a === void 0 ? s : R(Ro());
  }
  function w() {
    var x = Ro(), L = v(x);
    if (r = arguments, o = this, l = x, L) {
      if (a === void 0)
        return b(l);
      if (f)
        return clearTimeout(a), a = setTimeout(C, e), g(l);
    }
    return a === void 0 && (a = setTimeout(C, e)), s;
  }
  return w.cancel = E, w.flush = y, w;
}
var Kv = qv, Yv = Kv, Gv = Ti, Jv = "Expected a function";
function Zv(t, e, n) {
  var r = !0, o = !0;
  if (typeof t != "function")
    throw new TypeError(Jv);
  return Gv(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), Yv(t, e, {
    leading: r,
    maxWait: e,
    trailing: o
  });
}
var Xv = Zv;
const Qv = /* @__PURE__ */ wl(Xv), Kl = Object.fromEntries ? Object.fromEntries : (t) => {
  if (!t || !t[Symbol.iterator])
    throw new Error("Object.fromEntries() requires a single iterable argument");
  const e = {};
  return Object.keys(t).forEach((n) => {
    const [r, o] = t[n];
    e[r] = o;
  }), e;
};
function kt(t) {
  return Object.keys(t);
}
function zt(t, e) {
  if (!t)
    throw new Error(e);
}
function ki(t, e) {
  return e;
}
const Ai = (t) => {
  const e = t.length;
  let n = 0, r = "";
  for (; n < e; n++) {
    const o = t[n];
    if (o == null)
      continue;
    let i;
    switch (typeof o) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(o))
          i = Ai(o);
        else {
          zt(!ki(o, !1)), process.env.NODE_ENV !== "production" && o.styles !== void 0 && o.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), i = "";
          for (const s in o)
            o[s] && s && (i && (i += " "), i += s);
        }
        break;
      }
      default:
        i = o;
    }
    i && (r && (r += " "), r += i);
  }
  return r;
};
function e1(t, e, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    t[o] !== void 0 ? e.push(t[o] + ";") : o && (r += o + " ");
  }), r;
}
var t1 = function(e, n, r) {
  var o = e.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  e.registered[o] === void 0 && (e.registered[o] = n.styles);
}, n1 = function(e, n, r) {
  t1(e, n);
  var o = e.key + "-" + n.name;
  if (e.inserted[n.name] === void 0) {
    var i = n;
    do
      e.insert(n === i ? "." + o : "", i, e.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function r1(t, e) {
  var n;
  const r = Ur();
  return (!r.current || e.length !== ((n = r.current.prevDeps) === null || n === void 0 ? void 0 : n.length) || r.current.prevDeps.map((o, i) => o === e[i]).indexOf(!1) >= 0) && (r.current = {
    v: t(),
    prevDeps: [...e]
  }), r.current.v;
}
function o1(t) {
  return t instanceof Object && !("styles" in t) && !("length" in t) && !("__emotion_styles" in t);
}
const { createCssAndCx: i1 } = /* @__PURE__ */ (() => {
  function t(n, r, o) {
    const i = [], s = e1(n, i, o);
    return i.length < 2 ? o : s + r(i);
  }
  function e(n) {
    const { cache: r } = n, o = (...s) => {
      const a = kl(s, r.registered);
      n1(r, a);
      const l = `${r.key}-${a.name}`;
      e: {
        const c = s[0];
        if (!o1(c))
          break e;
        Bs.saveClassNameCSSObjectMapping(r, l, c);
      }
      return l;
    };
    return { css: o, cx: (...s) => {
      const a = Ai(s), l = Bs.fixClassName(r, a, o);
      return t(r.registered, o, l);
    } };
  }
  return { createCssAndCx: e };
})();
function Yl(t) {
  const { useCache: e } = t;
  function n() {
    const r = e(), { css: o, cx: i } = r1(() => i1({ cache: r }), [r]);
    return { css: o, cx: i };
  }
  return { useCssAndCx: n };
}
const Bs = /* @__PURE__ */ (() => {
  const t = /* @__PURE__ */ new WeakMap();
  return {
    saveClassNameCSSObjectMapping: (e, n, r) => {
      let o = t.get(e);
      o === void 0 && (o = /* @__PURE__ */ new Map(), t.set(e, o)), o.set(n, r);
    },
    fixClassName: /* @__PURE__ */ (() => {
      function e(n) {
        let r = !1;
        return n.map(([o, i]) => {
          if (i === void 0)
            return o;
          let s;
          if (r)
            s = {
              "&&": i
            };
          else {
            s = o;
            for (const a in i)
              if (a.startsWith("@media")) {
                r = !0;
                break;
              }
          }
          return s;
        });
      }
      return (n, r, o) => {
        const i = t.get(n);
        return Ai(e(r.split(" ").map((s) => [
          s,
          i == null ? void 0 : i.get(s)
        ])).map((s) => typeof s == "string" ? s : o(s)));
      };
    })()
  };
})();
function At(t) {
  if (!(t instanceof Object) || typeof t == "function")
    return t;
  const e = [];
  for (const n in t) {
    const r = t[n], o = typeof r;
    if (!(o === "string" || o === "number" && !isNaN(r) || o === "boolean" || r === void 0 || r === null))
      return t;
    e.push(`${n}:${o}_${r}`);
  }
  return "xSqLiJdLMd9s" + e.join("|");
}
function Ei(t, e, n) {
  if (!(e instanceof Object))
    return t;
  const r = {};
  return kt(t).forEach((o) => r[o] = n(t[o], e[o])), kt(e).forEach((o) => {
    if (o in t)
      return;
    const i = e[o];
    typeof i == "string" && (r[o] = i);
  }), r;
}
const Gl = ({ classes: t, theme: e, muiStyleOverridesParams: n, css: r, cx: o, name: i }) => {
  var s, a;
  e: {
    if (i === "makeStyle no name") {
      i = void 0;
      break e;
    }
    if (n !== void 0 && i === void 0)
      throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
  }
  let l;
  try {
    l = i === void 0 ? void 0 : ((a = (s = e.components) === null || s === void 0 ? void 0 : s[
      i
      /*example*/
    ]) === null || a === void 0 ? void 0 : a.styleOverrides) || void 0;
  } catch {
  }
  const c = mn(() => {
    if (l === void 0)
      return;
    const u = {};
    for (const f in l) {
      const m = l[f];
      m instanceof Object && (u[f] = r(typeof m == "function" ? m({
        theme: e,
        ownerState: n == null ? void 0 : n.ownerState,
        ...n == null ? void 0 : n.props
      }) : m));
    }
    return u;
  }, [
    l,
    At(n == null ? void 0 : n.props),
    At(n == null ? void 0 : n.ownerState),
    r
  ]);
  return t = mn(() => Ei(t, c, o), [t, c, o]), { classes: t };
}, s1 = Ed;
let a1 = 0;
function Jl(t) {
  const { useTheme: e, cache: n } = t, { useCache: r } = Zl({ cacheProvidedAtInception: n }), { useCssAndCx: o } = Yl({ useCache: r });
  function i(a) {
    const { name: l, uniqId: c = `${a1++}` } = a ?? {}, u = typeof l != "object" ? l : Object.keys(l)[0];
    return function(f) {
      const m = typeof f == "function" ? f : () => f;
      return function(b, d) {
        const v = e();
        let { css: C, cx: R } = o();
        const E = r();
        let y = mn(() => {
          const w = {}, x = typeof Proxy < "u" && new Proxy({}, {
            get: (F, h) => (typeof h == "symbol" && zt(!1), w[h] = `${E.key}-${c}${u !== void 0 ? `-${u}` : ""}-${h}-ref`)
          }), L = m(v, b, x || {}), D = Kl(kt(L).map((F) => {
            const h = L[F];
            return h.label || (h.label = `${u !== void 0 ? `${u}-` : ""}${F}`), [
              F,
              `${C(h)}${ki(F, F in w) ? ` ${w[F]}` : ""}`
            ];
          }));
          return kt(w).forEach((F) => {
            F in D || (D[F] = w[F]);
          }), D;
        }, [E, C, R, v, At(b)]);
        {
          const w = d == null ? void 0 : d.props.classes;
          y = mn(() => Ei(y, w, R), [y, At(w), R]);
        }
        {
          const w = Gl({
            classes: y,
            css: C,
            cx: R,
            name: u ?? "makeStyle no name",
            idOfUseStyles: c,
            muiStyleOverridesParams: d,
            // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
            theme: v
          });
          w.classes !== void 0 && (y = w.classes), w.css !== void 0 && (C = w.css), w.cx !== void 0 && (R = w.cx);
        }
        return {
          classes: y,
          theme: v,
          css: C,
          cx: R
        };
      };
    };
  }
  function s() {
    const a = e(), { css: l, cx: c } = o();
    return { theme: a, css: l, cx: c };
  }
  return { makeStyles: i, useStyles: s };
}
const l1 = Ta(void 0), { createUseCache: Zl } = /* @__PURE__ */ (() => {
  function t() {
    return ka(l1);
  }
  function e(n) {
    const { cacheProvidedAtInception: r } = n;
    function o() {
      var i;
      const s = s1(), a = t(), l = (i = r ?? a) !== null && i !== void 0 ? i : s;
      if (l === null)
        throw new Error([
          "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
          "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
          "MUI needs an Emotion cache to be provided for SSR to work.",
          "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
          "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
        ].join(`
`));
      return l;
    }
    return { useCache: o };
  }
  return { createUseCache: e };
})();
function _s(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function c1(t) {
  const { useTheme: e, cache: n } = t, { makeStyles: r } = Jl({ useTheme: e, cache: n });
  function o(i, s, a) {
    const l = typeof i == "string" ? (() => {
      const g = i, b = function({ children: d, ...v }) {
        return xu(g, v, d);
      };
      return Object.defineProperty(b, "name", {
        value: _s(g)
      }), b;
    })() : i, c = (() => {
      {
        const { name: b } = a ?? {};
        if (b !== void 0)
          return typeof b != "object" ? b : Object.keys(b)[0];
      }
      let g;
      e: {
        const b = l.displayName;
        if (typeof b != "string" || b === "")
          break e;
        g = b;
      }
      e: {
        if (g !== void 0)
          break e;
        const b = l.name;
        if (typeof b != "string" || b === "")
          break e;
        g = b;
      }
      if (g !== void 0)
        return g = g.replace(/\$/g, "usd"), g = g.replace(/\(/g, "_").replace(/\)/g, "_"), g = g.replace(/[^a-zA-Z0-9-_]/g, "_"), g;
    })(), u = r({ ...a, name: c })(typeof s == "function" ? (g, b, d) => Vs(s(g, b, d)) : Vs(s));
    function f(g) {
      for (const b in g)
        if (b !== "root")
          return !0;
      return !1;
    }
    const m = Aa(function(g, b) {
      const { className: d, classes: v, ...C } = g, { classes: R, cx: E } = u(g, { props: g }), y = E(R.root, d);
      return Xl.set(R, {
        ...R,
        root: y
      }), Su.createElement(l, { ref: b, className: f(R) ? d : y, ...typeof i == "string" ? {} : { classes: R }, ...C });
    });
    return c !== void 0 && (m.displayName = `${_s(c)}WithStyles`, Object.defineProperty(m, "name", { value: m.displayName })), m;
  }
  return o.getClasses = u1, { withStyles: o };
}
const Xl = /* @__PURE__ */ new WeakMap(), zs = "getClasses should only be used in conjunction with withStyles";
function u1(t) {
  const e = t.classes;
  if (e === void 0)
    throw new Error(zs);
  const n = Xl.get(e);
  if (n === void 0)
    throw new Error(zs);
  return n;
}
function Vs(t) {
  const e = {}, n = {};
  return Object.keys(t).forEach((r) => (r.startsWith("@media") ? n : e)[r] = t[r]), Object.keys(n).forEach((r) => {
    const o = n[r];
    Object.keys(o).forEach((i) => {
      var s;
      return e[i] = {
        ...(s = e[i]) !== null && s !== void 0 ? s : {},
        [r]: o[i]
      };
    });
  }), e;
}
const d1 = !(typeof document == "object" && typeof (document == null ? void 0 : document.getElementById) == "function") && !(typeof jest < "u") && !(typeof mocha < "u") && !(typeof __vitest_worker__ < "u");
function Ql(t) {
  ec = 0, wt.splice(0, wt.length);
  const { useContext: e, usePlugin: n, cache: r } = t, { useCache: o } = Zl({ cacheProvidedAtInception: r }), { useCssAndCx: i } = Yl({ useCache: o });
  return { tss: Mr({
    useContext: e,
    useCache: o,
    useCssAndCx: i,
    usePlugin: n ?? (({ classes: l, cx: c, css: u }) => ({ classes: l, cx: c, css: u })),
    name: void 0,
    doesUseNestedSelectors: !1
  }) };
}
let ec = 0;
const wt = [];
function Mr(t) {
  const { useContext: e, useCache: n, useCssAndCx: r, usePlugin: o, name: i, doesUseNestedSelectors: s } = t;
  return {
    withParams: () => Mr({ ...t }),
    withName: (a) => Mr({
      ...t,
      name: typeof a != "object" ? a : Object.keys(a)[0]
    }),
    withNestedSelectors: () => Mr({
      ...t,
      doesUseNestedSelectors: !0
    }),
    create: (a) => {
      const l = `x${ec++}`;
      if (i !== void 0)
        for (; ; ) {
          const u = wt.find((f) => f.name === i);
          if (u === void 0)
            break;
          wt.splice(wt.indexOf(u), 1);
        }
      const c = typeof a == "function" ? a : () => a;
      return function(f) {
        var m, g, b;
        const { classesOverrides: d, ...v } = f ?? {}, C = e(), { css: R, cx: E } = r(), y = n(), w = () => {
          const D = {}, F = c({
            ...f,
            ...C,
            ...s ? {
              classes: typeof Proxy > "u" ? {} : new Proxy({}, {
                get: (O, I) => {
                  if (typeof I == "symbol" && zt(!1), d1 && i === void 0)
                    throw new Error([
                      "tss-react: In SSR setups, in order to use nested selectors, you must also give a unique name to the useStyle function.",
                      'Solution: Use tss.withName("ComponentName").withNestedSelectors<...>()... to set a name.'
                    ].join(`
`));
                  e: {
                    if (i === void 0)
                      break e;
                    let P = wt.find((z) => z.name === i && z.idOfUseStyles === l);
                    P === void 0 && (P = { name: i, idOfUseStyles: l, nestedSelectorRuleNames: /* @__PURE__ */ new Set() }, wt.push(P)), P.nestedSelectorRuleNames.add(I);
                  }
                  e: {
                    if (i === void 0 || !(wt.find((z) => z.name === i && z.idOfUseStyles !== l && z.nestedSelectorRuleNames.has(I)) !== void 0))
                      break e;
                    throw new Error([
                      `tss-react: There are in your codebase two different useStyles named "${i}" that`,
                      `both use use the nested selector ${I}.
`,
                      `This may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.
`,
                      `Solution: Ensure each useStyles using nested selectors has a unique name.
`,
                      'Use: tss.withName("UniqueName").withNestedSelectors<...>()...'
                    ].join(" "));
                  }
                  return D[I] = `${y.key}-${i !== void 0 ? i : l}-${I}-ref`;
                }
              })
            } : {}
          });
          let h = Kl(kt(F).map((O) => {
            const I = F[O];
            return I.label || (I.label = `${i !== void 0 ? `${i}-` : ""}${O}`), [
              O,
              `${R(I)}${ki(O, O in D) ? ` ${D[O]}` : ""}`
            ];
          }));
          return kt(D).forEach((O) => {
            O in h || (h[O] = D[O]);
          }), h = Ei(h, d, E), h;
        }, x = f1({
          cache: y,
          cssObjectByRuleNameOrGetCssObjectByRuleName: a,
          classesOverridesRef: At(d),
          paramsAndPluginParamsRef: At(v),
          idOfUseStyles: l,
          context: C,
          getClasses: w
        }), L = o({
          classes: x,
          css: R,
          cx: E,
          idOfUseStyles: l,
          name: i,
          ...C,
          ...v
        });
        return {
          classes: (m = L.classes) !== null && m !== void 0 ? m : x,
          css: (g = L.css) !== null && g !== void 0 ? g : R,
          cx: (b = L.cx) !== null && b !== void 0 ? b : E,
          ...C
        };
      };
    }
  };
}
const kr = /* @__PURE__ */ new WeakMap();
function f1(t) {
  const { cache: e, cssObjectByRuleNameOrGetCssObjectByRuleName: n, classesOverridesRef: r, paramsAndPluginParamsRef: o, idOfUseStyles: i, context: s, getClasses: a } = t;
  e: {
    const c = kr.get(e);
    if (c === void 0)
      break e;
    const u = c.get(n);
    if (u === void 0)
      break e;
    const f = u.get(r);
    if (f === void 0)
      break e;
    const m = f.get(o);
    if (m === void 0)
      break e;
    const g = m.find(({ context: b }) => {
      if (b === s)
        return !0;
      if (kt(b).length !== kt(s).length)
        return !1;
      for (const d in b)
        if (At(b[d]) !== At(s[d]))
          return !1;
      return !0;
    });
    if (g === void 0)
      break e;
    if ((g == null ? void 0 : g.idOfUseStyles) !== i) {
      m.splice(m.indexOf(g), 1);
      break e;
    }
    return g.result;
  }
  const l = a();
  {
    kr.has(e) || kr.set(e, /* @__PURE__ */ new WeakMap());
    const c = kr.get(e);
    zt(c !== void 0), c.has(n) || c.set(n, /* @__PURE__ */ new Map());
    const u = c.get(n);
    zt(u !== void 0), u.has(r) || (u.size > 200 && u.clear(), u.set(r, /* @__PURE__ */ new Map()));
    const f = u.get(r);
    if (zt(f !== void 0), !f.has(o)) {
      e: {
        const g = typeof o == "string" ? 257 : 5;
        if (f.size < g)
          break e;
        f.clear();
      }
      f.set(o, []);
    }
    let m = f.get(o);
    zt(m !== void 0), m.length > 5 && (m = []), m.push({ idOfUseStyles: i, context: s, result: l });
  }
  return l;
}
function p1(t) {
  return {
    ...Jl(t),
    ...c1(t)
  };
}
const { tss: m1 } = Ql({
  useContext: () => ({})
});
m1.create({});
const { makeStyles: tc, withStyles: bx } = p1({
  useTheme: Ci
}), { tss: h1 } = Ql({
  useContext: function() {
    return { theme: Ci() };
  },
  usePlugin: Gl
});
h1.create({});
const g1 = tc({ name: { ResizableImageResizer: nc } })((t) => ({
  root: {
    position: "absolute",
    // The `outline` styles of the selected image add 3px to the edges, so we'll
    // position this offset by 3px outside to the bottom right
    bottom: -8,
    right: -8,
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: t.palette.primary.main,
    cursor: "nwse-resize"
  }
}));
function nc({ onResize: t, className: e, mouseDown: n, setMouseDown: r }) {
  const { classes: o, cx: i } = g1();
  Je(() => {
    if (!n)
      return;
    const a = (l) => {
      t(l);
    };
    return window.addEventListener("mousemove", a), () => {
      window.removeEventListener("mousemove", a);
    };
  }, [n, t]), Je(() => {
    const a = () => r(!1);
    return window.addEventListener("mouseup", a), () => {
      window.removeEventListener("mouseup", a);
    };
  }, [r]);
  const s = Ea(() => {
    r(!0);
  }, [r]);
  return (
    // There isn't a great role to use here (perhaps role="separator" is the
    // closest, as described here https://stackoverflow.com/a/43022983/4543977,
    // but we don't do keyboard-based resizing at this time so it doesn't make
    // sense to have it keyboard focusable)
    /* @__PURE__ */ p(
      "div",
      {
        className: i("resizable-image-resize", o.root, e),
        onMouseDown: s
      }
    )
  );
}
const y1 = 15, b1 = tc({ name: { ResizableImageComponent: rc } })((t) => ({
  imageContainer: {
    // Use inline-flex so that the container is only as big as the inner img
    display: "inline-flex",
    // Use relative position so that the resizer is positioned relative to
    // the img dimensions (via their common container)
    position: "relative"
  },
  image: {
    // We need display:block in order for the container element to be
    // sized properly (no extra space below the image)
    display: "block"
  },
  imageSelected: {
    // This "selected" state outline style is copied from our standard editor
    // styles (which are kept there as well so they appear even if not using our
    // custom resizable image).
    outline: `3px solid ${t.palette.primary.main}`,
    borderRadius: t.shape.borderRadius
  },
  resizer: {
    // As described here https://github.com/ueberdosis/tiptap/issues/3775,
    // updates to editor isEditable do not trigger re-rendering of node views.
    // Even editor state changes external to a given ReactNodeView component
    // will not trigger re-render (which is probably a good thing most of the
    // time, in terms of performance). As such, we always render the resizer
    // component with React (and so in the DOM), but hide it with CSS when the
    // editor is not editable. This also means its mouse event listeners will
    // also not fire, as intended.
    '.ProseMirror[contenteditable="false"] &': {
      display: "none"
    }
  }
}));
function rc(t) {
  const { node: e, selected: n, updateAttributes: r, extension: o } = t, { classes: i, cx: s } = b1(), { attrs: a } = e, l = Ur(null), [c, u] = ke(!1), f = n || c, m = mn(
    () => (
      // Throttle our "on resize" handler, since the event fires very rapidly during
      // dragging, so rendering would end up stuttering a bit without a throttle
      Qv(
        (b) => {
          if (!l.current)
            return;
          const d = l.current.getBoundingClientRect(), v = b.clientX - d.x, C = b.clientY - d.y, R = Math.max(
            v,
            d.width / d.height * C,
            // Set a minimum width, since any smaller is probably a mistake, and we
            // don't want images to get mistakenly shrunken below a size which makes
            // it hard to later select/resize the image
            y1
          );
          r({
            width: Math.round(R)
          });
        },
        50,
        { trailing: !0 }
        // Make sure our last event triggers a callback
      )
    ),
    [r]
  ), g = o.options.ChildComponent;
  return /* @__PURE__ */ p(
    wa,
    {
      style: {
        // Handle @tiptap/extension-text-align. Ideally we'd be able to inherit
        // this style from TextAlign's GlobalAttributes directly, but those are
        // only applied via `renderHTML` and not the `NodeView` renderer
        // (https://github.com/ueberdosis/tiptap/blob/6c34dec33ac39c9f037a0a72e4525f3fc6d422bf/packages/extension-text-align/src/text-align.ts#L43-L49),
        // so we have to do this manually/redundantly here.
        textAlign: a.textAlign,
        width: "100%"
      },
      as: o.options.inline ? "span" : "div",
      children: /* @__PURE__ */ _("div", { className: i.imageContainer, children: [
        /* @__PURE__ */ p(
          "img",
          {
            ref: l,
            src: a.src,
            height: "auto",
            width: a.width ? a.width : void 0,
            alt: a.alt || void 0,
            title: a.title || void 0,
            className: s(
              "rte-resizable-image",
              i.image,
              // For consistency with the standard Image extension selection
              // class/UI:
              f && "ProseMirror-selectednode",
              // We'll only show the outline when the editor content is selected
              f && i.imageSelected
            ),
            style: {
              // If no width has been specified, we use auto max-width
              maxWidth: a.width ? void 0 : "auto",
              // Always specify the aspect-ratio if it's been defined, to improve
              // initial render (so auto-height works before the image loads)
              aspectRatio: a.aspectRatio ?? void 0
            },
            "data-drag-handle": !0,
            onLoad: (b) => {
              const d = {};
              a.width || (d.width = b.currentTarget.naturalWidth), a.aspectRatio || (d.aspectRatio = String(b.currentTarget.naturalWidth / b.currentTarget.naturalHeight)), (d.width || d.aspectRatio) && r(d);
            }
          }
        ),
        f && /* @__PURE__ */ p(
          nc,
          {
            onResize: m,
            className: i.resizer,
            mouseDown: c,
            setMouseDown: u
          }
        ),
        g && /* @__PURE__ */ p(g, { ...t })
      ] })
    }
  );
}
const v1 = kd.extend({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  addOptions() {
    var t;
    return {
      // Tiptap claims this.parent can be undefined, so disable this eslint rule
      // https://tiptap.dev/guide/custom-extensions/#extend-existing-attributes
      ...(t = this.parent) == null ? void 0 : t.call(this),
      // By default, allow all images where `src` is non-empty
      isAllowedImgSrc: (e) => e
    };
  },
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      // The `width` attribute will be used by users to override/specify the width of
      // the image. If not specified, the image will display with its default/full
      // width, up to a `max-width: 100%` (via CSS styles). Height will be set to
      // "auto", so `width` will always determine sizing, and we'll preserve the original
      // aspect ratio.
      width: {
        default: "200px",
        // How to render this attribute in the HTML, so it's serialized/saved
        // (and in this case, affects visuals)
        renderHTML: (e) => ({
          width: e.width
        }),
        // How to load this attribute from any existing HTML content
        parseHTML: (e) => e.getAttribute("width")
      },
      // The `aspectRatio` attribute will be used to set the `aspect-ratio` CSS
      // style, which ensures that whatever the width (the specific value set
      // via attribute or max-width of 100%, if the viewport is narrower than
      // that), the "height: auto" can be inferred even before the image loads,
      // making the page flash/jitter less before/after the image renders (see
      // https://developer.mozilla.org/en-US/docs/Web/CSS/aspect-ratio, and note
      // that the newer alternative approach they describe using
      // `attr(width) / attr(height)` does not work in Chrome and other browsers
      // yet). We'll make sure to set `aspectRatio` whenever a user resizes and
      // sets `width`, so that we improve initial page/image rendering.
      aspectRatio: {
        default: null,
        renderHTML: (e) => e.aspectRatio ? {
          style: `aspect-ratio: ${e.aspectRatio}`
        } : {},
        parseHTML: (e) => e.style.aspectRatio
      }
    };
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "img",
      cl(
        // Always render the `height="auto"` attribute by default, since we control the
        // width with resizing (and this maintains the image aspect ratio)
        {
          height: "auto"
        },
        this.options.HTMLAttributes,
        t
      )
    ];
  },
  parseHTML() {
    return [
      {
        // This default tag-parsing rule is taken directly from the builtin Image
        // extension
        // (https://github.com/ueberdosis/tiptap/blob/4108e9f991522b5ac8f669ae2d24cfe9f91780ba/packages/extension-image/src/image.ts#L61-L69)
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])',
        /**
         * We add `getAttrs` here to include our own additional conditions for
         * parsing/matching images from input HTML (where returning false marks it as
         * not "matching", therefore ignoring it and not creating an Image node in
         * prosemirror). See https://tiptap.dev/guide/custom-extensions#parse-html
         */
        getAttrs: (t) => {
          if (!(t instanceof Element))
            return !1;
          const e = t.getAttribute("src");
          return this.options.isAllowedImgSrc(e) && null;
        }
      }
    ];
  },
  /**
   * By default, the Image extension supports markdown-like input rules for text entered
   * in the editor, such as the string "![wat](https://picsum.photos/600/400)". We'll
   * override the default implementation so that we can restrict which `src` values are
   * permitted.
   */
  addInputRules() {
    var n;
    const t = (n = this.parent) == null ? void 0 : n.call(this);
    if (!t)
      return [];
    const e = (r) => {
      const [, , o, i, s] = r;
      return { src: i, alt: o, title: s };
    };
    return t.map(
      (r) => new ul({
        find: r.find,
        handler: (o) => {
          const i = e(o.match);
          if (this.options.isAllowedImgSrc(i.src ?? ""))
            return r.handler(o);
        }
      })
    );
  },
  addNodeView() {
    return Sa(rc);
  }
}), w1 = Ca.create({
  name: "slashCommand",
  // Makes sure that KeyDown events when menu is shown are not overridden by other extensions
  priority: 1e3,
  addOptions() {
    return {
      suggestion: {
        char: "/",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        command: ({ editor: t, range: e, props: n }) => {
          n.command({ editor: t, range: e });
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      Od({
        editor: this.editor,
        ...this.options.suggestion
      })
    ];
  }
}), C1 = Aa(({ items: t, command: e }, n) => {
  const { t: r } = ee(), [o, i] = ke(0), s = Ur(null);
  Je(() => i(0), [t]);
  function a(f) {
    const m = t[f];
    m != null && e(m);
  }
  function l() {
    i((f) => Math.max(f - 1, 0));
  }
  function c() {
    i((f) => Math.min(f + 1, t.length - 1));
  }
  function u() {
    a(o);
  }
  return Oa(n, () => ({
    onKeyDown: ({ event: f }) => f.key === "ArrowUp" ? (l(), !0) : f.key === "ArrowDown" ? (c(), !0) : f.key === "Enter" ? (u(), !0) : !1
  })), Je(() => {
    var f;
    if (o !== -1 && s.current) {
      const m = s.current, g = (f = m.children[0]) == null ? void 0 : f.children[o];
      if (g) {
        const b = g.offsetTop, d = b + g.offsetHeight, v = m.scrollTop, C = v + m.offsetHeight, R = 4;
        b - R < v ? m.scrollTop = b - R : d + R > C && (m.scrollTop = d - m.offsetHeight + R);
      }
    }
  }, [o]), /* @__PURE__ */ p(
    er,
    {
      className: Ce("rte-rte-slash-commands-menu-list-paper", "rte-bubble-menu", "rte-shadowed-panel"),
      ref: s,
      tabIndex: 0,
      children: /* @__PURE__ */ p(He, { className: "rte-slash-commands-menu-list", tabIndex: -1, children: t.length > 0 ? t.map((f, m) => /* @__PURE__ */ _(
        Ut,
        {
          tabIndex: -1,
          selected: m === o,
          onClick: () => a(m),
          className: "rte-rounded",
          onFocus: () => i(m),
          children: [
            /* @__PURE__ */ p(pa, { children: f.icon }),
            r(f.titleKey, { count: f.titleCountValue })
          ]
        },
        m
      )) : /* @__PURE__ */ p(Ut, { disabled: !0, children: "No result" }) })
    }
  );
});
var Pe = "top", Ze = "bottom", Xe = "right", Ne = "left", Oi = "auto", ir = [Pe, Ze, Xe, Ne], yn = "start", Jn = "end", S1 = "clippingParents", oc = "viewport", Pn = "popper", x1 = "reference", js = /* @__PURE__ */ ir.reduce(function(t, e) {
  return t.concat([e + "-" + yn, e + "-" + Jn]);
}, []), ic = /* @__PURE__ */ [].concat(ir, [Oi]).reduce(function(t, e) {
  return t.concat([e, e + "-" + yn, e + "-" + Jn]);
}, []), T1 = "beforeRead", k1 = "read", A1 = "afterRead", E1 = "beforeMain", O1 = "main", $1 = "afterMain", R1 = "beforeWrite", I1 = "write", M1 = "afterWrite", P1 = [T1, k1, A1, E1, O1, $1, R1, I1, M1];
function ct(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Ue(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function qt(t) {
  var e = Ue(t).Element;
  return t instanceof e || t instanceof Element;
}
function Ye(t) {
  var e = Ue(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function $i(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Ue(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function N1(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, i = e.elements[n];
    !Ye(i) || !ct(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(s) {
      var a = o[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function L1(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, s = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Ye(o) || !ct(o) || (Object.assign(o.style, a), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const sc = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: N1,
  effect: L1,
  requires: ["computeStyles"]
};
function lt(t) {
  return t.split("-")[0];
}
var jt = Math.max, jr = Math.min, bn = Math.round;
function Vo() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function ac() {
  return !/^((?!chrome|android).)*safari/i.test(Vo());
}
function vn(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), o = 1, i = 1;
  e && Ye(t) && (o = t.offsetWidth > 0 && bn(r.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && bn(r.height) / t.offsetHeight || 1);
  var s = qt(t) ? Ue(t) : window, a = s.visualViewport, l = !ac() && n, c = (r.left + (l && a ? a.offsetLeft : 0)) / o, u = (r.top + (l && a ? a.offsetTop : 0)) / i, f = r.width / o, m = r.height / i;
  return {
    width: f,
    height: m,
    top: u,
    right: c + f,
    bottom: u + m,
    left: c,
    x: c,
    y: u
  };
}
function Ri(t) {
  var e = vn(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function lc(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && $i(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function yt(t) {
  return Ue(t).getComputedStyle(t);
}
function D1(t) {
  return ["table", "td", "th"].indexOf(ct(t)) >= 0;
}
function Rt(t) {
  return ((qt(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function so(t) {
  return ct(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    ($i(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Rt(t)
  );
}
function Hs(t) {
  return !Ye(t) || // https://github.com/popperjs/popper-core/issues/837
  yt(t).position === "fixed" ? null : t.offsetParent;
}
function F1(t) {
  var e = /firefox/i.test(Vo()), n = /Trident/i.test(Vo());
  if (n && Ye(t)) {
    var r = yt(t);
    if (r.position === "fixed")
      return null;
  }
  var o = so(t);
  for ($i(o) && (o = o.host); Ye(o) && ["html", "body"].indexOf(ct(o)) < 0; ) {
    var i = yt(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function sr(t) {
  for (var e = Ue(t), n = Hs(t); n && D1(n) && yt(n).position === "static"; )
    n = Hs(n);
  return n && (ct(n) === "html" || ct(n) === "body" && yt(n).position === "static") ? e : n || F1(t) || e;
}
function Ii(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function jn(t, e, n) {
  return jt(t, jr(e, n));
}
function B1(t, e, n) {
  var r = jn(t, e, n);
  return r > n ? n : r;
}
function cc() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function uc(t) {
  return Object.assign({}, cc(), t);
}
function dc(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var _1 = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, uc(typeof e != "number" ? e : dc(e, ir));
};
function z1(t) {
  var e, n = t.state, r = t.name, o = t.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = lt(n.placement), l = Ii(a), c = [Ne, Xe].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!i || !s)) {
    var f = _1(o.padding, n), m = Ri(i), g = l === "y" ? Pe : Ne, b = l === "y" ? Ze : Xe, d = n.rects.reference[u] + n.rects.reference[l] - s[l] - n.rects.popper[u], v = s[l] - n.rects.reference[l], C = sr(i), R = C ? l === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, E = d / 2 - v / 2, y = f[g], w = R - m[u] - f[b], x = R / 2 - m[u] / 2 + E, L = jn(y, x, w), D = l;
    n.modifiersData[r] = (e = {}, e[D] = L, e.centerOffset = L - x, e);
  }
}
function V1(t) {
  var e = t.state, n = t.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || lc(e.elements.popper, o) && (e.elements.arrow = o));
}
const j1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: z1,
  effect: V1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function wn(t) {
  return t.split("-")[1];
}
var H1 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function U1(t, e) {
  var n = t.x, r = t.y, o = e.devicePixelRatio || 1;
  return {
    x: bn(n * o) / o || 0,
    y: bn(r * o) / o || 0
  };
}
function Us(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, i = t.variation, s = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, f = t.isFixed, m = s.x, g = m === void 0 ? 0 : m, b = s.y, d = b === void 0 ? 0 : b, v = typeof u == "function" ? u({
    x: g,
    y: d
  }) : {
    x: g,
    y: d
  };
  g = v.x, d = v.y;
  var C = s.hasOwnProperty("x"), R = s.hasOwnProperty("y"), E = Ne, y = Pe, w = window;
  if (c) {
    var x = sr(n), L = "clientHeight", D = "clientWidth";
    if (x === Ue(n) && (x = Rt(n), yt(x).position !== "static" && a === "absolute" && (L = "scrollHeight", D = "scrollWidth")), x = x, o === Pe || (o === Ne || o === Xe) && i === Jn) {
      y = Ze;
      var F = f && x === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[L]
      );
      d -= F - r.height, d *= l ? 1 : -1;
    }
    if (o === Ne || (o === Pe || o === Ze) && i === Jn) {
      E = Xe;
      var h = f && x === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[D]
      );
      g -= h - r.width, g *= l ? 1 : -1;
    }
  }
  var O = Object.assign({
    position: a
  }, c && H1), I = u === !0 ? U1({
    x: g,
    y: d
  }, Ue(n)) : {
    x: g,
    y: d
  };
  if (g = I.x, d = I.y, l) {
    var P;
    return Object.assign({}, O, (P = {}, P[y] = R ? "0" : "", P[E] = C ? "0" : "", P.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + d + "px)" : "translate3d(" + g + "px, " + d + "px, 0)", P));
  }
  return Object.assign({}, O, (e = {}, e[y] = R ? d + "px" : "", e[E] = C ? g + "px" : "", e.transform = "", e));
}
function W1(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: lt(e.placement),
    variation: wn(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Us(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Us(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const q1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: W1,
  data: {}
};
var Ar = {
  passive: !0
};
function K1(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, i = o === void 0 ? !0 : o, s = r.resize, a = s === void 0 ? !0 : s, l = Ue(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Ar);
  }), a && l.addEventListener("resize", n.update, Ar), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Ar);
    }), a && l.removeEventListener("resize", n.update, Ar);
  };
}
const Y1 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: K1,
  data: {}
};
var G1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Pr(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return G1[e];
  });
}
var J1 = {
  start: "end",
  end: "start"
};
function Ws(t) {
  return t.replace(/start|end/g, function(e) {
    return J1[e];
  });
}
function Mi(t) {
  var e = Ue(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Pi(t) {
  return vn(Rt(t)).left + Mi(t).scrollLeft;
}
function Z1(t, e) {
  var n = Ue(t), r = Rt(t), o = n.visualViewport, i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    var c = ac();
    (c || !c && e === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a + Pi(t),
    y: l
  };
}
function X1(t) {
  var e, n = Rt(t), r = Mi(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, i = jt(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = jt(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + Pi(t), l = -r.scrollTop;
  return yt(o || n).direction === "rtl" && (a += jt(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function Ni(t) {
  var e = yt(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function fc(t) {
  return ["html", "body", "#document"].indexOf(ct(t)) >= 0 ? t.ownerDocument.body : Ye(t) && Ni(t) ? t : fc(so(t));
}
function Hn(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = fc(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Ue(r), s = o ? [i].concat(i.visualViewport || [], Ni(r) ? r : []) : r, a = e.concat(s);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Hn(so(s)))
  );
}
function jo(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Q1(t, e) {
  var n = vn(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function qs(t, e, n) {
  return e === oc ? jo(Z1(t, n)) : qt(e) ? Q1(e, n) : jo(X1(Rt(t)));
}
function ew(t) {
  var e = Hn(so(t)), n = ["absolute", "fixed"].indexOf(yt(t).position) >= 0, r = n && Ye(t) ? sr(t) : t;
  return qt(r) ? e.filter(function(o) {
    return qt(o) && lc(o, r) && ct(o) !== "body";
  }) : [];
}
function tw(t, e, n, r) {
  var o = e === "clippingParents" ? ew(t) : [].concat(e), i = [].concat(o, [n]), s = i[0], a = i.reduce(function(l, c) {
    var u = qs(t, c, r);
    return l.top = jt(u.top, l.top), l.right = jr(u.right, l.right), l.bottom = jr(u.bottom, l.bottom), l.left = jt(u.left, l.left), l;
  }, qs(t, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function pc(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? lt(r) : null, i = r ? wn(r) : null, s = e.x + e.width / 2 - n.width / 2, a = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Pe:
      l = {
        x: s,
        y: e.y - n.height
      };
      break;
    case Ze:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case Xe:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case Ne:
      l = {
        x: e.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = o ? Ii(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case yn:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case Jn:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Zn(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, i = n.strategy, s = i === void 0 ? t.strategy : i, a = n.boundary, l = a === void 0 ? S1 : a, c = n.rootBoundary, u = c === void 0 ? oc : c, f = n.elementContext, m = f === void 0 ? Pn : f, g = n.altBoundary, b = g === void 0 ? !1 : g, d = n.padding, v = d === void 0 ? 0 : d, C = uc(typeof v != "number" ? v : dc(v, ir)), R = m === Pn ? x1 : Pn, E = t.rects.popper, y = t.elements[b ? R : m], w = tw(qt(y) ? y : y.contextElement || Rt(t.elements.popper), l, u, s), x = vn(t.elements.reference), L = pc({
    reference: x,
    element: E,
    strategy: "absolute",
    placement: o
  }), D = jo(Object.assign({}, E, L)), F = m === Pn ? D : x, h = {
    top: w.top - F.top + C.top,
    bottom: F.bottom - w.bottom + C.bottom,
    left: w.left - F.left + C.left,
    right: F.right - w.right + C.right
  }, O = t.modifiersData.offset;
  if (m === Pn && O) {
    var I = O[o];
    Object.keys(h).forEach(function(P) {
      var z = [Xe, Ze].indexOf(P) >= 0 ? 1 : -1, re = [Pe, Ze].indexOf(P) >= 0 ? "y" : "x";
      h[P] += I[re] * z;
    });
  }
  return h;
}
function nw(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? ic : l, u = wn(r), f = u ? a ? js : js.filter(function(b) {
    return wn(b) === u;
  }) : ir, m = f.filter(function(b) {
    return c.indexOf(b) >= 0;
  });
  m.length === 0 && (m = f);
  var g = m.reduce(function(b, d) {
    return b[d] = Zn(t, {
      placement: d,
      boundary: o,
      rootBoundary: i,
      padding: s
    })[lt(d)], b;
  }, {});
  return Object.keys(g).sort(function(b, d) {
    return g[b] - g[d];
  });
}
function rw(t) {
  if (lt(t) === Oi)
    return [];
  var e = Pr(t);
  return [Ws(t), e, Ws(e)];
}
function ow(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !0 : s, l = n.fallbackPlacements, c = n.padding, u = n.boundary, f = n.rootBoundary, m = n.altBoundary, g = n.flipVariations, b = g === void 0 ? !0 : g, d = n.allowedAutoPlacements, v = e.options.placement, C = lt(v), R = C === v, E = l || (R || !b ? [Pr(v)] : rw(v)), y = [v].concat(E).reduce(function(V, K) {
      return V.concat(lt(K) === Oi ? nw(e, {
        placement: K,
        boundary: u,
        rootBoundary: f,
        padding: c,
        flipVariations: b,
        allowedAutoPlacements: d
      }) : K);
    }, []), w = e.rects.reference, x = e.rects.popper, L = /* @__PURE__ */ new Map(), D = !0, F = y[0], h = 0; h < y.length; h++) {
      var O = y[h], I = lt(O), P = wn(O) === yn, z = [Pe, Ze].indexOf(I) >= 0, re = z ? "width" : "height", Q = Zn(e, {
        placement: O,
        boundary: u,
        rootBoundary: f,
        altBoundary: m,
        padding: c
      }), se = z ? P ? Xe : Ne : P ? Ze : Pe;
      w[re] > x[re] && (se = Pr(se));
      var ue = Pr(se), Ee = [];
      if (i && Ee.push(Q[I] <= 0), a && Ee.push(Q[se] <= 0, Q[ue] <= 0), Ee.every(function(V) {
        return V;
      })) {
        F = O, D = !1;
        break;
      }
      L.set(O, Ee);
    }
    if (D)
      for (var $ = b ? 3 : 1, M = function(K) {
        var U = y.find(function(Y) {
          var J = L.get(Y);
          if (J)
            return J.slice(0, K).every(function(X) {
              return X;
            });
        });
        if (U)
          return F = U, "break";
      }, H = $; H > 0; H--) {
        var q = M(H);
        if (q === "break") break;
      }
    e.placement !== F && (e.modifiersData[r]._skip = !0, e.placement = F, e.reset = !0);
  }
}
const iw = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: ow,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ks(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function Ys(t) {
  return [Pe, Xe, Ze, Ne].some(function(e) {
    return t[e] >= 0;
  });
}
function sw(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, s = Zn(e, {
    elementContext: "reference"
  }), a = Zn(e, {
    altBoundary: !0
  }), l = Ks(s, r), c = Ks(a, o, i), u = Ys(l), f = Ys(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const aw = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: sw
};
function lw(t, e, n) {
  var r = lt(t), o = [Ne, Pe].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * o, [Ne, Xe].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function cw(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, i = o === void 0 ? [0, 0] : o, s = ic.reduce(function(u, f) {
    return u[f] = lw(f, e.rects, i), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = s;
}
const uw = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: cw
};
function dw(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = pc({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const fw = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: dw,
  data: {}
};
function pw(t) {
  return t === "x" ? "y" : "x";
}
function mw(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !1 : s, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, f = n.padding, m = n.tether, g = m === void 0 ? !0 : m, b = n.tetherOffset, d = b === void 0 ? 0 : b, v = Zn(e, {
    boundary: l,
    rootBoundary: c,
    padding: f,
    altBoundary: u
  }), C = lt(e.placement), R = wn(e.placement), E = !R, y = Ii(C), w = pw(y), x = e.modifiersData.popperOffsets, L = e.rects.reference, D = e.rects.popper, F = typeof d == "function" ? d(Object.assign({}, e.rects, {
    placement: e.placement
  })) : d, h = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), O = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, I = {
    x: 0,
    y: 0
  };
  if (x) {
    if (i) {
      var P, z = y === "y" ? Pe : Ne, re = y === "y" ? Ze : Xe, Q = y === "y" ? "height" : "width", se = x[y], ue = se + v[z], Ee = se - v[re], $ = g ? -D[Q] / 2 : 0, M = R === yn ? L[Q] : D[Q], H = R === yn ? -D[Q] : -L[Q], q = e.elements.arrow, V = g && q ? Ri(q) : {
        width: 0,
        height: 0
      }, K = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : cc(), U = K[z], Y = K[re], J = jn(0, L[Q], V[Q]), X = E ? L[Q] / 2 - $ - J - U - h.mainAxis : M - J - U - h.mainAxis, Z = E ? -L[Q] / 2 + $ + J + Y + h.mainAxis : H + J + Y + h.mainAxis, we = e.elements.arrow && sr(e.elements.arrow), N = we ? y === "y" ? we.clientTop || 0 : we.clientLeft || 0 : 0, Oe = (P = O == null ? void 0 : O[y]) != null ? P : 0, dt = se + X - Oe - N, It = se + Z - Oe, En = jn(g ? jr(ue, dt) : ue, se, g ? jt(Ee, It) : Ee);
      x[y] = En, I[y] = En - se;
    }
    if (a) {
      var On, lr = y === "x" ? Pe : Ne, cr = y === "x" ? Ze : Xe, ft = x[w], vt = w === "y" ? "height" : "width", $n = ft + v[lr], Mt = ft - v[cr], Rn = [Pe, Ne].indexOf(C) !== -1, ur = (On = O == null ? void 0 : O[w]) != null ? On : 0, dr = Rn ? $n : ft - L[vt] - D[vt] - ur + h.altAxis, fr = Rn ? ft + L[vt] + D[vt] - ur - h.altAxis : Mt, pr = g && Rn ? B1(dr, ft, fr) : jn(g ? dr : $n, ft, g ? fr : Mt);
      x[w] = pr, I[w] = pr - ft;
    }
    e.modifiersData[r] = I;
  }
}
const hw = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mw,
  requiresIfExists: ["offset"]
};
function gw(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function yw(t) {
  return t === Ue(t) || !Ye(t) ? Mi(t) : gw(t);
}
function bw(t) {
  var e = t.getBoundingClientRect(), n = bn(e.width) / t.offsetWidth || 1, r = bn(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function vw(t, e, n) {
  n === void 0 && (n = !1);
  var r = Ye(e), o = Ye(e) && bw(e), i = Rt(e), s = vn(t, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ct(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ni(i)) && (a = yw(e)), Ye(e) ? (l = vn(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = Pi(i))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function ww(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var l = e.get(a);
        l && o(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Cw(t) {
  var e = ww(t);
  return P1.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function Sw(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function xw(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var Gs = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Js() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Tw(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, i = o === void 0 ? Gs : o;
  return function(a, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Gs, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], m = !1, g = {
      state: u,
      setOptions: function(C) {
        var R = typeof C == "function" ? C(u.options) : C;
        d(), u.options = Object.assign({}, i, u.options, R), u.scrollParents = {
          reference: qt(a) ? Hn(a) : a.contextElement ? Hn(a.contextElement) : [],
          popper: Hn(l)
        };
        var E = Cw(xw([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = E.filter(function(y) {
          return y.enabled;
        }), b(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var C = u.elements, R = C.reference, E = C.popper;
          if (Js(R, E)) {
            u.rects = {
              reference: vw(R, sr(E), u.options.strategy === "fixed"),
              popper: Ri(E)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(h) {
              return u.modifiersData[h.name] = Object.assign({}, h.data);
            });
            for (var y = 0; y < u.orderedModifiers.length; y++) {
              if (u.reset === !0) {
                u.reset = !1, y = -1;
                continue;
              }
              var w = u.orderedModifiers[y], x = w.fn, L = w.options, D = L === void 0 ? {} : L, F = w.name;
              typeof x == "function" && (u = x({
                state: u,
                options: D,
                name: F,
                instance: g
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Sw(function() {
        return new Promise(function(v) {
          g.forceUpdate(), v(u);
        });
      }),
      destroy: function() {
        d(), m = !0;
      }
    };
    if (!Js(a, l))
      return g;
    g.setOptions(c).then(function(v) {
      !m && c.onFirstUpdate && c.onFirstUpdate(v);
    });
    function b() {
      u.orderedModifiers.forEach(function(v) {
        var C = v.name, R = v.options, E = R === void 0 ? {} : R, y = v.effect;
        if (typeof y == "function") {
          var w = y({
            state: u,
            name: C,
            instance: g,
            options: E
          }), x = function() {
          };
          f.push(w || x);
        }
      });
    }
    function d() {
      f.forEach(function(v) {
        return v();
      }), f = [];
    }
    return g;
  };
}
var kw = [Y1, fw, q1, sc, uw, iw, hw, j1, aw], Aw = /* @__PURE__ */ Tw({
  defaultModifiers: kw
}), Ew = "tippy-box", mc = "tippy-content", Ow = "tippy-backdrop", hc = "tippy-arrow", gc = "tippy-svg-arrow", Nt = {
  passive: !0,
  capture: !0
}, yc = function() {
  return document.body;
};
function $w(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function Io(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function Li(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function bc(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function Zs(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function Rw(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function Iw(t) {
  return t.split(/\s+/).filter(Boolean);
}
function on(t) {
  return [].concat(t);
}
function Xs(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Mw(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function Pw(t) {
  return t.split("-")[0];
}
function Hr(t) {
  return [].slice.call(t);
}
function Qs(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function Un() {
  return document.createElement("div");
}
function Xn(t) {
  return ["Element", "Fragment"].some(function(e) {
    return Li(t, e);
  });
}
function Nw(t) {
  return Li(t, "NodeList");
}
function Lw(t) {
  return Li(t, "MouseEvent");
}
function Dw(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function Fw(t) {
  return Xn(t) ? [t] : Nw(t) ? Hr(t) : Array.isArray(t) ? t : Hr(document.querySelectorAll(t));
}
function Mo(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function ea(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function Bw(t) {
  var e, n = on(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function _w(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var i = o.popperRect, s = o.popperState, a = o.props, l = a.interactiveBorder, c = Pw(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var f = c === "bottom" ? u.top.y : 0, m = c === "top" ? u.bottom.y : 0, g = c === "right" ? u.left.x : 0, b = c === "left" ? u.right.x : 0, d = i.top - r + f > l, v = r - i.bottom - m > l, C = i.left - n + g > l, R = n - i.right - b > l;
    return d || v || C || R;
  });
}
function Po(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function ta(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var rt = {
  isTouch: !1
}, na = 0;
function zw() {
  rt.isTouch || (rt.isTouch = !0, window.performance && document.addEventListener("mousemove", vc));
}
function vc() {
  var t = performance.now();
  t - na < 20 && (rt.isTouch = !1, document.removeEventListener("mousemove", vc)), na = t;
}
function Vw() {
  var t = document.activeElement;
  if (Dw(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function jw() {
  document.addEventListener("touchstart", zw, Nt), window.addEventListener("blur", Vw);
}
var Hw = typeof window < "u" && typeof document < "u", Uw = Hw ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function nn(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function ra(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function Ww(t) {
  return ra(`
  %ctippy.js

  %c` + ra(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function wc(t) {
  return [
    Ww(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Qn;
process.env.NODE_ENV !== "production" && qw();
function qw() {
  Qn = /* @__PURE__ */ new Set();
}
function mt(t, e) {
  if (t && !Qn.has(e)) {
    var n;
    Qn.add(e), (n = console).warn.apply(n, wc(e));
  }
}
function Ho(t, e) {
  if (t && !Qn.has(e)) {
    var n;
    Qn.add(e), (n = console).error.apply(n, wc(e));
  }
}
function Kw(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  Ho(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Ho(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var Cc = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Yw = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, ze = Object.assign({
  appendTo: yc,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Cc, Yw), Gw = Object.keys(ze), Jw = function(e) {
  process.env.NODE_ENV !== "production" && xc(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    ze[r] = e[r];
  });
};
function Sc(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var i = o.name, s = o.defaultValue;
    if (i) {
      var a;
      r[i] = t[i] !== void 0 ? t[i] : (a = ze[i]) != null ? a : s;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function Zw(t, e) {
  var n = e ? Object.keys(Sc(Object.assign({}, ze, {
    plugins: e
  }))) : Gw, r = n.reduce(function(o, i) {
    var s = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return o;
    if (i === "content")
      o[i] = s;
    else
      try {
        o[i] = JSON.parse(s);
      } catch {
        o[i] = s;
      }
    return o;
  }, {});
  return r;
}
function oa(t, e) {
  var n = Object.assign({}, e, {
    content: bc(e.content, [t])
  }, e.ignoreAttributes ? {} : Zw(t, e.plugins));
  return n.aria = Object.assign({}, ze.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function xc(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var o = Rw(ze, Object.keys(Cc)), i = !$w(o, r);
    i && (i = e.filter(function(s) {
      return s.name === r;
    }).length === 0), mt(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Xw = function() {
  return "innerHTML";
};
function Uo(t, e) {
  t[Xw()] = e;
}
function ia(t) {
  var e = Un();
  return t === !0 ? e.className = hc : (e.className = gc, Xn(t) ? e.appendChild(t) : Uo(e, t)), e;
}
function sa(t, e) {
  Xn(e.content) ? (Uo(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? Uo(t, e.content) : t.textContent = e.content);
}
function Wo(t) {
  var e = t.firstElementChild, n = Hr(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(mc);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(hc) || r.classList.contains(gc);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(Ow);
    })
  };
}
function Tc(t) {
  var e = Un(), n = Un();
  n.className = Ew, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Un();
  r.className = mc, r.setAttribute("data-state", "hidden"), sa(r, t.props), e.appendChild(n), n.appendChild(r), o(t.props, t.props);
  function o(i, s) {
    var a = Wo(e), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (i.content !== s.content || i.allowHTML !== s.allowHTML) && sa(c, t.props), s.arrow ? u ? i.arrow !== s.arrow && (l.removeChild(u), l.appendChild(ia(s.arrow))) : l.appendChild(ia(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
Tc.$$tippy = !0;
var Qw = 1, Er = [], No = [];
function eC(t, e) {
  var n = oa(t, Object.assign({}, ze, Sc(Qs(e)))), r, o, i, s = !1, a = !1, l = !1, c = !1, u, f, m, g = [], b = Zs(dt, n.interactiveDebounce), d, v = Qw++, C = null, R = Mw(n.plugins), E = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, y = {
    // properties
    id: v,
    reference: t,
    popper: Un(),
    popperInstance: C,
    props: n,
    state: E,
    plugins: R,
    // methods
    clearDelayTimeouts: dr,
    setProps: fr,
    setContent: pr,
    show: Jc,
    hide: Zc,
    hideWithInteractivity: Xc,
    enable: Rn,
    disable: ur,
    unmount: Qc,
    destroy: eu
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && Ho(!0, "render() function has not been supplied."), y;
  var w = n.render(y), x = w.popper, L = w.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + y.id, y.popper = x, t._tippy = y, x._tippy = y;
  var D = R.map(function(A) {
    return A.fn(y);
  }), F = t.hasAttribute("aria-expanded");
  return we(), $(), se(), ue("onCreate", [y]), n.showOnCreate && $n(), x.addEventListener("mouseenter", function() {
    y.props.interactive && y.state.isVisible && y.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    y.props.interactive && y.props.trigger.indexOf("mouseenter") >= 0 && z().addEventListener("mousemove", b);
  }), y;
  function h() {
    var A = y.props.touch;
    return Array.isArray(A) ? A : [A, 0];
  }
  function O() {
    return h()[0] === "hold";
  }
  function I() {
    var A;
    return !!((A = y.props.render) != null && A.$$tippy);
  }
  function P() {
    return d || t;
  }
  function z() {
    var A = P().parentNode;
    return A ? Bw(A) : document;
  }
  function re() {
    return Wo(x);
  }
  function Q(A) {
    return y.state.isMounted && !y.state.isVisible || rt.isTouch || u && u.type === "focus" ? 0 : Io(y.props.delay, A ? 0 : 1, ze.delay);
  }
  function se(A) {
    A === void 0 && (A = !1), x.style.pointerEvents = y.props.interactive && !A ? "" : "none", x.style.zIndex = "" + y.props.zIndex;
  }
  function ue(A, B, W) {
    if (W === void 0 && (W = !0), D.forEach(function(ne) {
      ne[A] && ne[A].apply(ne, B);
    }), W) {
      var ae;
      (ae = y.props)[A].apply(ae, B);
    }
  }
  function Ee() {
    var A = y.props.aria;
    if (A.content) {
      var B = "aria-" + A.content, W = x.id, ae = on(y.props.triggerTarget || t);
      ae.forEach(function(ne) {
        var Ie = ne.getAttribute(B);
        if (y.state.isVisible)
          ne.setAttribute(B, Ie ? Ie + " " + W : W);
        else {
          var We = Ie && Ie.replace(W, "").trim();
          We ? ne.setAttribute(B, We) : ne.removeAttribute(B);
        }
      });
    }
  }
  function $() {
    if (!(F || !y.props.aria.expanded)) {
      var A = on(y.props.triggerTarget || t);
      A.forEach(function(B) {
        y.props.interactive ? B.setAttribute("aria-expanded", y.state.isVisible && B === P() ? "true" : "false") : B.removeAttribute("aria-expanded");
      });
    }
  }
  function M() {
    z().removeEventListener("mousemove", b), Er = Er.filter(function(A) {
      return A !== b;
    });
  }
  function H(A) {
    if (!(rt.isTouch && (l || A.type === "mousedown"))) {
      var B = A.composedPath && A.composedPath()[0] || A.target;
      if (!(y.props.interactive && ta(x, B))) {
        if (on(y.props.triggerTarget || t).some(function(W) {
          return ta(W, B);
        })) {
          if (rt.isTouch || y.state.isVisible && y.props.trigger.indexOf("click") >= 0)
            return;
        } else
          ue("onClickOutside", [y, A]);
        y.props.hideOnClick === !0 && (y.clearDelayTimeouts(), y.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), y.state.isMounted || U());
      }
    }
  }
  function q() {
    l = !0;
  }
  function V() {
    l = !1;
  }
  function K() {
    var A = z();
    A.addEventListener("mousedown", H, !0), A.addEventListener("touchend", H, Nt), A.addEventListener("touchstart", V, Nt), A.addEventListener("touchmove", q, Nt);
  }
  function U() {
    var A = z();
    A.removeEventListener("mousedown", H, !0), A.removeEventListener("touchend", H, Nt), A.removeEventListener("touchstart", V, Nt), A.removeEventListener("touchmove", q, Nt);
  }
  function Y(A, B) {
    X(A, function() {
      !y.state.isVisible && x.parentNode && x.parentNode.contains(x) && B();
    });
  }
  function J(A, B) {
    X(A, B);
  }
  function X(A, B) {
    var W = re().box;
    function ae(ne) {
      ne.target === W && (Po(W, "remove", ae), B());
    }
    if (A === 0)
      return B();
    Po(W, "remove", f), Po(W, "add", ae), f = ae;
  }
  function Z(A, B, W) {
    W === void 0 && (W = !1);
    var ae = on(y.props.triggerTarget || t);
    ae.forEach(function(ne) {
      ne.addEventListener(A, B, W), g.push({
        node: ne,
        eventType: A,
        handler: B,
        options: W
      });
    });
  }
  function we() {
    O() && (Z("touchstart", Oe, {
      passive: !0
    }), Z("touchend", It, {
      passive: !0
    })), Iw(y.props.trigger).forEach(function(A) {
      if (A !== "manual")
        switch (Z(A, Oe), A) {
          case "mouseenter":
            Z("mouseleave", It);
            break;
          case "focus":
            Z(Uw ? "focusout" : "blur", En);
            break;
          case "focusin":
            Z("focusout", En);
            break;
        }
    });
  }
  function N() {
    g.forEach(function(A) {
      var B = A.node, W = A.eventType, ae = A.handler, ne = A.options;
      B.removeEventListener(W, ae, ne);
    }), g = [];
  }
  function Oe(A) {
    var B, W = !1;
    if (!(!y.state.isEnabled || On(A) || a)) {
      var ae = ((B = u) == null ? void 0 : B.type) === "focus";
      u = A, d = A.currentTarget, $(), !y.state.isVisible && Lw(A) && Er.forEach(function(ne) {
        return ne(A);
      }), A.type === "click" && (y.props.trigger.indexOf("mouseenter") < 0 || s) && y.props.hideOnClick !== !1 && y.state.isVisible ? W = !0 : $n(A), A.type === "click" && (s = !W), W && !ae && Mt(A);
    }
  }
  function dt(A) {
    var B = A.target, W = P().contains(B) || x.contains(B);
    if (!(A.type === "mousemove" && W)) {
      var ae = vt().concat(x).map(function(ne) {
        var Ie, We = ne._tippy, Gt = (Ie = We.popperInstance) == null ? void 0 : Ie.state;
        return Gt ? {
          popperRect: ne.getBoundingClientRect(),
          popperState: Gt,
          props: n
        } : null;
      }).filter(Boolean);
      _w(ae, A) && (M(), Mt(A));
    }
  }
  function It(A) {
    var B = On(A) || y.props.trigger.indexOf("click") >= 0 && s;
    if (!B) {
      if (y.props.interactive) {
        y.hideWithInteractivity(A);
        return;
      }
      Mt(A);
    }
  }
  function En(A) {
    y.props.trigger.indexOf("focusin") < 0 && A.target !== P() || y.props.interactive && A.relatedTarget && x.contains(A.relatedTarget) || Mt(A);
  }
  function On(A) {
    return rt.isTouch ? O() !== A.type.indexOf("touch") >= 0 : !1;
  }
  function lr() {
    cr();
    var A = y.props, B = A.popperOptions, W = A.placement, ae = A.offset, ne = A.getReferenceClientRect, Ie = A.moveTransition, We = I() ? Wo(x).arrow : null, Gt = ne ? {
      getBoundingClientRect: ne,
      contextElement: ne.contextElement || P()
    } : t, Fi = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(mr) {
        var Jt = mr.state;
        if (I()) {
          var tu = re(), co = tu.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(hr) {
            hr === "placement" ? co.setAttribute("data-placement", Jt.placement) : Jt.attributes.popper["data-popper-" + hr] ? co.setAttribute("data-" + hr, "") : co.removeAttribute("data-" + hr);
          }), Jt.attributes.popper = {};
        }
      }
    }, Pt = [{
      name: "offset",
      options: {
        offset: ae
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ie
      }
    }, Fi];
    I() && We && Pt.push({
      name: "arrow",
      options: {
        element: We,
        padding: 3
      }
    }), Pt.push.apply(Pt, (B == null ? void 0 : B.modifiers) || []), y.popperInstance = Aw(Gt, x, Object.assign({}, B, {
      placement: W,
      onFirstUpdate: m,
      modifiers: Pt
    }));
  }
  function cr() {
    y.popperInstance && (y.popperInstance.destroy(), y.popperInstance = null);
  }
  function ft() {
    var A = y.props.appendTo, B, W = P();
    y.props.interactive && A === yc || A === "parent" ? B = W.parentNode : B = bc(A, [W]), B.contains(x) || B.appendChild(x), y.state.isMounted = !0, lr(), process.env.NODE_ENV !== "production" && mt(y.props.interactive && A === ze.appendTo && W.nextElementSibling !== x, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function vt() {
    return Hr(x.querySelectorAll("[data-tippy-root]"));
  }
  function $n(A) {
    y.clearDelayTimeouts(), A && ue("onTrigger", [y, A]), K();
    var B = Q(!0), W = h(), ae = W[0], ne = W[1];
    rt.isTouch && ae === "hold" && ne && (B = ne), B ? r = setTimeout(function() {
      y.show();
    }, B) : y.show();
  }
  function Mt(A) {
    if (y.clearDelayTimeouts(), ue("onUntrigger", [y, A]), !y.state.isVisible) {
      U();
      return;
    }
    if (!(y.props.trigger.indexOf("mouseenter") >= 0 && y.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(A.type) >= 0 && s)) {
      var B = Q(!1);
      B ? o = setTimeout(function() {
        y.state.isVisible && y.hide();
      }, B) : i = requestAnimationFrame(function() {
        y.hide();
      });
    }
  }
  function Rn() {
    y.state.isEnabled = !0;
  }
  function ur() {
    y.hide(), y.state.isEnabled = !1;
  }
  function dr() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function fr(A) {
    if (process.env.NODE_ENV !== "production" && mt(y.state.isDestroyed, nn("setProps")), !y.state.isDestroyed) {
      ue("onBeforeUpdate", [y, A]), N();
      var B = y.props, W = oa(t, Object.assign({}, B, Qs(A), {
        ignoreAttributes: !0
      }));
      y.props = W, we(), B.interactiveDebounce !== W.interactiveDebounce && (M(), b = Zs(dt, W.interactiveDebounce)), B.triggerTarget && !W.triggerTarget ? on(B.triggerTarget).forEach(function(ae) {
        ae.removeAttribute("aria-expanded");
      }) : W.triggerTarget && t.removeAttribute("aria-expanded"), $(), se(), L && L(B, W), y.popperInstance && (lr(), vt().forEach(function(ae) {
        requestAnimationFrame(ae._tippy.popperInstance.forceUpdate);
      })), ue("onAfterUpdate", [y, A]);
    }
  }
  function pr(A) {
    y.setProps({
      content: A
    });
  }
  function Jc() {
    process.env.NODE_ENV !== "production" && mt(y.state.isDestroyed, nn("show"));
    var A = y.state.isVisible, B = y.state.isDestroyed, W = !y.state.isEnabled, ae = rt.isTouch && !y.props.touch, ne = Io(y.props.duration, 0, ze.duration);
    if (!(A || B || W || ae) && !P().hasAttribute("disabled") && (ue("onShow", [y], !1), y.props.onShow(y) !== !1)) {
      if (y.state.isVisible = !0, I() && (x.style.visibility = "visible"), se(), K(), y.state.isMounted || (x.style.transition = "none"), I()) {
        var Ie = re(), We = Ie.box, Gt = Ie.content;
        Mo([We, Gt], 0);
      }
      m = function() {
        var Pt;
        if (!(!y.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = y.props.moveTransition, I() && y.props.animation) {
            var lo = re(), mr = lo.box, Jt = lo.content;
            Mo([mr, Jt], ne), ea([mr, Jt], "visible");
          }
          Ee(), $(), Xs(No, y), (Pt = y.popperInstance) == null || Pt.forceUpdate(), ue("onMount", [y]), y.props.animation && I() && J(ne, function() {
            y.state.isShown = !0, ue("onShown", [y]);
          });
        }
      }, ft();
    }
  }
  function Zc() {
    process.env.NODE_ENV !== "production" && mt(y.state.isDestroyed, nn("hide"));
    var A = !y.state.isVisible, B = y.state.isDestroyed, W = !y.state.isEnabled, ae = Io(y.props.duration, 1, ze.duration);
    if (!(A || B || W) && (ue("onHide", [y], !1), y.props.onHide(y) !== !1)) {
      if (y.state.isVisible = !1, y.state.isShown = !1, c = !1, s = !1, I() && (x.style.visibility = "hidden"), M(), U(), se(!0), I()) {
        var ne = re(), Ie = ne.box, We = ne.content;
        y.props.animation && (Mo([Ie, We], ae), ea([Ie, We], "hidden"));
      }
      Ee(), $(), y.props.animation ? I() && Y(ae, y.unmount) : y.unmount();
    }
  }
  function Xc(A) {
    process.env.NODE_ENV !== "production" && mt(y.state.isDestroyed, nn("hideWithInteractivity")), z().addEventListener("mousemove", b), Xs(Er, b), b(A);
  }
  function Qc() {
    process.env.NODE_ENV !== "production" && mt(y.state.isDestroyed, nn("unmount")), y.state.isVisible && y.hide(), y.state.isMounted && (cr(), vt().forEach(function(A) {
      A._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), No = No.filter(function(A) {
      return A !== y;
    }), y.state.isMounted = !1, ue("onHidden", [y]));
  }
  function eu() {
    process.env.NODE_ENV !== "production" && mt(y.state.isDestroyed, nn("destroy")), !y.state.isDestroyed && (y.clearDelayTimeouts(), y.unmount(), N(), delete t._tippy, y.state.isDestroyed = !0, ue("onDestroy", [y]));
  }
}
function ar(t, e) {
  e === void 0 && (e = {});
  var n = ze.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (Kw(t), xc(e, n)), jw();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = Fw(t);
  if (process.env.NODE_ENV !== "production") {
    var i = Xn(r.content), s = o.length > 1;
    mt(i && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = o.reduce(function(l, c) {
    var u = c && eC(c, r);
    return u && l.push(u), l;
  }, []);
  return Xn(t) ? a[0] : a;
}
ar.defaultProps = ze;
ar.setDefaultProps = Jw;
ar.currentInput = rt;
Object.assign({}, sc, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
ar.setDefaultProps({
  render: Tc
});
const qo = "insert-image", kc = new Event(qo), Ko = "insert-youtube-video", Ac = new Event(Ko), tC = Cn(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  /* @__PURE__ */ p("path", { d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V4C13 3.44772 13.4477 3 14 3H20ZM19 5H15V19H19V5ZM6 7C8.76142 7 11 9.23858 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12C1 9.23858 3.23858 7 6 7ZM7 9H5V10.999L3 11V13L5 12.999V15H7V12.999L9 13V11L7 10.999V9Z" }),
  "AddColumnLeft"
), nC = Cn(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  /* @__PURE__ */ p("path", { d: "M10 3C10.5523 3 11 3.44772 11 4V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM9 5H5V19H9V5ZM18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 9.23858 15.2386 7 18 7ZM19 9H17V10.999L15 11V13L17 12.999V15H19V12.999L21 13V11L19 10.999V9Z" }),
  "AddColumnRight"
), rC = Cn(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  /* @__PURE__ */ p("path", { d: "M12 13C14.7614 13 17 15.2386 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 15.2386 9.23858 13 12 13ZM13 15H11V16.999L9 17V19L11 18.999V21H13V18.999L15 19V17L13 16.999V15ZM20 3C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H20ZM5 5V9H19V5H5Z" }),
  "AddRowBelow"
), oC = Cn(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  /* @__PURE__ */ p("path", { d: "M20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13H20ZM19 15H5V19H19V15ZM12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1ZM13 3H11V4.999L9 5V7L11 6.999V9H13V6.999L15 7V5L13 4.999V3Z" }),
  "AddRowAbove"
), iC = Cn(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  /* @__PURE__ */ p("path", { d: "M12 3C12.5523 3 13 3.44772 13 4L12.9998 11.9998C13.8355 11.372 14.8743 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C14.9681 21 14.0092 20.6874 13.2129 20.1518L13 20C13 20.5523 12.5523 21 12 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H12ZM11 5H7V19H11V5ZM19 15H13V17H19V15Z" }),
  "DeleteColumn"
), sC = Cn(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  /* @__PURE__ */ p("path", { d: "M20 5C20.5523 5 21 5.44772 21 6V12C21 12.5523 20.5523 13 20 13C20.628 13.8355 21 14.8743 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 14.8743 11.372 13.8355 11.9998 12.9998L4 13C3.44772 13 3 12.5523 3 12V6C3 5.44772 3.44772 5 4 5H20ZM13 15V17H19V15H13ZM19 7H5V11H19V7Z" }),
  "DeleteRow"
);
function aC(t) {
  return /* @__PURE__ */ p(Sn, { children: /* @__PURE__ */ p("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", ...t, children: /* @__PURE__ */ p(
    "path",
    {
      fill: "currentColor",
      d: "M333-200v-133H200v133h133Zm214 0v-100l-33-33H413v133h134Zm80 0Zm116-133Zm-410-80v-101l-33-33H200v134h133Zm80 0Zm347 0v-134H627v99l35 35h98ZM529-547Zm-329-80Zm347 0v-133H413v98l35 35h99Zm213 0v-133H627v133h133ZM316-760Zm524 525L235-840h525q33 0 56.5 23.5T840-760v525ZM200-120q-33 0-56.5-23.5T120-200v-640l720 720H200Zm591 64L56-792q-11-11-11.5-27.5T56-848q11-11 28-11t28 11l736 736q12 12 11.5 28T847-56q-12 11-28 11.5T791-56Z"
    }
  ) }) });
}
function lC(t) {
  return /* @__PURE__ */ p(Sn, { children: /* @__PURE__ */ p(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 -960 960 960",
      width: "24px",
      fillRule: "evenodd",
      ...t,
      children: /* @__PURE__ */ p(
        "path",
        {
          fill: "currentColor",
          d: "M240-280q-17 0-28.5-11.5T200-320v-320q0-17 11.5-28.5T240-680q17 0 28.5 11.5T280-640v120h160v-120q0-17 11.5-28.5T480-680q17 0 28.5 11.5T520-640v320q0 17-11.5 28.5T480-280q-17 0-28.5-11.5T440-320v-120H280v120q0 17-11.5 28.5T240-280Zm480 0q-17 0-28.5-11.5T680-320v-280h-40q-17 0-28.5-11.5T600-640q0-17 11.5-28.5T640-680h80q17 0 28.5 11.5T760-640v320q0 17-11.5 28.5T720-280Z"
        }
      )
    }
  ) });
}
function cC(t) {
  return /* @__PURE__ */ p(Sn, { children: /* @__PURE__ */ p(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 -960 960 960",
      width: "24px",
      fillRule: "evenodd",
      ...t,
      children: /* @__PURE__ */ p(
        "path",
        {
          fill: "currentColor",
          d: "M160-280q-17 0-28.5-11.5T120-320v-320q0-17 11.5-28.5T160-680q17 0 28.5 11.5T200-640v120h160v-120q0-17 11.5-28.5T400-680q17 0 28.5 11.5T440-640v320q0 17-11.5 28.5T400-280q-17 0-28.5-11.5T360-320v-120H200v120q0 17-11.5 28.5T160-280Zm400 0q-17 0-28.5-11.5T520-320v-120q0-33 23.5-56.5T600-520h160v-80H560q-17 0-28.5-11.5T520-640q0-17 11.5-28.5T560-680h200q33 0 56.5 23.5T840-600v80q0 33-23.5 56.5T760-440H600v80h200q17 0 28.5 11.5T840-320q0 17-11.5 28.5T800-280H560Z"
        }
      )
    }
  ) });
}
function uC(t) {
  return /* @__PURE__ */ p(Sn, { children: /* @__PURE__ */ p(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 -960 960 960",
      width: "24px",
      fillRule: "evenodd",
      ...t,
      children: /* @__PURE__ */ p(
        "path",
        {
          fill: "currentColor",
          d: "M160-280q-17 0-28.5-11.5T120-320v-320q0-17 11.5-28.5T160-680q17 0 28.5 11.5T200-640v120h160v-120q0-17 11.5-28.5T400-680q17 0 28.5 11.5T440-640v320q0 17-11.5 28.5T400-280q-17 0-28.5-11.5T360-320v-120H200v120q0 17-11.5 28.5T160-280Zm400 0q-17 0-28.5-11.5T520-320q0-17 11.5-28.5T560-360h200v-80H640q-17 0-28.5-11.5T600-480q0-17 11.5-28.5T640-520h120v-80H560q-17 0-28.5-11.5T520-640q0-17 11.5-28.5T560-680h200q33 0 56.5 23.5T840-600v240q0 33-23.5 56.5T760-280H560Z"
        }
      )
    }
  ) });
}
const dC = (t) => /* @__PURE__ */ p(Sn, { children: /* @__PURE__ */ p(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fillRule: "evenodd",
    ...t,
    children: /* @__PURE__ */ p(
      "path",
      {
        fill: "currentColor",
        d: "M544-400 440-504 240-304l104 104 200-200Zm-47-161 104 104 199-199-104-104-199 199Zm-84-28 216 216-229 229q-24 24-56 24t-56-24l-2-2-3 3q-11 11-25.5 17t-30.5 6H108q-14 0-19-12t5-22l92-92-2-2q-24-24-24-56t24-56l229-229Zm0 0 227-227q24-24 56-24t56 24l104 104q24 24 24 56t-24 56L629-373 413-589Z"
      }
    )
  }
) }), fC = (t) => /* @__PURE__ */ p(Sn, { children: /* @__PURE__ */ p(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fillRule: "evenodd",
    ...t,
    children: /* @__PURE__ */ p(
      "path",
      {
        fill: "currentColor",
        d: "M346-140 100-386q-10-10-15-22t-5-25q0-13 5-25t15-22l230-229-75-75q-13-13-13.5-31t12.5-32q13-14 32-14t33 14l367 367q10 10 14.5 22t4.5 25q0 13-4.5 25T686-386L440-140q-10 10-22 15t-25 5q-13 0-25-5t-22-15Zm47-506L179-432h428L393-646Zm399 526q-36 0-61-25.5T706-208q0-27 13.5-51t30.5-47l19-24q9-11 23.5-11.5T816-331l20 25q16 23 30 47t14 51q0 37-26 62.5T792-120Z"
      }
    )
  }
) }), Ec = {
  titleKey: "heading1TextStyle",
  icon: /* @__PURE__ */ p(lC, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setNode("heading", { level: 1 }).unsetFontSize());
  }
}, Oc = {
  titleKey: "heading2TextStyle",
  icon: /* @__PURE__ */ p(cC, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setNode("heading", { level: 2 }).unsetFontSize());
  }
}, pC = {
  titleKey: "heading3TextStyle",
  icon: /* @__PURE__ */ p(uC, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setNode("heading", { level: 3 }).unsetFontSize());
  }
}, mC = {
  titleKey: "body",
  icon: /* @__PURE__ */ p(Wr, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setParagraph().unsetFontSize());
  }
}, hC = {
  titleKey: "caption",
  icon: /* @__PURE__ */ p(Wr, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setParagraph().setFontSize(0.8));
  }
}, $c = {
  titleKey: "bulletList",
  icon: /* @__PURE__ */ p(La, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.toggleBulletList());
  }
}, Rc = {
  titleKey: "orderedList",
  icon: /* @__PURE__ */ p(Da, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.toggleOrderedList());
  }
}, Ic = {
  titleKey: "taskList",
  icon: /* @__PURE__ */ p(Fa, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.toggleTaskList());
  }
}, Mc = {
  titleKey: "codeBlockTextStyle",
  icon: /* @__PURE__ */ p(Go, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setCodeBlock());
  }
}, Pc = {
  titleKey: "quoteTextStyle",
  icon: /* @__PURE__ */ p(Ju, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setBlockquote());
  }
}, gC = {
  titleKey: "bold",
  icon: /* @__PURE__ */ p(Jo, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setBold());
  }
}, yC = {
  titleKey: "italic",
  icon: /* @__PURE__ */ p(Zo, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setItalic());
  }
}, bC = {
  titleKey: "underline",
  icon: /* @__PURE__ */ p(Xo, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setUnderline());
  }
}, vC = {
  titleKey: "strikethrough",
  icon: /* @__PURE__ */ p(Ba, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setStrike());
  }
}, wC = {
  titleKey: "subscript",
  icon: /* @__PURE__ */ p(_a, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setSubscript());
  }
}, CC = {
  titleKey: "superscript",
  icon: /* @__PURE__ */ p(za, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setSuperscript());
  }
}, SC = {
  titleKey: "slashCommands.insertHorizontalLine",
  icon: /* @__PURE__ */ p(Va, {}),
  command: ({ editor: t, range: e }) => {
    Ae(t, e, (n) => n.setHorizontalRule());
  }
}, Nc = {
  titleKey: "slashCommands.insertImage",
  icon: /* @__PURE__ */ p(Zu, {}),
  command: ({ editor: t, range: e }) => Lc(kc, t, e)
}, xC = Yu(8).map((t) => ({
  titleKey: "slashCommands.insertTable",
  titleCountValue: t + 2,
  icon: /* @__PURE__ */ p(Na, {}),
  command: ({ editor: e, range: n }) => Ae(
    e,
    n,
    (r) => r.insertCustomTable({ rows: t + 2, cols: t + 2, withHeaderRow: !1 })
  )
})), TC = {
  titleKey: "slashCommands.insertYoutubeVideo",
  icon: /* @__PURE__ */ p(Xu, {}),
  command: ({ editor: t, range: e }) => Lc(Ac, t, e)
}, kC = {
  titleKey: "clearFormatting",
  icon: /* @__PURE__ */ p(Qo, {}),
  command: ({ editor: t, range: e }) => Ae(t, e, (n) => n.unsetAllMarks())
}, AC = [
  Ec,
  Oc,
  pC,
  mC,
  hC,
  $c,
  Rc,
  Ic,
  Mc,
  Pc,
  gC,
  yC,
  bC,
  vC,
  wC,
  CC,
  SC,
  Nc,
  ...xC,
  TC,
  kC
], EC = [
  Ec,
  Oc,
  $c,
  Rc,
  Ic,
  Mc,
  Pc,
  Nc
];
function Ae(t, e, n) {
  let r = t.chain().focus().deleteRange(e);
  r = n(r), r.run();
}
function Lc(t, e, n) {
  e.chain().focus().deleteRange(n).run(), window.dispatchEvent(t);
}
const OC = {
  items: ({ query: t }) => {
    if (t.length === 0)
      return EC;
    function e(r) {
      return r.toLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "");
    }
    const n = e(t.toLowerCase());
    return AC.sort((r, o) => {
      const i = e(Vt.t(r.titleKey)), s = e(Vt.t(o.titleKey)), a = i.startsWith(n), l = s.startsWith(n);
      return a != l ? a ? -1 : 1 : i.localeCompare(s);
    }).filter((r) => e(Vt.t(r.titleKey)).includes(n)).slice(0, 10);
  },
  render: () => {
    let t, e;
    return {
      onStart: (n) => {
        n.clientRect && (t = new mu(C1, {
          props: n,
          editor: n.editor
        }), e = ar(".rte-editor-root", {
          getReferenceClientRect: n.clientRect,
          content: t.element,
          showOnCreate: !0,
          interactive: !0,
          trigger: "manual",
          placement: "auto-end"
        }));
      },
      onUpdate(n) {
        t.updateProps(n);
      },
      onKeyDown(n) {
        var r;
        return n.event.key === "Escape" ? (e[0].hide(), !0) : (r = t.ref) == null ? void 0 : r.onKeyDown(n);
      },
      onExit() {
        var n;
        (n = e[0]) == null || n.destroy(), t == null || t.destroy();
      }
    };
  }
}, $C = $d.extend({
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      backgroundColor: {
        default: null,
        renderHTML: (e) => {
          if (!e.backgroundColor)
            return {};
          const n = e.backgroundColor, r = or(n, Wt());
          return {
            "data-background-color": n != "primary" ? n : void 0,
            style: r.length > 0 ? `background-color: ${r}` : void 0,
            class: n === "secondary" ? "rte-table-cell-secondary-fill" : void 0
          };
        },
        parseHTML: (e) => e.getAttribute("data-background-color")
      },
      color: {
        default: null,
        renderHTML: (e) => {
          if (!e.color)
            return {};
          const n = e.color, r = An(n, Wt()) ?? n;
          return {
            "data-color": n != "primary" ? n : void 0,
            style: r.length > 0 ? `color: ${r}` : void 0,
            class: n === "secondary" ? "rte-secondary-text" : void 0
          };
        },
        parseHTML: (e) => e.getAttribute("data-color")
      }
    };
  }
}), RC = Rd.extend({
  name: "customTable",
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      rowCount: {
        default: 0,
        parseHTML: (e) => e.getElementsByTagName("tr").length
      },
      colCount: {
        default: 0,
        parseHTML: (e) => {
          const n = Array.from(e.getElementsByTagName("tr"));
          return Gu(n.map((r) => r.cells.length));
        }
      }
    };
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  addCommands() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      insertCustomTable: (e) => ({ chain: n }) => n().insertTable(e).updateAttributes("customTable", {
        rowCount: e == null ? void 0 : e.rows,
        colCount: e == null ? void 0 : e.cols
      }).run(),
      insertRowAtEnd: () => ({ state: e, commands: n }) => {
        const r = Nn(e), o = r.table.attrs.rowCount, i = Id(e.tr, r, o);
        return n.updateAttributes("customTable", { rowCount: o + 1 }), i;
      },
      insertColumnAtEnd: () => ({ state: e, commands: n }) => {
        const r = Nn(e), o = r.table.attrs.colCount, i = Md(e.tr, r, o);
        return n.updateAttributes("customTable", { colCount: o + 1 }), i;
      },
      deleteRowAtEnd: () => ({ state: e, commands: n }) => {
        const r = Nn(e), o = r.table.attrs.rowCount;
        return Pd(e.tr, r, o - 1), n.updateAttributes("customTable", { rowCount: o - 1 }), e.tr;
      },
      deleteColumnAtEnd: () => ({ state: e, commands: n }) => {
        const r = Nn(e), o = r.table.attrs.colCount;
        return Nd(e.tr, r, o), n.updateAttributes("customTable", { colCount: o - 1 }), e.tr;
      }
    };
  },
  // This function is taken directly from
  // https://github.com/ueberdosis/tiptap/blob/31c3a9aad9eb37f445eadcd27135611291178ca6/packages/extension-table/src/table.ts#L229-L245,
  // except overridden to always include `columnResizing`, even if `editable` is
  // false. We update our RichTextContent styles so that the table resizing
  // controls are not visible when `editable` is false, and since the editor
  // itself has contenteditable=false, the table will remain read-only. By doing
  // this, we can ensure that column widths are preserved when editable is false
  // (otherwise any dragged column widths are ignored when editable is false, as
  // reported here https://github.com/ueberdosis/tiptap/issues/2041). Moreover,
  // we do not need any hacky workarounds to ensure that the necessary table
  // extensions are reset when the editable state changes (since the resizable
  // extension will be omitted if not initially editable, or wouldn't be removed
  // if initially not editable if we relied on it being removed, as reported
  // here https://github.com/ueberdosis/tiptap/issues/2301, which was not
  // resolved despite what the OP there later said).
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable ? [
        Ld({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      Dd({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  }
}), IC = Bd.extend({
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      backgroundColor: {
        default: null,
        renderHTML: (e) => {
          if (!e.backgroundColor)
            return {};
          const n = e.backgroundColor, r = or(n, Wt());
          return {
            "data-background-color": n != "primary" ? n : void 0,
            style: r.length > 0 ? `background-color: ${r}` : void 0,
            class: n === "secondary" ? "rte-table-cell-secondary-fill" : void 0
          };
        },
        parseHTML: (e) => e.getAttribute("data-background-color")
      },
      color: {
        default: null,
        renderHTML: (e) => {
          if (!e.color)
            return {};
          const n = e.color, r = An(n, Wt()) ?? n;
          return {
            "data-color": n != "primary" ? n : void 0,
            style: r.length > 0 ? `color: ${r}` : void 0,
            class: n === "secondary" ? "rte-secondary-text" : void 0
          };
        },
        parseHTML: (e) => e.getAttribute("data-color")
      }
    };
  }
});
function MC({
  placeholder: t,
  isReadOnly: e
}) {
  return [
    ju.configure({
      bulletList: {
        keepMarks: !0,
        keepAttributes: !1
      },
      codeBlock: !1,
      orderedList: {
        keepMarks: !0,
        keepAttributes: !1
      },
      heading: {
        levels: [1, 2, 3]
      }
    }),
    Au.extend({
      addNodeView() {
        return Sa(Fg);
      }
    }).configure({ lowlight: Hu(Uu) }),
    H0.configure({ types: [_i.name, om.name] }),
    U0,
    W0,
    Eu.configure({ className: "is-focused" }),
    q0,
    Dg,
    v1.configure({ inline: !0 }),
    K0,
    Y0.configure({
      openOnClick: !1,
      autolink: !0,
      defaultProtocol: "https"
    }),
    Mu,
    Pu.configure({
      placeholder: t,
      showOnlyCurrent: !1,
      showOnlyWhenEditable: !0
    }),
    w1.configure({ suggestion: OC }),
    Nu,
    Lu,
    Bu,
    Fu.configure({
      nested: !0
    }),
    _u.configure({
      types: ["heading", "paragraph"]
    }),
    _i,
    zu,
    Vu.configure({ nocookie: !0, width: 360, height: 270 }),
    RC.configure({
      resizable: !e,
      allowTableNodeSelection: !1
    }),
    $C,
    IC,
    Du
  ];
}
function te() {
  const { editor: t } = hu();
  if (t == null)
    throw new Error("Current editor must be defined");
  return t;
}
function sn(t, e) {
  let n = t.chain().focus();
  switch (e) {
    case "title":
      n = n.setHeading({ level: 1 });
      break;
    case "subtitle":
      n = n.setHeading({ level: 2 });
      break;
    case "heading":
      n = n.setHeading({ level: 3 });
      break;
    case "body":
    case "caption":
      n = n.setParagraph();
      break;
  }
  e === "caption" ? n = n.selectParentNode().setFontSize(0.8) : n = n.selectParentNode().unsetFontSize(), n.run();
}
function Dc(t) {
  return t.isActive("heading", { level: 1 }) ? "title" : t.isActive("heading", { level: 2 }) ? "subtitle" : t.isActive("heading", { level: 3 }) ? "heading" : t.isActive("paragraph") ? t.getAttributes("textStyle").fontSize == null ? "body" : "caption" : void 0;
}
function PC(t, e) {
  const n = Ea(
    (r, o) => {
      t != null && e === r && o(t);
    },
    [t, e]
  );
  Je(() => {
    window.richTextEditor = {
      addTableColumnLeft: (r) => n(r, (o) => o.chain().focus().addColumnBefore().run()),
      addTableColumnRight: (r) => n(r, (o) => o.chain().focus().addColumnAfter().run()),
      addTableRowAfter: (r) => n(r, (o) => o.chain().focus().addRowAfter().run()),
      addTableRowBefore: (r) => n(r, (o) => o.chain().focus().addRowBefore().run()),
      alignTextCenter: (r) => n(r, (o) => o.chain().focus().setTextAlign("center").run()),
      alignTextLeft: (r) => n(r, (o) => o.chain().focus().setTextAlign("left").run()),
      alignTextRight: (r) => n(r, (o) => o.chain().focus().setTextAlign("right").run()),
      clearFormatting: (r) => n(r, (o) => o.chain().focus().unsetAllMarks().run()),
      decreaseIndent: (r) => n(r, (o) => o.chain().focus().liftListItem("listItem").run()),
      deleteSelection: (r) => n(r, (o) => o.chain().focus().deleteSelection().run()),
      deleteTableColumn: (r) => n(r, (o) => o.chain().focus().deleteColumn().run()),
      deleteTableRow: (r) => n(r, (o) => o.chain().focus().deleteRow().run()),
      increaseIndent: (r) => n(r, (o) => o.chain().focus().sinkListItem("listItem").run()),
      insertHorizontalLine: (r) => n(r, (o) => o.chain().focus().setHorizontalRule().run()),
      insertImage: (r, o) => n(
        r,
        (i) => i.chain().focus().setImage({
          src: o.url,
          title: o.title
        }).run()
      ),
      insertTable: (r) => n(
        r,
        (o) => o.chain().focus().insertCustomTable({
          rows: 3,
          cols: 3,
          withHeaderRow: !1
        }).run()
      ),
      insertYoutubeVideo: (r, o) => n(r, (i) => i.chain().focus().setYoutubeVideo({ src: o }).run()),
      justifyText: (r) => n(r, (o) => o.chain().focus().setTextAlign("justify").run()),
      redo: (r) => n(r, (o) => o.commands.redo()),
      removeLink: (r) => n(r, (o) => o.chain().extendMarkRange("customLink").unsetLink().run()),
      setHighlightColor: (r, o) => n(r, (i) => {
        o != null ? i.chain().focus().toggleHighlight({ color: o }).run() : i.chain().focus().unsetHighlight().run();
      }),
      setLink: (r, o) => n(r, (i) => i.chain().focus().extendMarkRange("customLink").setLink({ href: o }).run()),
      setTableCellFillColor: (r, o) => n(
        r,
        (i) => i.chain().focus().setCellAttribute("backgroundColor", o ?? "primary").run()
      ),
      setTextColor: (r, o) => n(r, (i) => {
        const s = i.isActive("customTable"), a = i.isActive("customLink");
        s ? i.chain().focus().setCellAttribute("color", o).run() : a ? i.chain().focus().extendMarkRange("customLink").setLinkColor(o).run() : i.chain().focus().setColor(o).run();
      }),
      setTextContentKind: (r, o) => n(r, (i) => sn(i, o)),
      toggleBold: (r) => n(r, (o) => o.chain().focus().toggleBold().run()),
      toggleBulletList: (r) => n(r, (o) => o.chain().focus().toggleBulletList().run()),
      toggleCodeBlock: (r) => n(r, (o) => o.chain().focus().toggleCodeBlock().run()),
      toggleCodeFormat: (r) => n(r, (o) => o.chain().focus().toggleCode().run()),
      toggleItalic: (r) => n(r, (o) => o.chain().focus().toggleItalic().run()),
      toggleOrderedList: (r) => n(r, (o) => o.chain().focus().toggleOrderedList().run()),
      toggleBlockquote: (r) => n(r, (o) => o.chain().focus().toggleBlockquote().run()),
      toggleStrikethrough: (r) => n(r, (o) => o.chain().focus().toggleStrike().run()),
      toggleSubscript: (r) => n(r, (o) => o.chain().focus().toggleSubscript().run()),
      toggleSuperscript: (r) => n(r, (o) => o.chain().focus().toggleSuperscript().run()),
      toggleTaskList: (r) => n(r, (o) => o.chain().focus().toggleTaskList().run()),
      toggleUnderline: (r) => n(r, (o) => o.chain().focus().toggleUnderline().run()),
      undo: (r) => n(r, (o) => o.commands.undo())
    };
  }, [n, t]);
}
function NC() {
  const t = ut();
  Je(() => {
    const e = t.palette.mode === "light";
    document.documentElement.style.setProperty("--panel-box-shadow", e ? "rgba(149, 157, 165, 0.2) 0px 8px 24px" : "none");
  }, [t]);
}
class Fc {
  constructor(e, n) {
    Bi(this, "uppy");
    this._fileUrlBasename = n, this.uppy = new _d({
      restrictions: { allowedFileTypes: ["image/*", ".jpg", ".jpeg", ".png", ".gif"], maxNumberOfFiles: 1 }
    }).use(Ud, {
      waitForEncoding: !0,
      assemblyOptions: {
        params: {
          auth: { key: e },
          template_id: "415548b9818d4a2ea03d716c6bf9802f"
        }
      }
    }).use(Vd, {
      companionUrl: gr,
      companionAllowedHosts: fo,
      companionKeysParams: {
        key: e,
        credentialsName: "TodayGoogleDrive"
      }
    }).use(jd, {
      companionUrl: gr,
      companionAllowedHosts: fo,
      companionKeysParams: {
        key: e,
        credentialsName: "TodayOneDrive"
      }
    }).use(zd, {
      companionUrl: gr,
      companionAllowedHosts: fo,
      companionKeysParams: {
        key: e,
        credentialsName: "TodayDropBox"
      }
    }).use(qd).use(Hd).use(Wd, { companionUrl: gr });
  }
  convertAssemblyResultsToImages(e) {
    return (e.results[":original"] ?? []).map((r) => {
      let o = r.url;
      if (this._fileUrlBasename != null) {
        const i = new URL(o);
        o = `${this._fileUrlBasename}${i.pathname}`;
      }
      return {
        url: o,
        title: r.name
      };
    });
  }
  async uploadFile(e) {
    return this.uppy.addFile(e), this.uppy.upload(), new Promise((n, r) => {
      const o = () => {
        this.uppy.off("transloadit:complete", i), this.uppy.off("error", s), this.uppy.cancelAll();
      }, i = (a) => {
        o();
        const l = this.convertAssemblyResultsToImages(a).at(0);
        l != null ? n(l) : r(new Error("No image found in results"));
      };
      this.uppy.on("transloadit:complete", i);
      const s = (a) => {
        o(), r(a);
      };
      this.uppy.on("error", s);
    });
  }
}
const Bc = Ta(new Fc("", void 0)), _c = () => ka(Bc), Ht = () => /* @__PURE__ */ p(Et, { className: "rte-bubble-menu-divider", orientation: "vertical" }), LC = ({ info: t }) => /* @__PURE__ */ _(He, { p: "2px", pb: 0.5, gap: 0.5, direction: "row", alignItems: "baseline", children: [
  /* @__PURE__ */ p(it, { variant: "body2", children: t.name }),
  t.shortcutComponents != null && /* @__PURE__ */ _(Wn, { children: [
    /* @__PURE__ */ p(it, { variant: "body1", component: "span", children: "•" }),
    /* @__PURE__ */ p(He, { direction: "row", alignItems: "baseline", gap: "2px", children: Hl(t.shortcutComponents).map((e, n) => /* @__PURE__ */ p(it, { variant: "body2", fontWeight: 700, component: "span", children: jl(e) }, n)) })
  ] })
] });
function Te({ isActive: t = !1, tooltipInfo: e, className: n, ...r }) {
  return /* @__PURE__ */ p(iu, { title: e != null ? /* @__PURE__ */ p(LC, { info: e }) : "", placement: "top", children: /* @__PURE__ */ p("span", { children: /* @__PURE__ */ p(
    ma,
    {
      className: Ce(n, "rte-bubble-menu-control", t && "active"),
      color: t ? "inherit" : "default",
      centerRipple: !1,
      onMouseDown: (o) => o.preventDefault(),
      ...r
    }
  ) }) });
}
const DC = /(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/, FC = new RegExp(DC), BC = ({ onClose: t, initialValue: e, isOpen: n, anchorEl: r }) => {
  const o = te(), [i, s] = ke(e), [a, l] = ke(!1), { t: c } = ee();
  function u() {
    FC.test(i) ? i.trim().length > 0 ? o.chain().focus().extendMarkRange("customLink").setLink({ href: i }).run() : o.chain().extendMarkRange("customLink").unsetLink().run() : l(!0);
  }
  function f() {
    t(), o.chain().extendMarkRange("customLink").unsetLink().run();
  }
  return (
    // Setting zIndex to be in front of any content (ex: Bubble Menus)
    /* @__PURE__ */ p(
      xn,
      {
        open: n,
        anchorEl: r,
        className: "rte-bubble-menu",
        onClose: () => t(),
        slotProps: { paper: { className: "rte-shadowed-panel" } },
        disableAutoFocus: !0,
        disableRestoreFocus: !0,
        children: /* @__PURE__ */ p(
          "form",
          {
            onSubmit: (m) => {
              m.preventDefault(), u();
            },
            noValidate: !0,
            children: /* @__PURE__ */ _(He, { className: "rte-link-bubble-menu-content", direction: "row", alignItems: "center", children: [
              /* @__PURE__ */ p(
                su,
                {
                  autoFocus: !0,
                  value: i,
                  onChange: (m) => s(m.target.value),
                  placeholder: c("linkInputPlaceholder"),
                  type: "url",
                  error: a
                }
              ),
              o.isActive("customLink") && /* @__PURE__ */ _(Wn, { children: [
                /* @__PURE__ */ p(Ht, {}),
                /* @__PURE__ */ p(Te, { onClick: f, children: /* @__PURE__ */ p(ei, { fontSize: "small" }) })
              ] }),
              /* @__PURE__ */ p(Ht, {}),
              /* @__PURE__ */ p(Te, { type: "submit", children: /* @__PURE__ */ p(Qu, { fontSize: "small" }) })
            ] })
          }
        )
      }
    )
  );
}, zc = ({ sx: t, children: e, className: n }) => /* @__PURE__ */ p(
  er,
  {
    sx: t,
    className: Ce(n, "rte-bubble-menu", "rte-bubble-menu-content", "rte-shadowed-panel"),
    tabIndex: -1,
    children: /* @__PURE__ */ p(
      He,
      {
        direction: "row",
        alignItems: "center",
        className: "rte-bubble-menu-controls-stack",
        children: e,
        tabIndex: -1
      }
    )
  }
);
function _C(t) {
  const { editor: e, to: n, state: r, from: o } = t, { doc: i, selection: s } = r, { empty: a } = s, l = !i.textBetween(o, n).length && gu(r.selection);
  return !(a || l || !e.isEditable);
}
const zC = () => {
  const t = te();
  return /* @__PURE__ */ p(Te, { color: "error", onClick: () => t.chain().focus().deleteSelection().run(), children: /* @__PURE__ */ p(ei, {}) });
};
function VC({ sx: t, className: e }) {
  var l;
  const n = te(), [r, o] = ke(), { t: i } = ee();
  function s(c) {
    o(c.currentTarget);
  }
  function a() {
    o(void 0);
  }
  return /* @__PURE__ */ _(ve, { sx: t, className: e, children: [
    /* @__PURE__ */ p(Te, { isActive: n.isActive("customLink"), onClick: s, tooltipInfo: { name: i("Link") }, children: /* @__PURE__ */ p(ed, { className: "rte-bubble-menu-link-icon" }) }),
    r != null && /* @__PURE__ */ p(
      BC,
      {
        isOpen: !0,
        anchorEl: r,
        onClose: a,
        initialValue: ((l = n.getAttributes("customLink")) == null ? void 0 : l.href) ?? ""
      }
    )
  ] });
}
const jC = () => {
  const t = te(), { t: e } = ee();
  if (!t.isActive("customLink"))
    return null;
  const n = t.getAttributes("customLink");
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    /* @__PURE__ */ p(Te, { tooltipInfo: { name: e("openLink") }, component: "a", href: n.href, target: "_blank", children: /* @__PURE__ */ p(td, {}) })
  );
}, HC = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().addColumnBefore().run(),
      tooltipInfo: { name: e("insertColumnLeft") },
      children: /* @__PURE__ */ p(tC, {})
    }
  );
}, UC = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().addColumnAfter().run(),
      tooltipInfo: { name: e("insertColumnRight") },
      children: /* @__PURE__ */ p(nC, {})
    }
  );
}, WC = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().addRowAfter().run(),
      tooltipInfo: { name: e("insertRowBelow") },
      children: /* @__PURE__ */ p(rC, {})
    }
  );
}, qC = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().addRowBefore().run(),
      tooltipInfo: { name: e("insertRowAbove") },
      children: /* @__PURE__ */ p(oC, {})
    }
  );
};
function KC() {
  const t = te(), [e, n] = ke(void 0), { t: r } = ee();
  function o(l) {
    e != null ? i() : (l.stopPropagation(), n(l.currentTarget));
  }
  function i() {
    n(void 0);
  }
  function s(l) {
    t.chain().focus().setCellAttribute("backgroundColor", l).run(), i();
  }
  const a = t.getAttributes("tableCell").backgroundColor;
  return /* @__PURE__ */ _(ve, { children: [
    /* @__PURE__ */ p(
      Te,
      {
        onClick: (l) => o(l),
        tooltipInfo: { name: r("cellBackgroundColor") },
        isActive: a != null,
        children: /* @__PURE__ */ p(fC, {})
      }
    ),
    /* @__PURE__ */ p(
      xn,
      {
        open: e != null,
        anchorEl: e,
        className: "rte-bubble-menu",
        onClose: i,
        slotProps: { paper: { className: "rte-shadowed-panel" } },
        disableAutoFocus: !0,
        disableRestoreFocus: !0,
        children: /* @__PURE__ */ p(Vl, { onColorChange: s })
      }
    )
  ] });
}
const YC = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().deleteColumn().run(),
      tooltipInfo: { name: e("deleteColumn") },
      children: /* @__PURE__ */ p(iC, {})
    }
  );
}, GC = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(Te, { onClick: () => t.chain().focus().deleteRow().run(), tooltipInfo: { name: e("deleteRow") }, children: /* @__PURE__ */ p(sC, {}) });
};
function JC() {
  const t = te(), { t: e } = ee();
  return t.can().chain().focus().toggleBold().run() ? /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().toggleBold().run(),
      isActive: t.isActive("bold"),
      tooltipInfo: { name: e("bold"), shortcutComponents: ["meta", "b"] },
      children: /* @__PURE__ */ p(Jo, {})
    }
  ) : null;
}
function ZC() {
  const t = te(), { t: e } = ee();
  return t.can().chain().focus().toggleCode().run() ? /* @__PURE__ */ p(
    Te,
    {
      tooltipInfo: { name: e("code"), shortcutComponents: ["meta", "e"] },
      onClick: () => t.chain().focus().toggleCode().run(),
      isActive: t.isActive("code"),
      children: /* @__PURE__ */ p(Go, {})
    }
  ) : null;
}
function XC() {
  const t = te(), { t: e } = ee();
  return t.can().chain().focus().toggleItalic().run() ? /* @__PURE__ */ p(
    Te,
    {
      size: "small",
      onClick: () => t.chain().focus().toggleItalic().run(),
      isActive: t.isActive("italic"),
      tooltipInfo: { name: e("italic"), shortcutComponents: ["meta", "i"] },
      children: /* @__PURE__ */ p(Zo, {})
    }
  ) : null;
}
function Vc() {
  const t = te(), [e, n] = ke(void 0), { t: r } = ee();
  if (!t.can().chain().focus().unsetColor().run())
    return null;
  const o = t.isActive("customTable"), i = t.isActive("customLink"), s = (o ? t.getAttributes("tableCell").color : i ? t.getAttributes("customLink").color : t.getAttributes("textStyle").color) ?? "primary";
  function a(u) {
    u.stopPropagation(), n(u.currentTarget);
  }
  function l() {
    n(void 0);
  }
  function c(u) {
    o ? t.chain().focus().setCellAttribute("color", u).run() : i ? t.chain().focus().extendMarkRange("customLink").setLinkColor(u).run() : t.chain().focus().setColor(u).run(), l();
  }
  return /* @__PURE__ */ _(ve, { children: [
    /* @__PURE__ */ p(
      Te,
      {
        onClick: (u) => a(u),
        tooltipInfo: { name: r("textColor") },
        isActive: s != "primary",
        children: /* @__PURE__ */ p(nd, {})
      }
    ),
    /* @__PURE__ */ p(
      xn,
      {
        open: e != null,
        anchorEl: e,
        className: "rte-bubble-menu",
        onClose: l,
        slotProps: { paper: { className: "rte-shadowed-panel" } },
        disableAutoFocus: !0,
        disableRestoreFocus: !0,
        children: /* @__PURE__ */ p(xi, { value: s, onValueChanged: c, className: "rte-text-color-picker-popover" })
      }
    )
  ] });
}
function QC() {
  const t = te(), [e, n] = ke(void 0), { t: r } = ee();
  if (!t.can().chain().focus().toggleHighlight().run())
    return null;
  function o(l) {
    e != null ? i() : (l.stopPropagation(), n(l.currentTarget));
  }
  function i() {
    n(void 0);
  }
  function s(l) {
    l != null ? t.chain().focus().toggleHighlight({ color: l }).run() : t.chain().focus().unsetHighlight().run(), i();
  }
  const a = t.getAttributes("highlight").color;
  return /* @__PURE__ */ _(ve, { children: [
    /* @__PURE__ */ p(
      Te,
      {
        onClick: (l) => o(l),
        isActive: a != null,
        tooltipInfo: { name: r("highlight"), shortcutComponents: ["meta", "shift", "h"] },
        children: /* @__PURE__ */ p(dC, {})
      }
    ),
    /* @__PURE__ */ p(
      xn,
      {
        open: e != null,
        anchorEl: e,
        className: "rte-bubble-menu",
        onClose: i,
        slotProps: { paper: { className: "rte-shadowed-panel" } },
        disableAutoFocus: !0,
        disableRestoreFocus: !0,
        children: /* @__PURE__ */ p(Vl, { onColorChange: s })
      }
    )
  ] });
}
const eS = ({ sx: t, className: e }) => {
  const n = te(), [r, o] = ke(void 0), { t: i } = ee();
  if (!n.can().chain().focus().toggleBold().run())
    return null;
  function s(m) {
    o(m.currentTarget);
  }
  function a() {
    o(void 0);
  }
  function l() {
    n.chain().focus().toggleStrike().run(), a();
  }
  function c() {
    n.chain().focus().toggleSubscript().run(), a();
  }
  function u() {
    n.chain().focus().toggleSuperscript().run(), a();
  }
  function f() {
    n.chain().focus().unsetAllMarks().run(), a();
  }
  return /* @__PURE__ */ _(ve, { sx: t, className: e, children: [
    /* @__PURE__ */ p(Te, { onClick: s, tooltipInfo: { name: i("moreTextStyles") }, children: /* @__PURE__ */ p(Wr, {}) }),
    /* @__PURE__ */ _(
      au,
      {
        open: r != null,
        anchorEl: r,
        onClose: a,
        className: "rte-bubble-menu",
        slotProps: { paper: { className: "rte-shadowed-panel" } },
        disableAutoFocus: !0,
        disableRestoreFocus: !0,
        children: [
          /* @__PURE__ */ p(
            Ke,
            {
              onClick: l,
              titleKey: "strikethrough",
              icon: /* @__PURE__ */ p(Ba, {}),
              rounded: !1,
              shortcutComponents: ["meta", "shift", "s"]
            }
          ),
          /* @__PURE__ */ p(
            Ke,
            {
              onClick: c,
              icon: /* @__PURE__ */ p(_a, {}),
              titleKey: "subscript",
              rounded: !1,
              shortcutComponents: ["meta", ","]
            }
          ),
          /* @__PURE__ */ p(
            Ke,
            {
              onClick: u,
              icon: /* @__PURE__ */ p(za, {}),
              titleKey: "superscript",
              rounded: !1,
              shortcutComponents: ["meta", "."]
            }
          ),
          /* @__PURE__ */ p(
            Ke,
            {
              onClick: f,
              icon: /* @__PURE__ */ p(Qo, {}),
              titleKey: "clearFormatting",
              rounded: !1
            }
          )
        ]
      }
    )
  ] });
};
function tS() {
  const t = te(), { t: e } = ee();
  return t.can().chain().focus().toggleUnderline().run() ? /* @__PURE__ */ p(
    Te,
    {
      size: "small",
      onClick: () => t.chain().focus().toggleUnderline().run(),
      disabled: !t.can().chain().focus().toggleUnderline().run(),
      isActive: t.isActive("underline"),
      tooltipInfo: { name: e("underline"), shortcutComponents: ["meta", "u"] },
      children: /* @__PURE__ */ p(Xo, {})
    }
  ) : null;
}
const nS = () => {
  const t = te();
  return /* @__PURE__ */ p(
    xa,
    {
      editor: t,
      pluginKey: "regular-bubble-menu",
      shouldShow: ({ editor: e, ...n }) => ["customTable", "codeBlock", "horizontalRule"].some((o) => e.isActive(o)) ? !1 : _C({
        editor: e,
        ...n
      }),
      children: /* @__PURE__ */ _(zc, { children: [
        /* @__PURE__ */ p(jC, {}),
        /* @__PURE__ */ p(Ht, {}),
        /* @__PURE__ */ p(QC, {}),
        /* @__PURE__ */ p(Vc, {}),
        /* @__PURE__ */ p(JC, {}),
        /* @__PURE__ */ p(XC, {}),
        /* @__PURE__ */ p(tS, {}),
        /* @__PURE__ */ p(ZC, {}),
        /* @__PURE__ */ p(VC, {}),
        /* @__PURE__ */ p(eS, {}),
        /* @__PURE__ */ p(Ht, {}),
        /* @__PURE__ */ p(zC, {})
      ] })
    }
  );
}, rS = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(
    Te,
    {
      onClick: () => t.chain().focus().deleteTable().run(),
      tooltipInfo: { name: e("deleteTable") },
      children: /* @__PURE__ */ p(aC, {})
    }
  );
};
function oS() {
  const t = te(), e = () => {
    const r = n();
    if (r != null) {
      const a = t.view.nodeDOM(r.pos);
      if (a != null)
        return a.getBoundingClientRect();
    }
    const { ranges: o } = t.state.selection, i = Math.min(...o.map((a) => a.$from.pos)), s = Math.max(...o.map((a) => a.$to.pos));
    return yu(t.view, i, s);
  }, n = () => t.isActive("customTable") ? bu(
    t.state.selection.$anchor,
    (r) => r.type.name === "tableCell" || r.type.name === "tableHeader"
  ) : void 0;
  return /* @__PURE__ */ p(
    xa,
    {
      editor: t,
      pluginKey: "table-bubble-menu",
      tippyOptions: {
        getReferenceClientRect: e
      },
      shouldShow: ({ editor: r }) => {
        const o = r.view.hasFocus();
        return !(!r.isActive("customTable") || !o || !r.isEditable);
      },
      children: /* @__PURE__ */ _(zc, { children: [
        /* @__PURE__ */ p(HC, {}),
        /* @__PURE__ */ p(UC, {}),
        /* @__PURE__ */ p(YC, {}),
        /* @__PURE__ */ p(Ht, {}),
        /* @__PURE__ */ p(qC, {}),
        /* @__PURE__ */ p(WC, {}),
        /* @__PURE__ */ p(GC, {}),
        /* @__PURE__ */ p(Ht, {}),
        /* @__PURE__ */ p(KC, {}),
        /* @__PURE__ */ p(Vc, {}),
        /* @__PURE__ */ p(Ht, {}),
        /* @__PURE__ */ p(rS, {})
      ] })
    }
  );
}
const Di = {
  strings: {},
  pluralize(t) {
    return t === 1 ? 0 : 1;
  }
};
Di.strings = {
  addBulkFilesFailed: {
    0: "Failed to add %{smart_count} file due to an internal error",
    1: "Failed to add %{smart_count} files due to internal errors"
  },
  addedNumFiles: "Added %{numFiles} file(s)",
  addingMoreFiles: "Adding more files",
  additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled",
  addMore: "Add more",
  addMoreFiles: "Add more files",
  aggregateExceedsSize: "You selected %{size} of files, but maximum allowed size is %{sizeAllowed}",
  allFilesFromFolderNamed: "All files from folder %{name}",
  allowAccessDescription: "In order to take pictures or record video with your camera, please allow camera access for this site.",
  allowAccessTitle: "Please allow access to your camera",
  allowAudioAccessDescription: "In order to record audio, please allow microphone access for this site.",
  allowAudioAccessTitle: "Please allow access to your microphone",
  aspectRatioLandscape: "Crop landscape (16:9)",
  aspectRatioPortrait: "Crop portrait (9:16)",
  aspectRatioSquare: "Crop square",
  authAborted: "Authentication aborted",
  authenticate: "Connect",
  authenticateWith: "Connect to %{pluginName}",
  authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
  back: "Back",
  browse: "browse",
  browseFiles: "browse files",
  browseFolders: "browse folders",
  cancel: "Cancel",
  cancelUpload: "Cancel upload",
  chooseFiles: "Choose files",
  closeModal: "Close Modal",
  companionError: "Connection with Companion failed",
  companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
  complete: "Complete",
  compressedX: "Saved %{size} by compressing images",
  compressingImages: "Compressing images...",
  connectedToInternet: "Connected to the Internet",
  copyLink: "Copy link",
  copyLinkToClipboardFallback: "Copy the URL below",
  copyLinkToClipboardSuccess: "Link copied to clipboard.",
  creatingAssembly: "Preparing upload...",
  creatingAssemblyFailed: "Transloadit: Could not create Assembly",
  dashboardTitle: "Uppy Dashboard",
  dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
  dataUploadedOfTotal: "%{complete} of %{total}",
  dataUploadedOfUnknown: "%{complete} of unknown",
  discardRecordedFile: "Discard recorded file",
  done: "Done",
  dropHereOr: "Drop here or %{browse}",
  dropHint: "Drop your files here",
  dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
  dropPasteFiles: "Drop files here or %{browseFiles}",
  dropPasteFolders: "Drop files here or %{browseFolders}",
  dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
  dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
  dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
  editFile: "Edit file",
  editFileWithFilename: "Edit file %{file}",
  editImage: "Edit image",
  editing: "Editing %{file}",
  emptyFolderAdded: "No files were added from empty folder",
  encoding: "Encoding...",
  enterCorrectUrl: "Incorrect URL: Please make sure you are entering a direct link to a file",
  enterTextToSearch: "Enter text to search for images",
  enterUrlToImport: "Enter URL to import a file",
  error: "Error",
  exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
  failedToFetch: "Companion failed to fetch this URL, please make sure it’s correct",
  failedToUpload: "Failed to upload %{file}",
  filesUploadedOfTotal: {
    0: "%{complete} of %{smart_count} file uploaded",
    1: "%{complete} of %{smart_count} files uploaded"
  },
  filter: "Filter",
  finishEditingFile: "Finish editing file",
  flipHorizontal: "Flip horizontally",
  folderAdded: {
    0: "Added %{smart_count} file from %{folder}",
    1: "Added %{smart_count} files from %{folder}"
  },
  folderAlreadyAdded: 'The folder "%{folder}" was already added',
  generatingThumbnails: "Generating thumbnails...",
  import: "Import",
  importFiles: "Import files from:",
  importFrom: "Import from %{name}",
  inferiorSize: "This file is smaller than the allowed size of %{size}",
  loadedXFiles: "Loaded %{numFiles} files",
  loading: "Loading...",
  logIn: "Log in",
  logOut: "Log out",
  micDisabled: "Microphone access denied by user",
  missingRequiredMetaField: "Missing required meta fields",
  missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
  missingRequiredMetaFields: {
    0: "Missing required meta field: %{fields}.",
    1: "Missing required meta fields: %{fields}."
  },
  myDevice: "My Device",
  noAudioDescription: "In order to record audio, please connect a microphone or another audio input device",
  noAudioTitle: "Microphone Not Available",
  noCameraDescription: "In order to take pictures or record video, please connect a camera device",
  noCameraTitle: "Camera Not Available",
  noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
  noFilesFound: "You have no files or folders here",
  noInternetConnection: "No Internet connection",
  noMoreFilesAllowed: "Cannot add more files",
  noSearchResults: "Unfortunately, there are no results for this search",
  openFolderNamed: "Open folder %{name}",
  pause: "Pause",
  paused: "Paused",
  pauseUpload: "Pause upload",
  pickFiles: "Pick files",
  pickPhotos: "Pick photos",
  pleaseWait: "Please wait",
  pluginNameAudio: "Audio",
  pluginNameBox: "Box",
  pluginNameCamera: "Camera",
  pluginNameDropbox: "Dropbox",
  pluginNameFacebook: "Facebook",
  pluginNameGoogleDrive: "Google Drive",
  pluginNameGoogleDrivePicker: "Google Drive",
  pluginNameGooglePhotosPicker: "Google Photos",
  pluginNameInstagram: "Instagram",
  pluginNameOneDrive: "OneDrive",
  pluginNameScreenCapture: "Screencast",
  pluginNameUnsplash: "Unsplash",
  pluginNameUrl: "Link",
  pluginNameWebdav: "WebDAV",
  pluginNameZoom: "Zoom",
  pluginWebdavInputLabel: "WebDAV URL for a file (e.g. from ownCloud or Nextcloud)",
  poweredBy: "Powered by %{uppy}",
  processingXFiles: {
    0: "Processing %{smart_count} file",
    1: "Processing %{smart_count} files"
  },
  recording: "Recording",
  recordingLength: "Recording length %{recording_length}",
  recordingStoppedMaxSize: "Recording stopped because the file size is about to exceed the limit",
  recordVideoBtn: "Record Video",
  recoveredAllFiles: "We restored all files. You can now resume the upload.",
  recoveredXFiles: {
    0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
    1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
  },
  removeFile: "Remove file",
  reSelect: "Re-select",
  resetFilter: "Reset filter",
  resetSearch: "Reset search",
  resume: "Resume",
  resumeUpload: "Resume upload",
  retry: "Retry",
  retryUpload: "Retry upload",
  revert: "Reset",
  rotate: "Rotate 90°",
  save: "Save",
  saveChanges: "Save changes",
  search: "Search",
  searchImages: "Search for images",
  selectX: {
    0: "Select %{smart_count}",
    1: "Select %{smart_count}"
  },
  sessionRestored: "Session restored",
  showErrorDetails: "Show error details",
  signInWithGoogle: "Sign in with Google",
  smile: "Smile!",
  startAudioRecording: "Begin audio recording",
  startCapturing: "Begin screen capturing",
  startRecording: "Begin video recording",
  stopAudioRecording: "Stop audio recording",
  stopCapturing: "Stop screen capturing",
  stopRecording: "Stop video recording",
  streamActive: "Stream active",
  streamPassive: "Stream passive",
  submitRecordedFile: "Submit recorded file",
  takePicture: "Take a picture",
  takePictureBtn: "Take Picture",
  unnamed: "Unnamed",
  upload: "Upload",
  uploadComplete: "Upload complete",
  uploadFailed: "Upload failed",
  uploading: "Uploading",
  uploadingXFiles: {
    0: "Uploading %{smart_count} file",
    1: "Uploading %{smart_count} files"
  },
  uploadPaused: "Upload paused",
  uploadStalled: "Upload has not made any progress for %{seconds} seconds. You may want to retry it.",
  uploadXFiles: {
    0: "Upload %{smart_count} file",
    1: "Upload %{smart_count} files"
  },
  uploadXNewFiles: {
    0: "Upload +%{smart_count} file",
    1: "Upload +%{smart_count} files"
  },
  xFilesSelected: {
    0: "%{smart_count} file selected",
    1: "%{smart_count} files selected"
  },
  xMoreFilesAdded: {
    0: "%{smart_count} more file added",
    1: "%{smart_count} more files added"
  },
  xTimeLeft: "%{time} left",
  youCanOnlyUploadFileTypes: "You can only upload: %{types}",
  youCanOnlyUploadX: {
    0: "You can only upload %{smart_count} file",
    1: "You can only upload %{smart_count} files"
  },
  youHaveToAtLeastSelectX: {
    0: "You have to select at least %{smart_count} file",
    1: "You have to select at least %{smart_count} files"
  },
  zoomIn: "Zoom in",
  zoomOut: "Zoom out"
};
typeof Uppy < "u" && (globalThis.Uppy.locales.en_US = Di);
const jc = {
  strings: {},
  pluralize(t) {
    return t <= 1 ? 0 : 1;
  }
};
jc.strings = {
  addBulkFilesFailed: {
    0: "L’ajout de %{smart_count} fichier a échoué en raison d’une erreur interne",
    1: "L’ajout de %{smart_count} fichiers a échoué en raison d’erreurs internes"
  },
  addedNumFiles: "%{numFiles} fichier(s) ajouté(s)",
  addingMoreFiles: "Ajout de fichiers",
  additionalRestrictionsFailed: "%{count} restrictions supplémentaires n’ont pas été respectées",
  addMore: "Ajouter d’autres",
  addMoreFiles: "Ajouter d’autres fichiers",
  aggregateExceedsSize: "Vous avez sélectionné %{size} de fichiers, mais la taille maximale autorisée est %{sizeAllowed}",
  allFilesFromFolderNamed: "Tous les fichiers du dossier %{name}",
  allowAccessDescription: "Pour prendre des photos ou enregistrer une vidéo, veuillez autoriser l’accès à votre caméra pour ce site.",
  allowAccessTitle: "Veuillez autoriser l’accès à votre caméra",
  allowAudioAccessDescription: "Pour enregistrer de l’audio, veuillez autoriser l’accès au microphone pour ce site.",
  allowAudioAccessTitle: "Veuillez autoriser l’accès au microphone",
  aspectRatioLandscape: "Recadrer en paysage (16:9)",
  aspectRatioPortrait: "Recadrer en portrait (9:16)",
  aspectRatioSquare: "Recadrer pour obtenir une photo carrée",
  authAborted: "Authentification interrompue",
  authenticateWith: "Se connecter à %{pluginName}",
  authenticateWithTitle: "Veuillez vous authentifier avec %{pluginName} pour sélectionner les fichiers",
  back: "Retour",
  browse: "naviguer",
  browseFiles: "naviguer dans les fichiers",
  browseFolders: "naviguer dans les dossiers",
  cancel: "Annuler",
  cancelUpload: "Annuler le téléversement",
  chooseFiles: "Choisir des fichiers",
  closeModal: "Fermer la fenêtre",
  companionError: "Connexion à Companion a échoué",
  companionUnauthorizeHint: "Pour vous déconnecter de votre compte %{provider}, veuillez aller à %{url}",
  complete: "Terminé",
  compressedX: "%{size} économisé(s) par la compression",
  compressingImages: "Compression des images…",
  connectedToInternet: "Connecté à Internet",
  copyLink: "Copier le lien",
  copyLinkToClipboardFallback: "Copier le lien ci-dessous",
  copyLinkToClipboardSuccess: "Lien copié",
  creatingAssembly: "Préparation du téléversement…",
  creatingAssemblyFailed: "Transloadit: Impossible de créer Assembly",
  dashboardTitle: "Téléverseur de fichiers",
  dashboardWindowTitle: "Fenêtre de téléversement de fichiers (Appuyez sur Échap pour fermer)",
  dataUploadedOfTotal: "%{complete} sur %{total}",
  discardRecordedFile: "Supprimer le fichier enregistré",
  done: "Terminé",
  dropHereOr: "Déposer les fichiers ici ou %{browse}",
  dropHint: "Déposez vos fichiers ici",
  dropPasteBoth: "Déposer les fichiers ici, coller ou %{browse}",
  dropPasteFiles: "Déposer les fichiers ici, coller ou %{browse}",
  dropPasteFolders: "Déposer les fichiers ici, coller ou %{browse}",
  dropPasteImportBoth: "Déposer les fichiers ici, coller, %{browse} ou importer de",
  dropPasteImportFiles: "Déposer les fichiers ici, coller, %{browse} ou importer de",
  dropPasteImportFolders: "Déposer les fichiers ici, coller, %{browse} ou importer de",
  editFile: "Modifier le fichier",
  editImage: "Modifier l’image",
  editFileWithFilename: "Modifier le fichier %{file}",
  editing: "Modification en cours de %{file}",
  emptyFolderAdded: "Aucun fichier n’a été ajouté depuis un dossier vide",
  encoding: "Traitement…",
  enterCorrectUrl: "Lien incorrect: Assurez-vous que vous entrez un lien direct vers le fichier",
  enterTextToSearch: "Entrez un texte pour rechercher des images",
  enterUrlToImport: "Entrez le lien pour importer un fichier",
  error: "Erreur",
  exceedsSize: "Le fichier %{file} dépasse la taille maximale autorisée de %{size}",
  failedToFetch: "Companion a échoué à récupérer ce lien, assurez-vous qu’il est correct",
  failedToUpload: "Le téléversement de %{file} a échoué",
  fileSource: "Fichier source: %{name}",
  filesUploadedOfTotal: {
    0: "%{complete} sur %{smart_count} fichier téléversé",
    1: "%{complete} sur %{smart_count} fichiers téléversés"
  },
  filter: "Filtrer",
  finishEditingFile: "Terminer l’édition du fichier",
  flipHorizontal: "Retourner horizontalement",
  folderAdded: {
    0: "%{smart_count} fichier ajouté de %{folder}",
    1: "%{smart_count} fichiers ajoutés de %{folder}"
  },
  folderAlreadyAdded: 'Le dossier "%{folder}" a déjà été ajouté',
  generatingThumbnails: "Génération des vignettes…",
  import: "Importer",
  importFiles: "Importer des fichiers depuis :",
  importFrom: "Importer de %{name}",
  inferiorSize: "Ce fichier est plus petit que la taille autorisée de %{size}",
  loadedXFiles: "Chargé %{numFiles} fichiers",
  loading: "Chargement…",
  logOut: "Déconnexion",
  micDisabled: "Accès au micro refusé par l’utilisateur",
  missingRequiredMetaField: "Champ méta requis manquant",
  missingRequiredMetaFieldOnFile: "Champs méta requis manquants dans %{fileName}",
  missingRequiredMetaFields: {
    0: "Champ méta requis manquant : %{fields}.",
    1: "Champs méta requis manquants : %{fields}."
  },
  myDevice: "Mon Appareil",
  noAudioDescription: "Pour enregistrer de l’audio, veuillez connecter un microphone ou un autre appareil d’entrée audio",
  noAudioTitle: "Microphone non disponible",
  noCameraDescription: "Pour prendre des photos ou enregistrer une vidéo, veuillez connecter une caméra",
  noDuplicates: 'Impossible d’ajouter le fichier "%{fileName}", il existe déjà',
  noFilesFound: "Vous n’avez aucun fichier ou dossier ici",
  noInternetConnection: "Pas de connexion à Internet",
  noMoreFilesAllowed: "Impossible d’ajouter de nouveaux fichiers: en cours de chargement ",
  noSearchResults: "Malheureusement, il n’y a aucun résultat pour cette recherche",
  openFolderNamed: "Ouvrir %{name}",
  pause: "Pause",
  pauseUpload: "Mettre en pause le téléversement",
  paused: "En pause",
  poweredBy: "Propulsé par %{uppy}",
  processingXFiles: {
    0: "Traitement de %{smart_count} fichier",
    1: "Traitement de %{smart_count} fichiers"
  },
  recording: "Enregistrement",
  recordingLength: "Durée d’enregistrement %{recording_length}",
  recordingStoppedMaxSize: "L’enregistrement s’est arrété car la taille du fichier dépasse la limite",
  recordVideoBtn: "Enregistrer une vidéo",
  recoveredAllFiles: "Nous avons restauré tous les fichiers. Vous pouvez maintenant reprendre le téléversement.",
  recoveredXFiles: {
    0: "Nous n’avons pas pu récupérer entièrement 1 fichier. Veuillez le resélectionner et reprendre le téléversement.",
    1: "Nous n’avons pas pu récupérer entièrement %{smart_count} fichiers. Veuillez les resélectionner et reprendre le téléversement."
  },
  removeFile: "Effacer le fichier %{file}",
  resetFilter: "Réinitialiser filtre",
  resume: "Reprendre",
  resumeUpload: "Reprendre le téléversement",
  retry: "Réessayer",
  retryUpload: "Réessayer le téléversement",
  reSelect: "Resélectionner",
  save: "Sauvegarder",
  saveChanges: "Sauvegarder les modifications",
  selectFileNamed: "Sélectionner le fichier %{name}",
  selectX: {
    0: "Sélectionner %{smart_count}",
    1: "Sélectionner %{smart_count}"
  },
  sessionRestored: "Session restaurée",
  signInWithGoogle: "Se connecter avec Google",
  smile: "Souriez !",
  startRecording: "Commencer l’enregistrement vidéo",
  stopRecording: "Arrêter l’enregistrement vidéo",
  streamActive: "Stream actif",
  streamPassive: "Stream passif",
  submitRecordedFile: "Envoyer la vidéo enregistrée",
  takePicture: "Prendre une photo",
  takePictureBtn: "Prendre une photo",
  timedOut: "Téléversement bloqué durant %{seconds} secondes, annulation.",
  unselectFileNamed: "Désélectionner le fichier %{name}",
  upload: "Téléverser",
  uploadComplete: "Téléversement terminé",
  uploadFailed: "Le téléversement a échoué",
  uploadPaused: "Téléversement mis en pause",
  uploadStalled: "Téléversement bloqué depuis %{seconds} secondes. Il est peut-être nécessaire de recommencer l’opération.",
  uploadXFiles: {
    0: "Téléverser %{smart_count} fichier",
    1: "Téléverser %{smart_count} fichiers"
  },
  uploadXNewFiles: {
    0: "Téléverser +%{smart_count} fichier",
    1: "Téléverser +%{smart_count} fichiers"
  },
  uploading: "Téléversement en cours",
  uploadingXFiles: {
    0: "Téléversement de %{smart_count} fichier",
    1: "Téléversement de %{smart_count} fichiers"
  },
  xFilesSelected: {
    0: "%{smart_count} fichier sélectionné",
    1: "%{smart_count} fichiers sélectionnés"
  },
  xMoreFilesAdded: {
    0: "%{smart_count} autre fichier ajouté",
    1: "%{smart_count} autres fichiers ajoutés"
  },
  xTimeLeft: "%{time} restantes",
  youCanOnlyUploadFileTypes: "Vous pouvez seulement téléverser: %{types}",
  youCanOnlyUploadX: {
    0: "Vous pouvez seulement téléverser %{smart_count} fichier",
    1: "Vous pouvez seulement téléverser %{smart_count} fichiers"
  },
  youHaveToAtLeastSelectX: {
    0: "Vous devez sélectionner au moins %{smart_count} fichier",
    1: "Vous devez sélectionner au moins %{smart_count} fichiers"
  }
};
const iS = ({ open: t, onClose: e }) => {
  const [n, r] = ke(!1), o = ut(), i = _c(), { uppy: s } = i, { t: a, i18n: l } = ee();
  return Je(() => {
    const c = () => r(!0);
    s.on("upload", c);
    const u = (m) => {
      const g = i.convertAssemblyResultsToImages(m).at(0);
      e(g), r(!1);
    };
    s.on("transloadit:complete", u);
    const f = () => {
      r(!1);
    };
    return s.on("error", f), () => {
      s.off("upload", c), s.off("transloadit:complete", u), s.off("error", f), s.cancelAll();
    };
  }, [s]), Je(() => {
    s.setOptions({ locale: l.language === "fr" ? jc : Di });
  }, [s, l.language]), /* @__PURE__ */ _(ha, { open: t, onClose: () => e(void 0), maxWidth: "sm", fullWidth: !0, className: "rte-dialog", children: [
    /* @__PURE__ */ p(ga, { className: "rte-dialog-title", children: a("insertImageDialogTitle") }),
    /* @__PURE__ */ p(Et, {}),
    /* @__PURE__ */ p(ya, { children: /* @__PURE__ */ p(
      Yd,
      {
        uppy: s,
        theme: o.palette.mode,
        style: { borderRadius: o.shape.borderRadius, borderColor: "none" },
        hideCancelButton: !1
      }
    ) }),
    /* @__PURE__ */ p(ba, { className: "rte-dialog-actions-container", children: /* @__PURE__ */ p(
      St,
      {
        className: "rte-dialog-action",
        color: "error",
        disabled: n,
        onClick: () => e(void 0),
        startIcon: /* @__PURE__ */ p(rd, {}),
        children: a("cancel")
      }
    ) })
  ] });
}, sS = ({ isOpen: t, onClose: e }) => {
  const [n, r] = ke(""), [o, i] = ke(!1), { t: s } = ee();
  function a() {
    if (n.length === 0) {
      e("");
      return;
    }
    let l = n;
    n.startsWith("https://") || (l = "https://" + n), e(l);
  }
  return (
    // Setting zIndex to be in front of any content (ex: Bubble Menus)
    /* @__PURE__ */ p(ha, { open: t, className: "rte-dialog", maxWidth: "xs", fullWidth: !0, onClose: () => e(""), children: /* @__PURE__ */ _(
      "form",
      {
        onSubmit: (l) => {
          l.preventDefault(), a();
        },
        children: [
          /* @__PURE__ */ p(ga, { className: "rte-dialog-title", children: s("insertYoutubeVideoDialogTitle") }),
          /* @__PURE__ */ p(Et, {}),
          /* @__PURE__ */ p(ya, { children: /* @__PURE__ */ p(lu, { children: /* @__PURE__ */ p(
            cu,
            {
              label: s("urlInputLabel"),
              fullWidth: !0,
              value: n,
              error: o,
              onChange: (l) => {
                r(l.target.value), i(!1);
              }
            }
          ) }) }),
          /* @__PURE__ */ _(ba, { className: "rte-dialog-actions-container", children: [
            /* @__PURE__ */ p(St, { className: "rte-dialog-action", onClick: () => e(""), variant: "contained-grey", children: s("cancel") }),
            /* @__PURE__ */ p(St, { type: "submit", className: "rte-dialog-action", variant: "contained", children: s("insertYoutubeVideoDialogSubmit") })
          ] })
        ]
      }
    ) })
  );
}, aS = ({ customEventHandler: t }) => {
  const e = te(), [n, r] = ke(!1), [o, i] = ke(!1);
  function s() {
    (t == null ? void 0 : t.image) != null ? t.image() : r(!0);
  }
  function a(u) {
    r(!1), u != null && e.chain().focus().setImage({ src: u.url, title: u.title }).run();
  }
  function l() {
    (t == null ? void 0 : t.youtubeVideo) != null ? t.youtubeVideo() : i(!0);
  }
  function c(u) {
    i(!1), u.length > 0 && e.chain().focus().setYoutubeVideo({ src: u }).run();
  }
  return Je(() => (window.addEventListener(qo, s), window.addEventListener(Ko, l), () => {
    window.removeEventListener(qo, s), window.removeEventListener(Ko, l);
  }), []), /* @__PURE__ */ _("div", { children: [
    n && /* @__PURE__ */ p(iS, { open: !0, onClose: a }),
    o && /* @__PURE__ */ p(sS, { isOpen: !0, onClose: c })
  ] });
}, lS = () => {
  const t = te(), e = _c();
  return Je(() => {
    t.setOptions({
      ...t.options,
      editorProps: {
        handleDrop: (n, r, o, i) => {
          if (!i && r.dataTransfer && r.dataTransfer.files.length > 0) {
            const s = r.dataTransfer.files[0];
            return aa(s, n, e);
          }
          return !1;
        },
        handlePaste: (n, r) => {
          var a;
          r.preventDefault(), r.stopPropagation();
          const i = Array.from(((a = r.clipboardData) == null ? void 0 : a.items) ?? []).at(0), s = i == null ? void 0 : i.getAsFile();
          return i == null ? !1 : aa(s, n, e);
        }
      }
    });
  }, [t, e]), null;
};
function aa(t, e, n) {
  return t == null || !t.type.includes("image") ? !1 : ((async () => {
    const { schema: r } = e.state, o = {}, i = e.state.tr;
    i.selection.empty || i.deleteSelection(), i.setMeta(zn, { add: { id: o, pos: i.selection.from } }), e.dispatch(i);
    try {
      const { url: s, title: a } = await n.uploadFile({ name: t.name, type: t.type, data: t }), l = Lg(e.state, o);
      if (l == null || r.nodes.image == null) return;
      e.dispatch(
        e.state.tr.replaceWith(l, l, r.nodes.image.create({ src: s, title: a })).setMeta(zn, { remove: { id: o } })
      );
    } catch (s) {
      console.error(s), e.dispatch(i.setMeta(zn, { remove: { id: o } }));
    }
  })(), !0);
}
function la(t) {
  var s;
  const e = t.isActive("customTable"), n = t.isActive("customLink"), r = (e ? t.getAttributes("tableCell").color : n ? t.getAttributes("customLink").color : t.getAttributes("textStyle").color) ?? "primary";
  let o;
  return ["codeBlock", "horizontalRule"].some((a) => t.isActive(a)) ? o = "other" : e ? o = "table" : o = "text", {
    blockquote: {
      isActive: t.isActive("blockquote"),
      isEnabled: t.can().chain().focus().toggleBlockquote().run()
    },
    bold: { isActive: t.isActive("bold"), isEnabled: t.can().chain().focus().toggleBold().run() },
    code: { isActive: t.isActive("code"), isEnabled: t.can().chain().focus().toggleCode().run() },
    codeBlock: {
      isActive: t.isActive("codeBlock"),
      isEnabled: t.can().chain().focus().toggleCodeBlock().run()
    },
    decreaseIndent: {
      isActive: !1,
      isEnabled: t.can().chain().focus().liftListItem("listItem").run()
    },
    deleteTableColumn: { isActive: !1, isEnabled: e && t.getAttributes("customTable").colCount > 1 },
    deleteTableRow: { isActive: !1, isEnabled: e && t.getAttributes("customTable").rowCount > 1 },
    highlightColor: t.getAttributes("highlight").color,
    increaseIndent: {
      isActive: !1,
      isEnabled: t.can().chain().focus().sinkListItem("listItem").run()
    },
    isList: t.isActive("listItem"),
    italic: { isActive: t.isActive("italic"), isEnabled: t.can().chain().focus().toggleItalic().run() },
    kind: o,
    link: (s = t.getAttributes("customLink")) == null ? void 0 : s.href,
    redo: { isActive: !1, isEnabled: t.can().chain().focus().redo().run() },
    strikethrough: {
      isActive: t.isActive("strikethrough"),
      isEnabled: t.can().chain().focus().toggleStrike().run()
    },
    subscript: {
      isActive: t.isActive("subscript"),
      isEnabled: t.can().chain().focus().toggleSubscript().run()
    },
    superscript: {
      isActive: t.isActive("superscript"),
      isEnabled: t.can().chain().focus().toggleSuperscript().run()
    },
    tableCellFillColor: t.getAttributes("tableCell").backgroundColor,
    textColor: r,
    textContentKind: Dc(t),
    underline: {
      isActive: t.isActive("underline"),
      isEnabled: t.can().chain().focus().toggleUnderline().run()
    },
    undo: { isActive: !1, isEnabled: t.can().chain().focus().undo().run() }
  };
}
const ao = ({ sx: t, className: e, title: n, children: r, isFloating: o }) => /* @__PURE__ */ _(
  er,
  {
    sx: {
      backgroundColor: o ? void 0 : "transparent",
      backgroundImage: o ? void 0 : "none",
      ...t
    },
    elevation: o ? 4 : 0,
    className: Ce(e, "rte-sidebar-tab-panel", o && "rte-shadowed-panel"),
    children: [
      /* @__PURE__ */ p(it, { className: "rte-sidebar-tab-panel-title", variant: "subtitle2", children: n }),
      /* @__PURE__ */ p(He, { className: "rte-sidebar-tab-panel-content", spacing: 2, children: r })
    ]
  }
), Ge = ({
  sx: t,
  children: e,
  title: n = "",
  className: r,
  disablePadding: o = !1,
  showEmptyTitle: i = !1
}) => /* @__PURE__ */ _(He, { sx: { px: o ? void 0 : 1.5, ...t }, className: r, spacing: 1, children: [
  (n.length > 0 || i) && /* @__PURE__ */ p(it, { variant: "caption", fontWeight: "500", color: "textSecondary", children: n }),
  /* @__PURE__ */ p(ve, { children: e })
] }), Hc = ({ sx: t, className: e, isFloating: n }) => {
  const r = te(), { t: o } = ee();
  function i() {
    r.chain().focus().deleteSelection().run();
  }
  return /* @__PURE__ */ _(ao, { sx: t, className: e, title: o("actionsPanelTitle"), isFloating: n, children: [
    /* @__PURE__ */ _(Ge, { children: [
      /* @__PURE__ */ p(
        Ke,
        {
          onClick: () => r.commands.undo(),
          titleKey: "undo",
          icon: /* @__PURE__ */ p(od, {}),
          shortcutComponents: ["meta", "z"]
        }
      ),
      /* @__PURE__ */ p(
        Ke,
        {
          onClick: () => r.commands.redo(),
          titleKey: "redo",
          icon: /* @__PURE__ */ p(id, {}),
          shortcutComponents: ["meta", "shift", "z"]
        }
      ),
      /* @__PURE__ */ p(
        Ke,
        {
          onClick: () => r.chain().selectParentNode().unsetAllMarks().run(),
          titleKey: "clearFormatting",
          icon: /* @__PURE__ */ p(Qo, {})
        }
      )
    ] }),
    /* @__PURE__ */ p(Et, {}),
    /* @__PURE__ */ p(Ge, { children: /* @__PURE__ */ p(Ke, { onClick: () => i(), titleKey: "deleteSelection", icon: /* @__PURE__ */ p(ei, {}), isDestructive: !0 }) })
  ] });
}, ca = ({ sx: t, className: e, isSelected: n, icon: r, onClick: o }) => /* @__PURE__ */ p(
  ma,
  {
    sx: t,
    className: Ce(e, n && "selected"),
    color: n ? "primary" : "default",
    centerRipple: !1,
    onClick: o,
    children: r
  }
), Uc = ({ sx: t, className: e, isFloating: n }) => {
  const r = te(), { t: o } = ee();
  function i() {
    r.chain().focus().setHorizontalRule().run();
  }
  function s() {
    window.dispatchEvent(kc);
  }
  function a() {
    r.chain().focus().insertCustomTable({ rows: 3, cols: 3, withHeaderRow: !1 }).run();
  }
  function l() {
    window.dispatchEvent(Ac);
  }
  return /* @__PURE__ */ _(ao, { sx: t, className: e, title: o("insert"), isFloating: n, children: [
    /* @__PURE__ */ _(Ge, { children: [
      /* @__PURE__ */ p(Ke, { onClick: s, titleKey: "image", icon: /* @__PURE__ */ p(sd, {}) }),
      /* @__PURE__ */ p(Ke, { onClick: a, titleKey: "table", icon: /* @__PURE__ */ p(Na, {}) }),
      /* @__PURE__ */ p(Ke, { onClick: l, titleKey: "youtube", icon: /* @__PURE__ */ p(ad, {}) })
    ] }),
    /* @__PURE__ */ p(Et, {}),
    /* @__PURE__ */ p(Ge, { children: /* @__PURE__ */ p(Ke, { onClick: i, titleKey: "horizontalLine", icon: /* @__PURE__ */ p(Va, {}) }) })
  ] });
}, Wc = ["insert", "text-style", "commands"];
function qc(t) {
  switch (t) {
    case "insert":
      return /* @__PURE__ */ p(ja, {});
    case "text-style":
      return /* @__PURE__ */ p(Wr, { fontSize: "small" });
    case "commands":
      return /* @__PURE__ */ p(ld, { fontSize: "small" });
  }
}
const Or = (t) => /* @__PURE__ */ p(va, { variant: "outlined", fullWidth: !0, ...t }), De = ({ sx: t, activeKey: e, icon: n, action: r, className: o }) => {
  const i = te(), s = mn(() => {
    let l = i.can().chain().focus();
    return l = r(l), !l.run();
  }, [i, r]);
  function a() {
    let l = i.chain().focus();
    l = r(l), l.run();
  }
  return /* @__PURE__ */ p(
    St,
    {
      sx: t,
      className: Ce(
        o,
        "rte-sidebar-grouped-button",
        e != null && i.isActive(e) && "is-active"
      ),
      disabled: s,
      onClick: a,
      children: n
    }
  );
}, Lt = ({
  sx: t,
  className: e,
  isActive: n = !1,
  titleKey: r,
  onClick: o,
  icon: i,
  disabled: s
}) => {
  const { t: a } = ee();
  return /* @__PURE__ */ p(
    St,
    {
      className: Ce(e, n && "is-active"),
      fullWidth: !0,
      variant: "contained-grey",
      sx: t,
      onClick: () => o(),
      startIcon: i,
      disabled: s,
      children: a(r)
    }
  );
}, Kc = ({
  sx: t,
  showTitle: e,
  className: n,
  showIndentationOptions: r = !0
}) => /* @__PURE__ */ p(Ge, { sx: t, className: n, title: e ? "Text style" : void 0, showEmptyTitle: !0, children: /* @__PURE__ */ _(me, { container: !0, spacing: 1, children: [
  /* @__PURE__ */ p(me, { size: { xs: 12 }, children: /* @__PURE__ */ _(Or, { children: [
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(Jo, {}),
        activeKey: "bold",
        action: (o) => o.toggleBold()
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(Zo, {}),
        activeKey: "italic",
        action: (o) => o.toggleItalic()
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(Xo, {}),
        activeKey: "underline",
        action: (o) => o.toggleUnderline()
      }
    ),
    /* @__PURE__ */ p(De, { icon: /* @__PURE__ */ p(Go, {}), activeKey: "code", action: (o) => o.toggleCode() })
  ] }) }),
  /* @__PURE__ */ p(me, { size: { xs: 12 }, children: /* @__PURE__ */ _(Or, { children: [
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(Fa, {}),
        activeKey: "taskList",
        action: (o) => o.toggleTaskList()
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(La, {}),
        activeKey: "bulletList",
        action: (o) => o.toggleBulletList()
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(Da, {}),
        activeKey: "orderedList",
        action: (o) => o.toggleOrderedList()
      }
    )
  ] }) }),
  r && /* @__PURE__ */ p(me, { size: { xs: 4 }, children: /* @__PURE__ */ _(Or, { children: [
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(cd, {}),
        action: (o) => o.liftListItem("listItem")
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(ud, {}),
        action: (o) => o.sinkListItem("listItem")
      }
    )
  ] }) }),
  /* @__PURE__ */ p(me, { size: { xs: r ? 8 : 12 }, children: /* @__PURE__ */ _(Or, { children: [
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(dd, {}),
        activeKey: { textAlign: "left" },
        action: (o) => o.setTextAlign("left")
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(fd, {}),
        activeKey: { textAlign: "center" },
        action: (o) => o.setTextAlign("center")
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(pd, {}),
        activeKey: { textAlign: "right" },
        action: (o) => o.setTextAlign("right")
      }
    ),
    /* @__PURE__ */ p(
      De,
      {
        icon: /* @__PURE__ */ p(md, {}),
        activeKey: { textAlign: "justify" },
        action: (o) => o.setTextAlign("justify")
      }
    )
  ] }) })
] }) }), cS = ({ sx: t, className: e }) => {
  const n = te(), [r, o] = ke(), i = ut(), { t: s } = ee(), a = n.getAttributes("tableCell").backgroundColor || "primary", l = ua(a, i);
  return /* @__PURE__ */ _(ve, { sx: t, className: e, children: [
    /* @__PURE__ */ _(
      Ut,
      {
        className: Ce("rte-editor-menu-item", "rte-rounded"),
        onClick: (c) => o(c.currentTarget),
        children: [
          /* @__PURE__ */ p(Yo, { primary: s("tableStyle.cellFillColor"), sx: { flex: 1 } }),
          /* @__PURE__ */ p(
            fn,
            {
              onClick: (c) => o(c.currentTarget),
              className: Ce(
                "rte-sidebar-table-cell-current-value",
                "rte-sidebar-table-cell-current-value-squared",
                a === "primary" && "color-wheel-outlined"
              ),
              sx: {
                borderColor: a != "primary" ? l : "transparent",
                outlineWidth: l === i.palette.common.white ? 1 : void 0
              },
              children: /* @__PURE__ */ p(ve, { className: "rte-sidebar-table-cell-color-current-value-background", children: /* @__PURE__ */ p(
                ve,
                {
                  className: "rte-sidebar-table-cell-color-current-value-colored-view",
                  sx: {
                    backgroundColor: a != "primary" ? pn(l, 0.05) : void 0
                  },
                  children: /* @__PURE__ */ p(
                    Ha,
                    {
                      sx: {
                        color: a != "primary" ? a : i.palette.text.primary
                      }
                    }
                  )
                }
              ) })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ p(
      xn,
      {
        open: r != null,
        anchorEl: r,
        onClose: () => o(void 0),
        children: /* @__PURE__ */ p(me, { container: !0, spacing: 1, className: "rte-sidebar-table-cell-fill-color-picker", children: Si.map((c, u) => {
          const f = ua(c, i);
          return /* @__PURE__ */ p(me, { size: { xs: 2 }, children: /* @__PURE__ */ p(
            fn,
            {
              className: "rte-sidebar-table-cell-fill-color-picker-value",
              sx: {
                backgroundColor: f,
                borderColor: c != "primary" ? pn(f, 0.6) : i.palette.divider
              },
              onClick: () => n == null ? void 0 : n.chain().focus().setCellAttribute("backgroundColor", c ?? "primary").run(),
              children: a === c && /* @__PURE__ */ p(
                Pa,
                {
                  sx: {
                    color: c != "primary" ? i.palette.getContrastText(f) : i.palette.text.secondary
                  }
                }
              )
            }
          ) }, c ?? u);
        }) })
      }
    )
  ] });
};
function ua(t, e) {
  return t === "primary" ? "transparent" : t === "secondary" ? e.palette.text.primary : or(t, e.palette.mode === "dark");
}
const da = ({
  sx: t,
  className: e,
  icon: n,
  title: r,
  isOn: o,
  onValueChange: i
}) => {
  const s = ut();
  return /* @__PURE__ */ _(He, { direction: "row", spacing: 1, alignItems: "center", sx: t, className: e, children: [
    n({ color: s.palette.text.secondary }),
    /* @__PURE__ */ p(it, { sx: { flex: 1 }, variant: "body2", children: r }),
    /* @__PURE__ */ p(uu, { value: o, checked: o, onChange: i })
  ] });
}, fa = ({
  sx: t,
  className: e,
  icon: n,
  title: r,
  onDecrease: o,
  onIncrease: i,
  count: s
}) => {
  const a = ut();
  return /* @__PURE__ */ _(He, { direction: "row", spacing: 1, alignItems: "center", sx: t, className: e, children: [
    n({ color: a.palette.text.secondary }),
    /* @__PURE__ */ p(it, { sx: { flex: 1 }, variant: "body2", children: r }),
    /* @__PURE__ */ p(
      ve,
      {
        className: "rte-sidebar-table-size-count",
        sx: {
          borderRadius: 1,
          display: "flex",
          px: 1.5,
          py: "2px",
          backgroundColor: pn(a.palette.divider, 0.02)
        },
        children: /* @__PURE__ */ p(it, { variant: "caption", children: s })
      }
    ),
    /* @__PURE__ */ _(va, { variant: "outlined", children: [
      /* @__PURE__ */ p(St, { size: "small", disabled: s <= 1, onClick: o, children: /* @__PURE__ */ p(hd, { fontSize: "small" }) }),
      /* @__PURE__ */ p(St, { size: "small", onClick: i, children: /* @__PURE__ */ p(ja, { fontSize: "small" }) })
    ] })
  ] });
}, uS = ({ sx: t, className: e }) => {
  const n = te(), [r, o] = ke(), i = ut(), { t: s } = ee(), a = n.getAttributes("tableCell").color || "primary", l = dS(a, i);
  function c(u) {
    n.chain().focus().setCellAttribute("color", u).run();
  }
  return /* @__PURE__ */ _(ve, { sx: t, className: e, children: [
    /* @__PURE__ */ _(
      Ut,
      {
        className: Ce("rte-editor-menu-item", "rte-rounded"),
        onClick: (u) => o(u.currentTarget),
        children: [
          /* @__PURE__ */ p(Yo, { primary: s("tableStyle.textColor"), sx: { flex: 1 } }),
          /* @__PURE__ */ p(
            fn,
            {
              onClick: (u) => o(u.currentTarget),
              className: Ce(
                "rte-sidebar-table-cell-current-value",
                "rte-sidebar-table-cell-current-value-rounded",
                a === "primary" && "color-wheel-outlined"
              ),
              sx: {
                borderColor: a != "primary" ? l : "transparent",
                outlineWidth: l === i.palette.common.white ? 1 : void 0
              },
              children: /* @__PURE__ */ p(ve, { className: "rte-sidebar-table-cell-color-current-value-background", children: /* @__PURE__ */ p(
                ve,
                {
                  className: "rte-sidebar-table-cell-color-current-value-colored-view",
                  sx: {
                    backgroundColor: a != "primary" ? pn(l, 0.05) : void 0
                  },
                  children: /* @__PURE__ */ p(
                    Ha,
                    {
                      sx: {
                        color: l === i.palette.common.white ? i.palette.mode === "light" ? i.palette.divider : i.palette.common.white : l
                      }
                    }
                  )
                }
              ) })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ p(
      xn,
      {
        open: r != null,
        anchorEl: r,
        onClose: () => o(void 0),
        children: /* @__PURE__ */ p(xi, { value: a, onValueChanged: c })
      }
    )
  ] });
};
function dS(t, e) {
  return t === "primary" ? e.palette.text.primary : t === "secondary" ? e.palette.mode === "light" ? e.palette.common.white : e.palette.common.black : An(t, e.palette.mode === "dark");
}
const Yc = ({ sx: t, className: e, isFloating: n }) => {
  const r = te(), { t: o } = ee();
  function i(f) {
    return r != null && r.isActive("customTable") && fS(f, Nn(r.state), Fd(r.state.schema));
  }
  const s = r.getAttributes("customTable"), { rowCount: a, colCount: l } = s, c = i("row"), u = i("column");
  return /* @__PURE__ */ _(ao, { sx: t, className: e, title: o("tableStyle.panelTitle"), isFloating: n, children: [
    /* @__PURE__ */ p(Ge, { children: /* @__PURE__ */ _(He, { gap: 0.5, children: [
      /* @__PURE__ */ p(
        fa,
        {
          title: o("tableStyle.numberOfRows"),
          icon: (f) => /* @__PURE__ */ p(gd, { sx: f }),
          count: a,
          onDecrease: () => r.chain().focus().deleteRowAtEnd().run(),
          onIncrease: () => r.chain().focus().insertRowAtEnd().run()
        }
      ),
      /* @__PURE__ */ p(
        fa,
        {
          title: o("tableStyle.numberOfColumns"),
          icon: (f) => /* @__PURE__ */ p(yd, { sx: f }),
          count: l,
          onDecrease: () => r.chain().focus().deleteColumnAtEnd().run(),
          onIncrease: () => r.chain().focus().insertColumnAtEnd().run()
        }
      )
    ] }) }),
    /* @__PURE__ */ _(Ge, { title: o("tableStyle.includeHeaderSection"), children: [
      /* @__PURE__ */ p(
        da,
        {
          title: o("tableStyle.includeRowHeader"),
          isOn: c,
          icon: (f) => /* @__PURE__ */ p(bd, { sx: f }),
          onValueChange: () => r.chain().focus().toggleHeaderRow().run()
        }
      ),
      /* @__PURE__ */ p(
        da,
        {
          title: o("tableStyle.includeColumnHeader"),
          isOn: u,
          icon: (f) => /* @__PURE__ */ p(vd, { sx: f }),
          onValueChange: () => r.chain().focus().toggleHeaderColumn().run()
        }
      )
    ] }),
    /* @__PURE__ */ p(Kc, { showTitle: !0, showIndentationOptions: !1 }),
    /* @__PURE__ */ p(Ge, { title: o("tableStyle.textStyleSection"), children: /* @__PURE__ */ _(He, { spacing: 0.5, children: [
      /* @__PURE__ */ p(cS, {}),
      /* @__PURE__ */ p(uS, {})
    ] }) })
  ] });
};
function fS(t, e, n) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let o = 0; o < r.length; o++) {
    const i = e.table.nodeAt(r[o] ?? -1);
    if (i && i.type !== n.header_cell)
      return !1;
  }
  return !0;
}
const pS = () => {
  const t = te(), { t: e } = ee(), n = Dc(t);
  return /* @__PURE__ */ _(Wn, { children: [
    /* @__PURE__ */ p(Ge, { title: e("textContentTypeTitlesSection"), children: /* @__PURE__ */ _(me, { container: !0, spacing: 1, children: [
      /* @__PURE__ */ p(me, { size: { xs: 4 }, children: /* @__PURE__ */ p(
        Lt,
        {
          sx: { fontWeight: "900" },
          titleKey: "heading1TextStyle",
          isActive: n === "title",
          onClick: () => sn(t, "title")
        }
      ) }),
      /* @__PURE__ */ p(me, { size: { xs: 4 }, children: /* @__PURE__ */ p(
        Lt,
        {
          sx: { fontWeight: "700" },
          titleKey: "heading2TextStyle",
          isActive: n === "subtitle",
          onClick: () => sn(t, "subtitle")
        }
      ) }),
      /* @__PURE__ */ p(me, { size: { xs: 4 }, children: /* @__PURE__ */ p(
        Lt,
        {
          sx: { fontWeight: "500" },
          titleKey: "heading3TextStyle",
          isActive: n === "heading",
          onClick: () => sn(t, "heading")
        }
      ) })
    ] }) }),
    /* @__PURE__ */ p(Ge, { title: e("textContentTypeContentSection"), children: /* @__PURE__ */ _(me, { container: !0, spacing: 1, children: [
      /* @__PURE__ */ p(me, { size: { xs: 6 }, children: /* @__PURE__ */ p(
        Lt,
        {
          titleKey: "body",
          isActive: n === "body",
          onClick: () => sn(t, "body")
        }
      ) }),
      /* @__PURE__ */ p(me, { size: { xs: 6 }, children: /* @__PURE__ */ p(
        Lt,
        {
          titleKey: "caption",
          isActive: n === "caption",
          onClick: () => sn(t, "caption"),
          sx: { fontSize: "0.8rem", height: "100%" }
        }
      ) })
    ] }) })
  ] });
}, mS = () => {
  const t = te(), { t: e } = ee();
  return /* @__PURE__ */ p(Ge, { title: e("textDecorations"), children: /* @__PURE__ */ _(me, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ p(me, { size: { xs: 6 }, children: /* @__PURE__ */ p(
      Lt,
      {
        titleKey: "quoteTextStyle",
        isActive: t.isActive("blockquote"),
        onClick: () => t.chain().focus().toggleBlockquote().run(),
        disabled: !t.can().chain().focus().toggleBlockquote().run(),
        icon: /* @__PURE__ */ p(ve, { className: "rte-sidebar-quote-option-icon" })
      }
    ) }),
    /* @__PURE__ */ p(me, { size: { xs: 6 }, children: /* @__PURE__ */ p(
      Lt,
      {
        titleKey: "codeBlockTextStyle",
        isActive: t.isActive("codeBlock"),
        onClick: () => t.chain().focus().toggleCodeBlock().run(),
        disabled: !t.can().chain().focus().toggleCodeBlock().run(),
        icon: /* @__PURE__ */ p(wd, {})
      }
    ) })
  ] }) });
}, hS = () => {
  const t = te(), { t: e } = ee(), n = t.isActive("customLink"), r = (n ? t.getAttributes("customLink").color : t.getAttributes("textStyle").color) ?? "primary";
  function o(i) {
    n ? t.chain().focus().extendMarkRange("customLink").setLinkColor(i).run() : t.chain().focus().setColor(i).run();
  }
  return /* @__PURE__ */ p(Ge, { title: e("textColor"), children: /* @__PURE__ */ p(xi, { value: r, onValueChanged: o }) });
}, Gc = ({ sx: t, className: e, isFloating: n }) => {
  const { t: r } = ee();
  return /* @__PURE__ */ _(ao, { sx: t, className: e, title: r("textStylePanelTitle"), isFloating: n, children: [
    /* @__PURE__ */ p(pS, {}),
    /* @__PURE__ */ p(Kc, { showTitle: !1 }),
    /* @__PURE__ */ p(mS, {}),
    /* @__PURE__ */ p(hS, {})
  ] });
}, gS = ({ sx: t, activeTab: e, setActiveTab: n, className: r, expand: o }) => {
  const i = te(), s = {
    hidden: {
      scaleX: 0.7,
      opacity: 0,
      x: "15%",
      transition: {
        type: "easeInOut",
        duration: 0.1
      }
    },
    show: {
      scaleX: 1,
      opacity: 1,
      x: 0,
      transition: {
        type: "easeInOut",
        duration: 0.1
      }
    }
  }, a = i.isActive("customTable");
  return /* @__PURE__ */ _(He, { direction: "row", alignItems: "flex-start", sx: t, className: Ce(r, "rte-sidebar-compact"), children: [
    /* @__PURE__ */ p(ti, { mode: "sync", children: /* @__PURE__ */ _(
      ni.div,
      {
        className: "rte-sidebar-compact-panel-container",
        variants: s,
        initial: "hidden",
        animate: "show",
        exit: "hidden",
        children: [
          e === "insert" && /* @__PURE__ */ p(Uc, { isFloating: !0 }),
          e === "text-style" && !a && /* @__PURE__ */ p(Gc, { isFloating: !0 }),
          e === "text-style" && a && /* @__PURE__ */ p(Yc, { isFloating: !0 }),
          e === "commands" && /* @__PURE__ */ p(Hc, { isFloating: !0 })
        ]
      },
      e
    ) }),
    /* @__PURE__ */ p(er, { className: "rte-sidebar-compact-tabs-container-background", children: /* @__PURE__ */ _(He, { className: Ce("rte-sidebar-compact-tabs-container", e != null && "active"), direction: "column", children: [
      Wc.map((l) => /* @__PURE__ */ p(
        ca,
        {
          isSelected: e === l,
          icon: qc(l),
          onClick: () => n(e !== l ? l : void 0)
        },
        l
      )),
      o != null && /* @__PURE__ */ p(
        ca,
        {
          isSelected: !1,
          icon: /* @__PURE__ */ p(Cd, { fontSize: "small" }),
          onClick: () => o()
        }
      )
    ] }) })
  ] });
}, yS = ({ sx: t, className: e, activeTab: n, setActiveTab: r, collapse: o }) => {
  const i = te(), { t: s } = ee(), a = i.isActive("customTable"), l = {
    hidden: {
      opacity: 0,
      transition: {
        type: "easeInOut",
        duration: 0.15
      }
    },
    show: {
      opacity: 1,
      transition: {
        type: "easeInOut",
        duration: 0.15
      }
    }
  };
  return /* @__PURE__ */ p(er, { square: !0, sx: t, className: Ce(e, "rte-sidebar-expanded"), children: /* @__PURE__ */ _(ve, { className: "rte-sidebar-expanded-container", children: [
    /* @__PURE__ */ p(ve, { children: /* @__PURE__ */ p(
      du,
      {
        value: n,
        onChange: (c, u) => r(u),
        variant: "fullWidth",
        className: "rte-sidebar-expanded-tab",
        children: Wc.map((c) => /* @__PURE__ */ p(fu, { value: c, icon: qc(c) }, c))
      }
    ) }),
    /* @__PURE__ */ p(Et, {}),
    /* @__PURE__ */ p(ve, { className: "rte-sidebar-expanded-content-container", children: /* @__PURE__ */ p(ti, { mode: "sync", children: /* @__PURE__ */ _(
      ni.div,
      {
        className: "rte-sidebar-expanded-content",
        variants: l,
        initial: "hidden",
        animate: "show",
        exit: "hidden",
        children: [
          n === "insert" && /* @__PURE__ */ p(Uc, { isFloating: !1 }),
          n === "text-style" && !a && /* @__PURE__ */ p(Gc, { isFloating: !1 }),
          n === "text-style" && a && /* @__PURE__ */ p(Yc, { isFloating: !1 }),
          n === "commands" && /* @__PURE__ */ p(Hc, { isFloating: !1 })
        ]
      },
      n
    ) }) }),
    /* @__PURE__ */ p(
      St,
      {
        className: "rte-sidebar-expanded-collapse-button",
        endIcon: /* @__PURE__ */ p(Sd, { fontSize: "small" }),
        onClick: () => o(),
        size: "small",
        children: s("collapseSidebar")
      }
    )
  ] }) });
}, bS = ({ className: t, isCompact: e, setIsCompact: n }) => {
  const [r, o] = ke("insert"), [i, s] = ke(void 0), a = {
    hidden: {
      scaleX: 0.7,
      opacity: 0,
      x: "15%",
      transition: {
        type: "easeInOut",
        duration: 0.1
      }
    },
    show: {
      scaleX: 1,
      opacity: 1,
      x: 0,
      transition: {
        type: "easeInOut",
        duration: 0.1
      }
    }
  };
  return /* @__PURE__ */ p(ti, { mode: "sync", children: /* @__PURE__ */ p(
    ni.div,
    {
      className: t,
      variants: a,
      initial: "hidden",
      animate: "show",
      exit: "hidden",
      children: e ? /* @__PURE__ */ p(
        gS,
        {
          activeTab: i,
          setActiveTab: (l) => {
            s(l), o(l ?? "insert");
          },
          expand: n != null ? () => n(!1) : void 0
        }
      ) : /* @__PURE__ */ p(
        yS,
        {
          activeTab: r,
          setActiveTab: (l) => {
            o(l), i != null && s(l);
          },
          collapse: () => n == null ? void 0 : n(!0)
        }
      )
    },
    e ? "compact" : "sidebar"
  ) });
}, vS = ({
  sx: t = [],
  ref: e,
  className: n,
  id: r,
  content: o,
  onChange: i,
  options: s = {},
  autofocus: a = !1,
  locale: l,
  contentSx: c,
  disabled: u = !1,
  onFocus: f,
  onBlur: m,
  onSelectionChange: g,
  customEventHandler: b
}) => {
  const {
    placeholder: d,
    transloaditKey: v = "",
    isReadOnly: C = !1,
    sidebarMode: R = "both",
    textSize: E = "regular",
    canSelectText: y = !0,
    supportsBubbleMenu: w = !0,
    fileHostBasename: x
  } = s, L = ut(), D = MC({ isReadOnly: C || u || !y, placeholder: d }), [F, h] = ke(!0), O = Ur(new Fc(v, x));
  NC();
  const I = Vt.createInstance();
  I.use($a).init({
    fallbackLng: "en",
    interpolation: { escapeValue: !0 },
    resources: {
      en: { translation: bl },
      fr: { translation: vl }
    }
  });
  const P = vu(
    {
      extensions: D,
      content: o,
      editable: !C && !u && y,
      autofocus: a,
      editorProps: {
        attributes: {
          class: "rte-editor-content"
        }
      },
      onUpdate: (z) => {
        i == null || i(z.editor.getHTML()), g == null || g(la(z.editor));
      },
      onFocus: f,
      onBlur: m,
      onSelectionUpdate: g != null ? ({ editor: z }) => g(la(z)) : void 0
    },
    [C, u, y, d, a]
  );
  return Je(() => {
    Ng(l);
  }, [l]), Oa(e, () => ({
    focus: () => P == null ? void 0 : P.commands.focus(),
    blur: () => P == null ? void 0 : P.commands.blur(),
    setContent: (z) => P == null ? void 0 : P.commands.setContent(z)
  })), PC(P, r), /* @__PURE__ */ p(
    ve,
    {
      sx: t,
      className: Ce(
        "rte-editor-root",
        n,
        L.palette.mode === "dark" && "dark-mode",
        E === "small" && "rte-editor-text-small-size",
        !y && "rte-user-selection-disabled",
        u && "rte-disabled"
      ),
      children: /* @__PURE__ */ p(ve, { className: "rte-auto-size-container", children: /* @__PURE__ */ p(ku, { disableWidth: !1, disableHeight: !0, className: "rte-auto-size", children: ({ width: z }) => /* @__PURE__ */ p(Tu, { i18n: I, children: /* @__PURE__ */ p(wu.Provider, { value: { editor: P }, children: /* @__PURE__ */ _(Bc.Provider, { value: O.current, children: [
        /* @__PURE__ */ _(
          ve,
          {
            sx: { width: z, height: "100%" },
            className: Ce("rte-editor-main-container", wS(z)),
            tabIndex: -1,
            onClick: () => P == null ? void 0 : P.commands.focus(),
            children: [
              /* @__PURE__ */ p(ve, { className: "rte-editor-container", children: /* @__PURE__ */ p(ve, { className: "rte-editor-container-content", sx: c, children: /* @__PURE__ */ p(Cu, { editor: P }) }) }),
              !C && !u && R !== "none" && y && /* @__PURE__ */ p(
                bS,
                {
                  isCompact: R === "compact" || F,
                  setIsCompact: R === "both" ? h : void 0,
                  className: F ? "rte-sidebar-compact-position" : void 0
                }
              )
            ]
          }
        ),
        !C && /* @__PURE__ */ _(Wn, { children: [
          w && /* @__PURE__ */ _(Wn, { children: [
            /* @__PURE__ */ p(nS, {}),
            /* @__PURE__ */ p(oS, {})
          ] }),
          /* @__PURE__ */ p(aS, { customEventHandler: b }),
          /* @__PURE__ */ p(lS, {})
        ] })
      ] }) }) }) }) })
    }
  );
};
vS.displayName = "RichTextEditor";
function wS(t) {
  return t < 600 ? "rte-width-xs" : t < 900 ? "rte-width-sm" : t < 1300 ? "rte-width-md" : t < 1536 ? "rte-width-lg" : "rte-width-xl";
}
export {
  vS as RichTextEditor,
  la as getRichTextEditorSelectionStateFromEditor
};
//# sourceMappingURL=index.es.js.map
